import { template } from 'lodash'
import { knowledge_center } from '../../../components/NavNewDesign/images'
import { download } from '../../api/library'

export default {
  quest: {
    quest_title: 'Create a New Quest',
    quest_hunt: 'Quest',
    quest_filter_title: 'Quest',
    no_permission_to_view_this_quest: 'You do not have permission to view this quest',
    publish_quest: 'Publish Quest',
    quest: 'Quest',
    users_emails: "Choose specific user's email.",
    description_specifiction_email:
      'Please enter 1 email address per line to share this with multiple specific users.',
    publish_success: 'Published successfully',
    publish_error: 'Failed to publish',
    please_agree_terms: 'Please agree to the terms and conditions',
    not_complete: 'Not complete',
    emails_validation_error: 'Some emails are invalid. Please check and try again.'
  },
  reminder_trigger: {
    start_date: 'Start Date',
    expiry_date: 'Expiry Date',
    start_date_required: 'Start Date is required!',
    expiry_date_required: 'Expiry Date is required!',
    select_start_date: 'Select start date',
    select_expiry_date: 'Select expiry date',
    title: 'Reminder Triggers & Frequency',
    expand_all: 'Expand All',
    recurrence_by_date: 'Recurrence by Date',
    mandatory_course: 'Mandatory Course',
    by_failed_attempts: 'By failed attempts',
    every: 'Every',
    due_date: 'Due Date',
    select_interval: 'Select interval',
    select_duration: 'Select duration',
    select_date: 'Select date',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    tooltip_start_date: 'Start date',
    tooltip_start_date_description: "This rule uses the course's global Start Date set on the left.",
  },
  tour: {
    take_a_tour: 'Take a Tour',
    // Add Content Tour
    add_content_generation_name: 'Expand Your Content',
    add_content_generation_desc:
      'Intelligently extend your course with complementary content that enriches the learning experience.',
    add_content_generation_step_0_title: 'Access Content Generation Tools',
    add_content_generation_step_0_content: "Click to expand the content generation menu and unlock Sharelook's AI-powered authoring capabilities.",
    add_content_generation_step_1_title: 'Generate Additional Content',
    add_content_generation_step_1_content_prefix: 'Select ',
    add_content_generation_step_1_content_bold: 'Add Content',
    add_content_generation_step_1_content_suffix: " to expand your course with supporting materials. Sharelook's AI analyzes your existing content to generate relevant, high-quality additions.",
    add_content_generation_step_2_title: 'Select Reference Material',
    add_content_generation_step_2_content:
      'Choose the pages that will serve as the foundation for new content. The AI will identify opportunities to deepen understanding and fill knowledge gaps.',
    add_content_generation_step_3_title: 'Generate Complementary Content',
    add_content_generation_step_3_content_prefix: 'Click ',
    add_content_generation_step_3_content_bold: 'Add Content',
    add_content_generation_step_3_content_suffix: ' to initiate the expansion process. Sharelook will produce contextually relevant material that seamlessly integrates with your existing course.',

    // Interactive Tour
    interactive_generation_name: 'Interactive Simulations',
    interactive_generation_desc:
      'Transform your static content into immersive, hands-on learning experiences with AI-powered interactive simulations.',
    interactive_generation_step_0_title: 'Access Content Generation Tools',
    interactive_generation_step_0_content: "Click to expand the content generation menu and unlock Sharelook's AI-powered authoring capabilities.",
    interactive_generation_step_1_title: 'Create Interactive Simulations',
    interactive_generation_step_1_content_prefix: 'Select ',
    interactive_generation_step_1_content_bold: 'Interactive Simulation',
    interactive_generation_step_1_content_suffix: " to transform your course pages into engaging, scenario-based learning experiences. Sharelook's AI will generate realistic simulations that drive active learner participation.",
    interactive_generation_step_2_title: 'Choose Your Source Content',
    interactive_generation_step_2_content:
      "Select the pages from your course that you'd like to enhance with interactive elements. The AI will analyze your content and create contextually relevant simulations.",
    interactive_generation_step_3_title: 'Generate Your Simulation',
    interactive_generation_step_3_content_prefix: 'Click ',
    interactive_generation_step_3_content_bold: 'Interactive Lesson',
    interactive_generation_step_3_content_suffix: ' to initiate the AI generation process. Sharelook will craft an immersive simulation tailored to your learning objectives within seconds.',

    // Background Color Tour
    background_color_settings_name: 'Background Color Customization',
    background_color_settings_desc:
      'Apply branded colors and create visual consistency across your learning content.',
    background_color_settings_step_0_title: 'Background Color Settings',
    background_color_settings_step_0_content:
      'This panel allows you to customize the background color of your page. Select colors that align with your brand and enhance the learning experience.',
    background_color_settings_step_1_title: 'Select Your Color',
    background_color_settings_step_1_content:
      'Choose from the palette or enter a specific hex code to match your brand guidelines. Consistent color usage reinforces brand identity.',
    background_color_settings_step_2_title: 'Apply Your Selection',
    background_color_settings_step_2_content:
      'Confirm to apply the background color to your page. Your changes will be immediately visible in the editor.',

    // Background Image Tour
    background_image_settings_name: 'Background Image Customization',
    background_image_settings_desc:
      'Create visually stunning pages with professional background imagery and precise opacity control.',
    background_image_settings_step_0_title: 'Background Image Settings',
    background_image_settings_step_0_content:
      "This panel provides complete control over your page's background image. Create visually stunning pages with professional imagery and precise customization.",
    background_image_settings_step_1_title: 'Select Background Image',
    background_image_settings_step_1_content:
      'Choose from your media library or upload a new image. High-quality backgrounds create professional, engaging pages.',
    background_image_settings_step_2_title: 'Fine-Tune Opacity',
    background_image_settings_step_2_content:
      'Adjust transparency to ensure optimal readability of foreground content. Subtle backgrounds enhance without distracting.',
    background_image_settings_step_3_title: 'Remove Background',
    background_image_settings_step_3_content:
      'Clear the current background image to return to a clean canvas or apply a different visual treatment.',
    background_image_settings_step_4_title: 'Finalize Changes',
    background_image_settings_step_4_content:
      'Apply your background settings to update the page. Changes are saved and immediately visible to learners.',

    // Create Course Tour
    create_course_name: 'Course Creation Walkthrough',
    create_course_desc: 'Learn to build comprehensive, enterprise-grade learning programs with Sharelook.',
    create_course_step_0_title: 'Welcome to Course Builder',
    create_course_step_0_content: "Welcome to Sharelook's elite Course Builder. This workspace is designed to help you craft high-impact learning experiences. Let's take a quick tour of the essential tools at your disposal.",
    create_course_step_1_title: 'Core Configuration',
    create_course_step_1_content:
      'This configuration panel allows you to define the foundation of your course. Setting these attributes accurately ensures your content is organized, searchable, and professionally presented.',
    create_course_step_2_title: 'Compelling Title',
    create_course_step_2_content:
      'A great course starts with a powerful title. Aim for something clear and engaging that immediately signals the learning outcomes to your audience.',
    create_course_step_3_title: 'Professional Imagery',
    create_course_step_3_content:
      'Visuals matter. A professional cover image sets the tone and builds immediate credibility. Choose an image that resonates with your subject matter and inspires learners.',
    create_course_step_4_title: 'Curriculum Structure',
    create_course_step_4_content:
      'Your curriculum is the heart of the course. Here you can structure your lessons, add rich media, and design a journey that leads your learners from theory to mastery.',
    create_course_step_5_title: 'Publish Your Course',
    create_course_step_5_content: 'Ready to share your expertise? Once you\'ve finalized your content, use the Publish button to deploy your course. Sharelook handles the deployment, making it available across your organization instantly.',
    create_course_ai_step_title: 'AI Course Creation',
    create_course_ai_step_content: 'Click here to proceed to the next stage. Sharelook\'s AI will automatically generate relevant topics and lessons based on your course configuration, saving you time and effort.',

    // Create Lesson Tour
    create_lesson_name: 'Lesson Creation Walkthrough',
    create_lesson_desc: 'Master the fundamentals of creating professional, impactful lessons in Sharelook.',
    create_lesson_step_0_title: 'Lesson Builder',
    create_lesson_step_0_content: "Welcome to Sharelook's lesson builder—your workspace for crafting engaging, structured learning experiences. Let's walk through the essential elements of effective lesson design.",
    create_lesson_step_1_title: 'Define Your Lesson',
    create_lesson_step_1_content:
      "Start with a clear, descriptive title that captures the lesson's learning outcome. Effective titles set clear expectations and help learners navigate your course structure.",
    create_lesson_step_2_title: 'Visual Identity',
    create_lesson_step_2_content:
      'Upload a professional cover image that represents your lesson content. Quality visuals enhance learner engagement and make your content more memorable.',
    create_lesson_step_3_title: 'Build Your Content',
    create_lesson_step_3_content: 'Ready to add content? Click here to begin creating pages and building your lesson. Sharelook provides powerful tools to bring your vision to life.',

    // Infographics Tour
    infographics_generation_name: 'Visual Data Stories',
    infographics_generation_desc:
      'Convert complex information into visually compelling infographics that enhance understanding and retention.',
    infographics_generation_step_0_title: 'Access Content Generation Tools',
    infographics_generation_step_0_content: "Click to expand the content generation menu and unlock Sharelook's AI-powered authoring capabilities.",
    infographics_generation_step_1_title: 'Design Visual Content',
    infographics_generation_step_1_content_prefix: 'Select ',
    infographics_generation_step_1_content_bold: 'Infographics',
    infographics_generation_step_1_content_suffix: " to transform data and concepts into professional visual representations. Sharelook's AI identifies key information and organizes it for maximum visual impact.",
    infographics_generation_step_2_title: 'Select Content to Visualize',
    infographics_generation_step_2_content:
      'Choose the pages containing data or concepts you want to visualize. The AI will extract critical information and design an engaging infographic.',
    infographics_generation_step_3_title: 'Generate Infographic',
    infographics_generation_step_3_content_prefix: 'Click ',
    infographics_generation_step_3_content_bold: 'Generate Infographic',
    infographics_generation_step_3_content_suffix: ' to begin the visualization process. Sharelook will create a professional infographic that communicates your message clearly and effectively.',

    // Quiz Tour
    quiz_generation_name: 'Intelligent Assessments',
    quiz_generation_desc:
      'Generate adaptive quizzes that accurately measure comprehension and reinforce key concepts.',
    quiz_generation_step_0_title: 'Access Content Generation Tools',
    quiz_generation_step_0_content: "Click to expand the content generation menu and unlock Sharelook's AI-powered authoring capabilities.",
    quiz_generation_step_1_title: 'Create Smart Quizzes',
    quiz_generation_step_1_content_prefix: 'Select ',
    quiz_generation_step_1_content_bold: 'AI Quiz',
    quiz_generation_step_1_content_suffix: " to generate assessment questions that precisely target your learning objectives. Sharelook's AI creates varied, pedagogically sound questions that test true understanding.",
    quiz_generation_step_2_title: 'Define Assessment Scope',
    quiz_generation_step_2_content:
      'Select the pages containing the content you want to assess. The AI will analyze your material to generate contextually relevant questions.',
    quiz_generation_step_3_title: 'Generate Assessment',
    quiz_generation_step_3_content_prefix: 'Click ',
    quiz_generation_step_3_content_bold: 'Generate Quiz',
    quiz_generation_step_3_content_suffix: ' to launch the quiz builder. Sharelook will generate high-quality questions aligned with your content within moments.',

    // Scenario Tour
    scenario_generation_name: 'Scenario-Based Training',
    scenario_generation_desc:
      'Create realistic, decision-driven scenarios that prepare learners for real-world challenges.',
    scenario_generation_step_0_title: 'Access Content Generation Tools',
    scenario_generation_step_0_content: "Click to expand the content generation menu and unlock Sharelook's AI-powered authoring capabilities.",
    scenario_generation_step_1_title: 'Build Decision Scenarios',
    scenario_generation_step_1_content_prefix: 'Select ',
    scenario_generation_step_1_content_bold: 'Scenario',
    scenario_generation_step_1_content_suffix: " to create branching, consequence-based learning paths. Sharelook's AI generates authentic scenarios that develop critical thinking skills.",
    scenario_generation_step_2_title: 'Select Foundation Content',
    scenario_generation_step_2_content:
      'Choose the pages that contain the concepts for your scenario. The AI will build realistic decision points based on your content.',
    scenario_generation_step_3_title: 'Generate Your Scenario',
    scenario_generation_step_3_content_prefix: 'Click ',
    scenario_generation_step_3_content_bold: 'Generate Scenario',
    scenario_generation_step_3_content_suffix: ' to initiate scenario generation. Sharelook will craft an immersive, branching narrative tailored to your learning goals.',

    // Story Tour
    story_generation_name: 'Story-Based Learning',
    story_generation_desc:
      'Transform dry content into captivating narratives that drive emotional engagement and knowledge retention.',
    story_generation_step_0_title: 'Access Content Generation Tools',
    story_generation_step_0_content: "Click to expand the content generation menu and unlock Sharelook's AI-powered authoring capabilities.",
    story_generation_step_1_title: 'Create Narrative Content',
    story_generation_step_1_content_prefix: 'Select ',
    story_generation_step_1_content_bold: 'Story Writing',
    story_generation_step_1_content_suffix: " to transform your course material into compelling narratives. Sharelook's AI excels at weaving educational content into memorable, story-driven experiences.",
    story_generation_step_2_title: 'Choose Your Source Material',
    story_generation_step_2_content:
      "Select the pages containing the concepts you'd like to transform into a story. The AI will extract key learning points and build a narrative around them.",
    story_generation_step_3_title: 'Launch Story Builder',
    story_generation_step_3_content_prefix: 'Click ',
    story_generation_step_3_content_bold: 'Create Story',
    story_generation_step_3_content_suffix: " to access Sharelook's story generation interface, where you can shape your narrative with precision.",
    story_generation_step_4_title: 'Craft Your Narrative',
    story_generation_step_4_content:
      'Use our intelligent story builder to refine your narrative. Collaborate with the AI through conversational prompts or structured inputs to achieve your desired outcome.',
    story_generation_step_5_title: 'Generate Your Story',
    story_generation_step_5_content_prefix: 'Click ',
    story_generation_step_5_content_bold: 'Create Your First Story',
    story_generation_step_5_content_suffix: " to create your narrative. Sharelook's AI will craft an engaging story that seamlessly integrates your learning objectives.",

    // Toolbar Tour
    toolbar_guide_name: 'Content Authoring Tools',
    toolbar_guide_desc: "Master Sharelook's comprehensive toolkit for creating rich, multimedia learning experiences.",
    toolbar_guide_step_0_title: 'Precision Alignment',
    toolbar_guide_step_0_content:
      'Enable the grid overlay to ensure pixel-perfect alignment of elements. Professional layouts start with precise positioning.',
    toolbar_guide_step_1_title: 'Text Content',
    toolbar_guide_step_1_content:
      'Add formatted text blocks to convey concepts and instructions. Includes full rich-text editing capabilities, hyperlinks, and typography controls.',
    toolbar_guide_step_2_title: 'Visual Media',
    toolbar_guide_step_2_content:
      'Incorporate images to enhance comprehension and engagement. Upload from your library or device to add visual context to your lessons.',
    toolbar_guide_step_3_title: 'Video Integration',
    toolbar_guide_step_3_content:
      'Embed videos from YouTube, Vimeo, or your own uploads. Video content drives engagement and supports diverse learning preferences.',
    toolbar_guide_step_4_title: 'Audio Elements',
    toolbar_guide_step_4_content:
      'Add voiceovers, podcasts, or ambient audio to create immersive learning environments. Audio supports accessibility and multisensory learning.',
    toolbar_guide_step_5_title: 'Augmented Reality',
    toolbar_guide_step_5_content:
      'Integrate AR experiences to bring concepts to life. Create cutting-edge, immersive learning that bridges digital and physical worlds.',
    toolbar_guide_step_6_title: 'Knowledge Checks',
    toolbar_guide_step_6_content:
      'Embed interactive quizzes to validate learning and reinforce key concepts. Track learner progress and identify knowledge gaps.',
    toolbar_guide_step_7_title: 'Interactive Annotations',
    toolbar_guide_step_7_content:
      'Layer interactive annotations on images and media. Create clickable hotspots that reveal additional information and drive exploration.',
    toolbar_guide_step_8_title: 'Page Styling',
    toolbar_guide_step_8_content:
      'Customize page backgrounds to match your brand or create visual hierarchy. Professional design elevates content credibility.',
    toolbar_guide_step_9_title: 'Learner Preview',
    toolbar_guide_step_9_content:
      'Experience your course exactly as learners will see it. Preview mode ensures quality control before publication.',

    // World Scenario Tour
    world_scenario_generation_name: 'Real-World Applications',
    world_scenario_generation_desc:
      'Bridge theory and practice with authentic workplace scenarios that build job-ready skills.',
    world_scenario_generation_step_0_title: 'Access Content Generation Tools',
    world_scenario_generation_step_0_content: "Click to expand the content generation menu and unlock Sharelook's AI-powered authoring capabilities.",
    world_scenario_generation_step_1_title: 'Create Workplace Scenarios',
    world_scenario_generation_step_1_content_prefix: 'Select ',
    world_scenario_generation_step_1_content_bold: 'Real World Scenario',
    world_scenario_generation_step_1_content_suffix: " to generate authentic, industry-specific situations. Sharelook's AI crafts scenarios that mirror actual workplace challenges and decision-making contexts.",
    world_scenario_generation_step_2_title: 'Select Contextual Content',
    world_scenario_generation_step_2_content:
      'Choose the pages containing the skills or concepts to apply. The AI will design realistic scenarios that demonstrate practical application in professional settings.',
    world_scenario_generation_step_3_title: 'Generate Real-World Scenario',
    world_scenario_generation_step_3_content_prefix: 'Click ',
    world_scenario_generation_step_3_content_bold: 'Generate Scenario',
    world_scenario_generation_step_3_content_suffix: ' to build your workplace scenario. Sharelook will create an authentic, industry-relevant experience that prepares learners for real challenges.',

    // Match Image Tour
    match_image_generation_name: 'Match Image Consistency',
    match_image_generation_desc:
      'Maintain visual harmony across your course pages by matching styles and characters.',
    match_image_generation_step_0_title: 'Access Content Generation Tools',
    match_image_generation_step_0_content: "Click to expand the content generation menu and unlock Sharelook's AI-powered authoring capabilities.",
    match_image_generation_step_1_title: 'Match Image Consistency',
    match_image_generation_step_1_content_prefix: 'Select ',
    match_image_generation_step_1_content_bold: 'Match Image',
    match_image_generation_step_1_content_suffix:
      ' to generate images that maintain consistent style and characters across your course.',
    match_image_generation_step_2_title: 'Select Reference Pages',
    match_image_generation_step_2_content:
      'Choose pages that you want to match image style with.',
    match_image_generation_step_3_title: 'Generate Matching Images',
    match_image_generation_step_3_content_prefix: 'Click ',
    match_image_generation_step_3_content_bold: 'Match Image',
    match_image_generation_step_3_content_suffix: ' to start generating images that perfectly blend with your selected references.',
    match_image_generation_step_4_title: 'Configure Generation',
    match_image_generation_step_4_content:
      'Adjust settings and reference images in this modal to fine-tune the final result.',
    match_image_generation_step_5_title: 'Start Generation',
    match_image_generation_step_5_content_prefix: 'Click ',
    match_image_generation_step_5_content_bold: 'Generate for Selected Pages',
    match_image_generation_step_5_content_suffix: ' to create your consistent images.'
  },
  aiusage: {
    title: 'AI Credit Usage',
    ai_credit_limit: "Ai Credit Limit",
    ai_credit_limit_required: "AI Credit Limit is required field.",
    ai_credit_limit_tip: "Must be between 1 to 300.",
    you_do_not_have_enough_ai_credits: "You do not have enough AI credits to generate",
    you_do_not_have_enough_ai_credit_to_use: "You do not have enough AI credits to use",
    error_fetching_ai_credit_status: "Error fetching AI credit status",
    cost_title: 'AI Cost Usage',
  },
  matchimage: {
    title: 'Match Image',
    consistency_subtitle: 'Maintain visual harmony across your course pages',
    consistency: 'Match Image Consistency',
    visual_style: 'Visual Style',
    select_style: 'Select a visual style...',
    reference_images: 'Reference Images',
    reference_images_tip:
      'These images provide a visual anchor for the AI, ensuring characters, colors, and styles remain consistent across multiple pages.',
    add: 'Add',
    max_9_reference_images:
      'The system uses the most relevant images from your selected pages as context to maintain visual focus and generation speed.',
    generation_progress: 'Generation Progress',
    no_images_generated_yet: 'No images generated yet',
    click_generate_to_start: 'Click Generate to start the multi-page process.',
    page: 'Page',
    completed: 'Completed',
    failed: 'Failed',
    generating: 'Generating...',
    generate_selected_pages: 'Generate for Selected Pages',
    apply_to_all_pages: 'Apply to All Pages',
    applied: 'Applied',
    cancel: 'Cancel',
    apply_success: 'Images applied successfully!',
    select_at_least_one_page: 'Please select at least one page to generate.',
    fetching_references: 'Fetching references...',
    fetching: 'Fetching...',
    no_references_found: 'No references found',
    loading_references: 'Loading reference images...',
    apply_confirmation_content:
      "This will replace existing images on the selected pages and add new ones where they don't exist. Do you want to proceed?",
    uploaded: 'Uploaded',
    style_photorealistic_label: 'Photorealistic',
    style_photorealistic_prompt:
      'Ultra-photorealistic image, DSLR quality, natural lighting, sharp focus, realistic textures, professional photography.',
    style_product_label: 'Commercial Product Shot',
    style_product_prompt:
      'High-end commercial product photography, studio lighting, clean background, sharp details, premium advertising style.',
    style_lifestyle_label: 'Lifestyle Photography',
    style_lifestyle_prompt:
      'Natural lifestyle photography, candid composition, soft daylight, real people, authentic modern commercial look.',
    style_corporate_portrait_label: 'Corporate Portrait',
    style_corporate_portrait_prompt:
      'Professional corporate portrait, neutral background, soft studio lighting, sharp facial details, business headshot style.',
    style_3d_modern_label: 'Modern 3D Illustration',
    style_3d_modern_prompt:
      'Modern 3D illustration, smooth geometry, soft global lighting, realistic materials, clean professional appearance.',
    style_3d_isometric_label: '3D Isometric Scene',
    style_3d_isometric_prompt:
      '3D isometric scene, clean geometry, balanced lighting, soft shadows, modern corporate illustration style.',
    style_flat_corporate_label: 'Flat Corporate Illustration',
    style_flat_corporate_prompt:
      'Clean flat illustration, corporate branding style, minimal shapes, balanced professional color palette.',
    style_ui_brand_label: 'Minimal UI / Brand Visual',
    style_ui_brand_prompt:
      'Minimal UI-style visual, white or light background, simple layout, modern tech branding, precise and clean.',
    style_editorial_label: 'Editorial Photography',
    style_editorial_prompt:
      'Editorial photography style, natural light, realistic environment, documentary feel, high-resolution detail.',
    style_technical_diagram_label: 'Technical Diagram',
    style_technical_diagram_prompt:
      'Clean technical diagram, precise lines, flat colors, professional infographic style, easy-to-understand layout.',
    style_abstract_corporate_label: 'Abstract Corporate Background',
    style_abstract_corporate_prompt:
      'Abstract corporate background, soft gradients, subtile geometric shapes, modern professional branding.',
    style_saas_marketing_label: 'SaaS Marketing Visual',
    style_saas_marketing_prompt:
      'Modern SaaS marketing visual, clean composition, bright professional colors, tech-focused and polished.',
    generating_image: 'Generating image...',
    ready: 'Ready',
    generating_page: 'Generating for page'
  },
  infographic: {
    title: 'Generate Infographic',
    custom_prompt: 'Custom Instructions (Optional)',
    prompt_placeholder:
      'e.g., Use blue colors, include charts, focus on statistics...',
    generating: 'Generating infographic...',
    generated: 'Infographic generated successfully!',
    generation_failed: 'Failed to generate infographic',
    no_content: 'No content available to generate infographic',
    no_image: 'No infographic to apply',
    empty_state: 'Click Generate to create your infographic',
    generate: 'Generate Infographic',
    regenerate: 'Regenerate',
    apply_question: 'How would you like to use this infographic?',
    replace_option: 'Replace existing image',
    add_option: 'Add as new image',
    replace_success: 'Infographic replaced successfully!',
    add_success: 'Infographic added successfully!',
    newPage_success: 'New page created with infographic successfully!',
    page_content: 'Page Content',
    generated_infographic: 'Generated Infographic',
    title_label: 'Title',
    text_label: 'Text Content',
    aspect_ratio: 'Aspect Ratio',
    replace_the_existing_image_on_the_page:
      'Replace the existing image on the page with this infographic',
    add_this_infographic: 'Add this infographic as a new element on the page',
    square: '1:1 (Square)',
    portrait: '2:3 (Portrait)',
    landscape: '3:2 (Landscape)',
    three_four_Portrait: '3:4 (Portrait)',
    four_three_landscape: '4:3 (Landscape)',
    four_five_portrait: '4:5 (Portrait)',
    four_five_landscape: '5:4 (Landscape)',
    mobile_portrait: '9:16 (Mobile Portrait)',
    widescreen: '16:9 (Widescreen)',
    ultrawide: '21:9 (Ultrawide)',
    replace_image: 'Replace Image',
    replace_existing_images_on_selected_pages:
      'Replace existing image on selected page',
    add_to_pages: 'Add to Page',
    add_image_to_selected_pages: 'Add image to selected page',
    create_new_page: 'Create New Page',
    create_page_with_infographic_after_last_selected:
      'Create a new page with this infographic after the selected slide with the highest page order.',
    no_page_selected: 'No page selected. Please select at least one page.',
    pages_selected: '{{count}} page(s) selected',
    content_from_selected_pages:
      'Content from all selected pages will be used to generate the infographic.',
    select_pages_to_apply: 'Select pages to apply:',
    page_number: 'Page {{number}}',
    preview: 'Preview',
    select_page_to_apply: 'Select a page to apply:',
    select_image_to_replace: 'Select Image to Replace',
    multiple_images_found:
      'This page has multiple images. Please select which image you want to replace:',
    image_number: 'Image {{number}}',
    instructions_required: 'Required',
    instructions_required_hint:
      'Instructions are required when no page text content is available.'
  },
  helplist: {
    // MISC
    main_categories: 'Main Categories',
    my_workshop: 'My Workshop',
    basic_course_controls: 'Basic Course Controls',
    scorm_courses: 'SCORM Courses',
    user_management: 'User Management',
    virtual_coach_title: 'Virtual Coach',
    sharelook_trivia: 'Sharelook Trivia',
    leaderboard_title: 'Sharelook Leaderboard',
    live_events: 'Live Events',
    podcasts_music_story: 'Podcasts, Music, and Story',
    whats_new: "What's New",
    whats_new_sharelook: "What's new at ShareLook",
    whats_new_desc:
      'Did you know that creating a storytelling-style learning experience is easy to do in a short time and inexpensive? You should combine the ShareLook course builder with your respective talents. Ask us how.',
    no_video_found: 'No videos found matching',
    uploaded_on: 'Uploaded on',
    no_video_available: 'No new videos available at this time.',
    no_videos_available: 'No videos available',
    user_view: 'User View',
    admin_view: 'Admin View',
    welcome: 'Welcome to ShareLook Help Center',
    video_filter:
      'Select a video from the left navigation to get started, or use the search to find specific content.',

    // HELP CENTER
    sharelook: 'What is Sharelook',
    sharelook_desc: 'Introduction to Sharelook and its features',

    course_summary: 'Course Creation Summary',
    course_summary_desc: 'Overview and summary of the course creation process',

    ai_course_creation: 'Full Process - AI Course Creation',
    ai_course_creation_desc: 'Learn how to create a course using AI',

    scenario_based_assessment:
      'Full Process - Scenario-based Assessment (Metamaze) Creation',
    scenario_based_assessment_desc:
      'Learn how to create a scenario-based assessment using AI',

    skill_leaderboard_creation:
      'Full Process - Skill Journey and Leaderboard Creation',
    skill_leaderboard_creation_desc:
      'Learn how to create a skill journey and leaderboard using AI',

    skill_journey: 'What is a Skill Journey',
    skill_journey_desc:
      'Understand what a Skill Journey is and how it helps learners',

    metamaze: 'What is a Metamaze',
    metamaze_desc:
      'Introduction to Metamaze and its role in scenario-based learning',

    share_shorts: 'Sharelook Share Shorts',
    share_shorts_desc:
      'Overview of Share Shorts and how to use them effectively',

    // TRAINING
    view_channel: 'View Video Channel',
    view_channel_desc:
      'Learn how to view and explore content in a video channel',

    take_course: 'How to take a course - Learner',
    take_course_desc: 'Understand how learners can take and navigate a course',

    take_metamaze: 'How to take a Metamaze',
    take_metamaze_desc:
      'Learn how learners can take part in a Metamaze scenario-based learning module',

    take_skill_journey: 'How to take a Skill Journey',
    take_skill_journey_desc:
      'Learn how to start and complete a skill journey as a learner',

    listen_podcast: 'How to Listen to Podcast',
    listen_podcast_desc: 'Learn how to listen to and navigate podcast content',

    // COURSES
    create_course: 'Adding a Certificate, Badge, and Course Cover to a Course',
    create_course_desc:
      'Create a course and customize it with badges, certificates, and cover images',

    create_course_simulation:
      'Simulation (Sandbox Environment) Within The Course',
    create_course_simulation_desc:
      'Step-by-step guide to creating simulations within a course',

    interactive_lesson_learner: 'Interactive Lesson - Learner View',
    interactive_lesson_learner_desc:
      'Experience interactive lessons from the learner perspective',

    interactive_lesson_admin: 'Interactive Lesson - Admin View',
    interactive_lesson_admin_desc:
      'Step-by-step guide to creating and managing interactive lessons',

    create_lesson: 'How to Create a Lesson',
    create_lesson_desc:
      'Step-by-step guide to creating lessons within a course',

    create_course_complete_tutorial: 'Create a Course Complete Tutorial',
    create_course_complete_tutorial_desc:
      'An end-to-end guide on how to generate a curriculum and create a course using AI on Sharelook.',

    // COURSES AI
    ai_curriculum: 'AI Curriculum Generation',
    ai_curriculum_desc:
      'Learn how to use AI to automatically generate course curriculum',

    // COURSES BUILDER
    intro_gen: 'Introduction Generation',
    intro_gen_desc: 'Generate compelling course introductions with AI',

    intro_generation: 'Course Introduction Generation',
    intro_generation_desc: 'Generate compelling course introductions with AI',

    ai_story_generation: 'AI Story & Real-life Story Generation',
    ai_story_generation_desc:
      'Create engaging stories and real-life scenarios with AI',

    scenario_gen: 'Scenario Generation',
    scenario_gen_desc: 'Build interactive scenarios for immersive learning',

    scenario_generation: 'Scenario Generation',
    scenario_generation_desc:
      'Build interactive scenarios for immersive learning',

    quiz_ai: 'AI Quiz Generation',
    quiz_ai_desc: 'Create quizzes automatically using AI technology',

    ai_quiz_generation: 'AI Quiz Generation',
    ai_quiz_generation_desc: 'Create quizzes automatically using AI technology',

    bullet_gen: 'Bullet Point Generation',
    bullet_gen_desc: 'Create structured bullet points for your lessons',

    bullet_points: 'Bullet Point Generation',
    bullet_points_desc: 'Create structured bullet points for your lessons',

    summary_gen: 'Summary Generation',
    summary_gen_desc: 'Automatically generate lesson summaries with AI',

    summary_generation: 'Summary Generation',
    summary_generation_desc: 'Automatically generate lesson summaries with AI',

    add_content: 'Add Content to Lesson',
    add_content_desc: 'Add various types of content to enrich your lessons',

    add_lesson_content: 'Add Content to Lesson',
    add_lesson_content_desc:
      'Add various types of content to enrich your lessons',

    layout_change: 'Change Lesson Layout',
    layout_change_desc: 'Customize the layout of your lesson pages',

    change_lesson_layout: 'Change Lesson Layout',
    change_lesson_layout_desc: 'Customize the layout of your lesson pages',

    voiceover_gen: 'Voiceover Generation',
    voiceover_gen_desc: 'Add professional voiceovers to your course content',

    voiceover_generation: 'Voiceover Generation',
    voiceover_generation_desc:
      'Add professional voiceovers to your course content',

    manual_quiz: 'Manual Quiz Creation',
    manual_quiz_desc: 'Learn how to manually create and customize quizzes',

    manual_quiz_creation: 'Manual Quiz Creation',
    manual_quiz_creation_desc:
      'Learn how to manually create and customize quizzes',

    ai_image_gen: 'AI Image Generation',
    ai_image_gen_desc: 'Generate custom images for your course using AI',

    ai_image_generation: 'AI Image Generation',
    ai_image_generation_desc: 'Generate custom images for your course using AI',

    simulation: 'Create Simulation',
    simulation_desc: 'Create interactive simulations in a sandbox environment',

    simulation_creation: 'Creating a Simulation (Sandbox Environment)',
    simulation_creation_desc:
      'Step-by-step guide to building simulations in the sandbox environment',

    course_learner_view: 'Course Learner View',
    course_learner_view_desc:
      'Understand the learner perspective and experience in courses',

    simulation_learner_view: 'How to take a simulation',
    simulation_learner_view_desc:
      'Experience simulations from the learner perspective in the sandbox environment',

    infographic_title: 'Adding Infographics to a Lesson Page',
    infographic_desc:
      'Learn to create interactive Infographics for your lessons',

    // MAZE
    ai_metamaze: 'AI-Metamaze Creation',
    ai_metamaze_desc:
      'Learn how to create interactive metamaze experiences using AI',

    ai_metamaze_creation: 'AI-Metamaze Creation',
    ai_metamaze_creation_desc:
      'Learn how to create interactive metamaze experiences using AI',

    // LIBRARY
    media_library: 'Media Library',
    media_library_desc: 'Overview of the Media Library and its usage',

    file_management: 'File Management',
    file_management_desc: 'Learn how to manage your files efficiently',

    upload_files: 'Uploading Files & Adding to AI Repository',
    upload_files_desc:
      'How to upload and integrate files into the AI Repository',

    file_upload_repository:
      'Uploading Files & Adding Files to the AI Repository',
    file_upload_repository_desc:
      'Learn to upload files and add them to the AI Repository',

    document_creation: 'Document Creation (Word, Calc, Impress)',
    document_creation_desc:
      'Learn to create documents in Word, Calc, and Impress formats',

    file_organization: 'File Organization in Folders',
    file_organization_desc: 'Organize files effectively within folders',

    document_creation_screen: 'Document Creation Using Screen Capture',
    document_creation_screen_desc:
      'Create documents using screen capture functionality',

    course_creation_screen: 'Course Creation Using Screen Capture',
    course_creation_screen_desc:
      'Create courses using screen capture functionality',

    downloads_center: 'Downloads Center',
    downloads_center_desc:
      'Access and manage downloaded content from the downloads center',

    // REPORTS
    reports_analytics: 'Reports and Analytics Overview',
    reports_analytics_desc:
      'Comprehensive guide to reports and analytics in Sharelook',

    reports_detailed: 'Reports and Analytics Detailed',
    reports_detailed_desc:
      'Detailed overview of all reporting features and analytics capabilities',

    workshop_report: 'Workshop Report',
    workshop_report_desc: 'View and analyze workshop performance reports',

    user_report: 'User Report',
    user_report_desc:
      'Access comprehensive user activity and performance reports',

    course_report: 'Course Report',
    course_report_desc:
      'View detailed reports on course completion and engagement',

    live_events_report: 'Live Events Report',
    live_events_report_desc:
      'Analyze attendance and engagement metrics for live events',

    metamaze_reports: 'Metamaze Reports',
    metamaze_reports_desc:
      'View performance and completion reports for Metamaze modules',

    live_assessments_reports: 'Live Assessment Reports',
    live_assessments_reports_desc:
      'Access reports on live assessment performance and results',

    skill_journey_reports: 'Skill Journey Reports',
    skill_journey_reports_desc:
      'Track progress and completion reports for skill journeys',

    sharesphere_report: 'Sharesphere Report',
    sharesphere_report_desc:
      'View engagement and activity reports for ShareSphere content',

    // SKILL JOURNEY
    create_skill_journey: 'Create Skill Journey',
    create_skill_journey_desc:
      'Learn how to create and manage skill journeys for learners',

    // PODCAST
    podcast_creation: 'Podcast Creation',
    podcast_creation_desc: 'Learn how to create and manage podcast channels',

    // Podcasts, Music, and Story
    podcast_listening_learner: 'How to listen to a Podcast',
    podcast_listening_learner_desc:
      'Learn how to listen to and navigate podcast content',

    // CHANNEL
    video_channel_creation: 'How to use the video channel',
    video_channel_creation_desc:
      'Create and customize video channels for your content',

    // REEL
    short_video_creation: 'Share Shorts Video Contribution',
    short_video_creation_desc: 'Learn how to create engaging short-form videos',

    short_video_admin: 'Short video/Shareshorts Admin View',
    short_video_admin_desc:
      'Manage and review short videos from the admin perspective',

    // TRIVIA
    create_trivia: 'How to Create a Trivia on Sharelook',
    create_trivia_desc: 'Learn how to create engaging trivia games',

    take_trivia: 'How to take a Trivia',
    take_trivia_desc: 'Learn how to participate in trivia games as a learner',

    // MANAGEMENT
    add_users: 'How to add users to an organization',
    add_users_desc: 'Add and manage users in your organization',

    add_group: 'How to create a group in your organization',
    add_group_desc: 'Create and manage user groups',

    // SKILL JOURNEY
    create_skill_journey: 'Skill Journey Creation',
    create_skill_journey_desc:
      'Learn how to create and manage skill journeys for learners',

    // CHANNEL
    video_channel_creation: 'Video Channel Creation',
    video_channel_creation_desc:
      'Create and customize video channels for your content',

    // MAZE
    ai_metamaze_creation: 'AI Metamaze Creation',
    ai_metamaze_creation_desc: 'Learn how to create AI Metamazes',
    virtual_coach: 'Virtual Coach Overview',
    virtual_coach_desc: 'Learn how to use the virtual coach feature',

    coaching_creation: 'Coaching Session Creation',
    coaching_creation_desc: 'Create and schedule coaching sessions',

    coaching_session_creation: 'Coaching Session Creation',
    coaching_session_creation_desc: 'Create and schedule coaching sessions',

    coaching_booking: 'Book Coaching Session Slot',
    coaching_booking_desc: 'How to book available coaching session slots',

    booking_coaching_slot: 'How to book a Coaching Session Slot',
    booking_coaching_slot_desc: 'How to book available coaching session slots',

    // WORKSHOP
    my_workshop: 'My Workshop',
    my_workshop_desc: 'Overview of the Workshop section and its features',

    add_scorm: 'How to Add a SCORM Course on Sharelook',
    add_scorm_desc:
      'Upload a SCORM course, customize it with badges, certificates, and cover images',

    edit_skill_journey: 'Edit Skill Journey',
    edit_skill_journey_desc: 'Learn how to edit an existing skill journey',

    edit_live_event: 'Edit Live Event',
    edit_live_event_desc: 'Edit and manage live events effectively',

    clone_course: 'Clone Course',
    clone_course_desc: 'Clone an existing course for reuse or modification',

    clone_metamaze: 'Clone Metamaze',
    clone_metamaze_desc:
      'Learn how to duplicate a Metamaze for new learners or updates',

    delete_skill_journey: 'Delete Skill Journey',
    delete_skill_journey_desc: 'Step-by-step process to delete a skill journey',

    delete_live_event: 'Delete Live Event',
    delete_live_event_desc: 'Delete unwanted live events from the platform',

    edit_course: 'Edit Course',
    edit_course_desc: 'Edit existing courses and update their content',

    delete_metamaze: 'Delete Metamaze',
    delete_metamaze_desc: 'Learn how to safe delete a Metamaze module',

    delete_podcast: 'Delete Podcast',
    delete_podcast_desc: 'Remove existing podcasts from your channel',

    delete_video_channel: 'Delete Video Channel',
    delete_video_channel_desc: 'Delete unwanted video channels easily',

    edit_video_channel: 'Edit Video Channel',
    edit_video_channel_desc: 'Learn how to edit details of your video channels',

    delete_course: 'Delete Course',
    delete_course_desc: 'Steps to permanently delete a course',

    edit_metamaze: 'Edit Metamaze',
    edit_metamaze_desc: 'Learn how to make edits to existing Metamaze modules',

    edit_podcast: 'Edit Podcast',
    edit_podcast_desc: 'Edit podcast episodes and details with ease',

    create_live_event: 'How to Create a Live Event',
    create_live_event_desc:
      'Step-by-step guide to creating and scheduling live events',

    translate_course: 'How to Translate a Course',
    translate_course_desc:
      'Learn how to translate course content into multiple languages',

    // LEADERBOARD
    create_competition: 'How to create a competition on the leaderboard',
    create_competition_desc:
      'Set up competitions and leaderboards to engage learners',

    leaderboard_settings: 'Leaderboard Settings',
    leaderboard_settings_desc: 'Configure leaderboard and competition settings',

    leaderboard_learner_view: 'Navigating the Sharelook Leaderboard',
    leaderboard_learner_view_desc:
      'View leaderboards and competitions from the learner perspective',

    // MARKETPLACE
    marketplace: 'An overview of The Sharelook Marketplace',
    marketplace_desc:
      'Overview of the Marketplace and how to buy and sell content',

    buy_course: 'How to Buy a Course',
    buy_course_desc: 'Learn how to purchase courses from the marketplace',

    book_coaching: 'How to book a Coaching Session Slot',
    book_coaching_desc:
      'Step-by-step guide to booking coaching sessions from the marketplace',

    buy_podcast: 'How to Buy a Podcast',
    buy_podcast_desc: 'Learn how to purchase podcast subscriptions',

    subscribe_channel: 'How to Buy/Subscribe to a Video Channel',
    subscribe_channel_desc:
      'Subscribe to video channels and access premium content'
  },
  v5: {
    view_document: 'View Document',
    duplicate_folder_name: 'Folder with this name already exists.',
    my_video_shorts: 'MY VIDEO SHORTS',
    see_more: 'SEE MORE',
    no_shorts_found: 'No Shorts Found',
    shorts: 'Shorts',
    general_information: 'General Information',
    gamification: 'Gamification',
    click_to_select_files: 'Click to select files',
    selected_files: 'Selected Files',
    uploaded: 'Uploaded',
    failed: 'Failed',
    system_will_automatically_analyze_and_select_the_most_relevant:
      "system will automatically analyze and select the most relevant  documents from your organization's library based on the content requirements.",
    select_from_library: ' Select from Library',
    search_document: 'Search documents...',
    selected: 'Selected',
    loading_documents: 'Loading documents...',
    review_generated_content: 'Review Generated Content',
    confirm_and_replace_content: 'Confirm and Replace Content',
    the_generate_content_will_replace:
      "The generated content will replace the existing text in the selected pages. If you don't want to apply these changes, you can go back to the previous step.",
    pages_to_be_updated: 'Pages to be updated',
    generated_revisions: 'Generated Revisions',
    lesson_preview: 'Lesson Preview',
    create_new_folder: 'Create New Folder',
    interactive_simulation: 'Interactive Lesson',
    rename_item: 'Rename Item',
    enter_folder_name: 'Enter folder name:',
    enter_new_name: 'Enter new name:',
    folder_name: 'Folder name:',
    new_name: 'New name',
    move_items: 'Move Items',
    copy_items: 'Copy Items',
    move_here: 'Move Here',
    copy_here: 'Copy Here',
    select_destination_library_and_folder:
      'Select destination library and folder:',
    items_selected: 'Items Selected',
    version: 'Version',
    modified_by: 'Modified by',
    size: 'Size',
    restore: 'Restore',
    are_you_sure_you_want_to_restore_this_version:
      'Are you sure you want to restore this version?',
    this_will_replce_the_current_version_with_the_selected_one:
      'This will replace the current version with the selected one.',
    restore_this_version: 'Restore this version',
    restore_not_available: 'Restore not available',
    version_history: 'Version History:',
    by_making_items_public:
      'By making items public, they will be visible to everyone. Please review the terms and conditions before proceeding.',
    the_selected_items_will_be_copied:
      'The selected items will be copied to your public library and visible to everyone.',
    the_selected_items_will_be_copied_to_org:
      'The selected items will be copied to your organization library and visible to all organization members.',
    the_selected_items_will_be_copied_to_your_private:
      'The selected items will be copied to your private library and only visible to you.',
    loading_organization: 'Loading organization users...',
    click_download_to_view: 'Click download to view',
    archive_file: 'Archive file',
    no_preview_available: 'No preview available',
    audit_report: 'Audit Report',
    audit_type: 'Action Type',
    i_agree_to_the_terms_and_conditions: 'I agree to the terms and conditions.',
    this_file_is_indexed_for_ai: 'This file is indexed for AI.',
    file_is_not_indexed_for_ai: 'File is not indexed for AI.',
    no_users_found: 'No users found',
    no_users_available: ' No users available',
    add_people: 'Add people',
    people: 'People',
    access_type: 'Access Type',
    no_group_found: 'No groups found',
    add_group: 'Add groups',
    groups: 'Groups',
    users_top: 'user(s)',
    confirm_delete: 'Confirm Delete',
    do_you_want_remove: 'Are you sure you want to remove',
    form_this_documents_permissions: "from this document's permissions?",
    no_users_found_in_this_group: 'No users found in this group',

    add_selected_users: 'Add Selected Users',
    choose_users_from_the_list: 'Choose users from the list',
    selected_users: 'Selected Users',
    archived: 'Archived',
    request_approval: 'Request Approval',
    document_in_review: 'Document in Review',
    approve: 'Approve',
    reject: 'Reject',
    comment: 'Comment:',
    enter_your_commit: 'Enter your comment...',
    confirm_cancel: 'Confirm Cancel',
    upload_3d_zip: ' Upload 3D Zip',
    delete_items: 'Delete Items',
    video_upload_request: 'Video upload request',
    reject_video: 'Reject Video',
    enter_rejection_reason: 'Enter rejection reason...',
    please_provide_a_reason_for_reejection_this_video:
      'Please provide a reason for rejecting this video:',
    generate_trivia_with_ai: 'Generate Trivia with AI',
    select_category: 'Select Category:',
    number_of_question: 'Number of Questions',
    generated_questions: 'Generated Questions',
    this_will_clear_all_generate_question:
      'This will clear all generated questions. Continue?',
    sure_delete: 'Are you sure to delete?',
    delete_this_question: 'Are you sure to delete this question?',
    loading_quiz: 'Loading Quiz...',
    creteing_file: 'creating',
    opening_desktop_app: 'opening desktop app',
    this_folder_is_empty: 'This folder is empty',
    select_a_competition: 'Select a competition...',
    activity_badges: 'Activity Badges',
    awarded_every_badges:
      'Awarded every 4, 8, 16, 32, 64, 128, 256, 512 logins',
    learning_badges: 'Learning badges',
    awarded_every_courses:
      'Awarded every 1, 4, 8, 16, 32, 64, 128 completed courses',
    test_badges: 'Test badges',
    awarded_every_passes_tests:
      'Awarded every 2, 4, 8, 16, 32, 64, 128, 256 passed tests',
    assignment_badges: 'Assignment badges',
    awarded_every_passed_assignments:
      'Awarded every 1, 2, 4, 8, 16, 32, 64, 128 passed assignments',
    perfectionism_badges: 'Perfectionism badges',
    awarded_every_assignments_with_scrore:
      'Awarded every 1, 2, 4, 8, 16, 32, 64, 128 tests or assignments with score 90%+',
    communication_badges: 'Communication badges',
    awarded_every_topics_or_comments:
      'Awarded every 2, 4, 8, 16, 32, 64, 128, 256 topics or comments',
    certification_badges: 'Certification badges',
    awarded_every_certificates:
      'Awarded every 1, 2, 4, 8, 16, 32, 64, 128 certificates',
    level_name: 'Level name',
    delete_competition: 'Delete Competition',
    this_week: 'This Week',
    this_year: 'This Year',
    folder: 'Folder',
    item: 'Item',
    delete_confirmation: 'Are you sure you want to delete',
    make_organization: 'Make Organization',
    no_results_found: 'No results found for',
    no_items_available: 'No items available',
    help_video: 'Help Videos',
    select_a_video_from_the_list:
      'Select a video from the list to start learning',
    relevant_videos_label: 'Individual Videos',
    pinned_bundle_label: 'Complete Tutorial',

    recording: 'Recording', //translate german and hebrew
    on: 'On',
    off: 'Off',
    started_on: 'Started on',
    created_on: 'Created on',
    this: 'This',
    list_arrangement_will_be_primary_order:
      'list arrangement will be primary order for the list visible in traning page.',
    sequence_order: 'Sequence Order',
    sequence_not_set: 'Sequence Not Set',
    order_sequence_set_successfully: 'Order sequence set successfully',
    search_for_stock_images: 'Search for stock images...',
    search_for_a_location: 'Search for a location...',
    loading_suggestions: 'Loading suggestions...',
    suggested_locations: 'Suggested locations:',
    available: 'available',
    no_podcast_is_available: 'No podcast is available !',
    no_mazes_available: 'No mazes available !',
    grid_view: 'Grid View',
    list_view: 'List View',
    create_a_subtle_and_non_distracting_background_image:
      'Create a subtle and non-distracting background image for a digital course, inspired by',
    the_image_should_incorporate_elements_of:
      'The image should incorporate elements of',
    vary_abstract_faded_or_minimalist_way:
      'in a very abstract, faded, or minimalist way. Use extremely soft colors, gentle gradients, or barely noticeable patterns that hint at the theme without being too literal or prominent. The overall effect should be light and airy, allowing for easy readability of overlaid text and content. The design must be suitable for a 16:9 aspect ratio and accommodate various UI elements. Ensure the elements are distributed evenly across the image to create a balanced, non-distracting backdrop.',
    top_left: 'Top Left',
    top_right: 'Top Right',
    bottom_left: 'Bottom Left',
    bottom_right: 'Bottom Right',
    select_position_of_image_you_like: 'Select Position of Image You Like',
    select_a_position_of_image:
      'Select a position of image you like to generate its variations',
    generate_variations: 'Generate variations',
    select_a_position_of_image_upscale:
      'Select a position of image you like to upscale it',
    upscale_image_for_selection: 'Upscale Image For Selection',
    generation_variations: 'Generating variations...',
    generating_your_image: 'Generating your image...',
    waiting_start_generation: 'Waiting to start generating',
    variations: 'variations',
    upscaling_image: 'Upscaling image...',
    upscaled_image: 'Upscaled Image',
    ai_generate_image: 'AI Generated Image',
    select: 'Select',
    generate_image_using_your_image: 'Generate image using your own image idea',
    please_enter_your_idea: 'Please enter your image idea...',
    your_prompt_here: 'Your prompt here...',
    add_text_in_the_image: 'Add text in the image',
    what_type_image_do_you_generate:
      "What type of image would you like to generate? Please describe the scene, objects, or any specific details you have in mind, and I'll do my best to create it for you.",
    are_you_sure_you_want_to_start_a_new_chat:
      'Are you sure you want to start a new chat?',
    start_new_chat: 'Start New Chat',
    stop_chat: 'Stop Chat',
    start_chat: 'Start Chat',
    created_successfully: 'created successfully',
    failed_to_create_folder: 'Failed to create folder',
    please_enter_name: 'Please enter a name',
    failed_to_rename_file_folder: 'Failed to rename file/folder',
    opened_download_link_in_new_tab: 'Opened download link in new tab',
    failed_to_get_download_link: 'Failed to get download link',
    prepare_download: 'Preparing downloads...',
    failed_download_link: 'Failed to get download link for ID',
    open_first_download: 'Opened first download link. Check console for',
    additional_link: 'additional links.',
    prepared: 'Prepared',
    download_link: 'download links',
    no_download_file: 'No downloadable files found',
    download_failed: 'Download preparation failed',
    certificate_title_is_required: 'Certificate title is required.',
    are_you_sure_you_want_to_attach_this_certificate:
      'Are you sure you want to attach this certificate to this course? It will also be available in your certificates history.',
    update_badge: 'Update badge',
    attach_audio: 'Attach Audio',
    correct_answer_is_required: 'A correct answer is required.',
    or: 'OR',
    insert_scenario: 'Insert Scenario',
    as_screen_capture: 'with Screen Capture',
    as_simulation: 'with Simulation',
    added_avatar: 'Avatar added',
    select_avatar: 'Select Avatar',
    add_audio: 'Add audio',
    only_to_options: 'Only 2 to 4 options',
    only_to_layers: 'Only 2 to 8 layers',
    shop: 'SOP',
    video_channel: 'Video Channel',
    podcasts: 'Podcasts',
    organisations: 'Organisations',
    org_groups: 'Organisation Groups',
    channel_outline_is_required: 'Channel Outline is required',
    channel_obj_required: 'Channel Objectives is required.',
    enter_value: 'Please enter a value.',
    no_basket_to_add: 'No item(s) selected to add to basket',
    find_your_video: 'Find Your YouTube User & Channel IDs',
    each_youtube_channel_has_unique:
      'Each YouTube channel has a unique user ID and channel ID. These IDs are used to refer to the channel in certain apps and services.',
    find_channel_id: "How to Find Your Channel's User ID & Channel ID",
    of: 'of',
    folders: 'Folders',
    yesterday: 'Yesterday',
    months_ago: 'months ago',
    today: 'Today',
    days_ago: 'days ago',
    weeks_ago: 'weeks ago',
    documents: 'documents',
    your_channel_user_id:
      "You can find your channel's user and channel IDs in your",
    advance_account: 'advanced account settings',
    computer_or_mobile_browser: 'on a computer or mobile browser.',
    sign_in_to: 'Sign in to',
    click_profile_pic_left: 'In the top right, click your profile picture',
    from_the_left_menu: 'From the left menu, select',
    adv_setting: 'Advanced settings',
    user_channel_id_there:
      'You’ll see your channel’s user and channel IDs there.',
    you_can_also: 'You can also',
    manage_channel: 'manage your channel name',
    studio_youtube: 'in YouTube Studio.',
    sharesphere_question_updated: 'ShareSphere question updated',
    select_category: 'Select category(s)',
    please_select_category: 'Please select category(s)!',
    ShareSphere_question_created: 'ShareSphere question created',
    generate_text: 'Generate to text',
    ar_trigger_image: 'AR Trigger Image',
    name_of_the_guest: 'Name of the Guest No',
    library: 'Library',
    previous: 'Previous',
    draft: 'Draft',
    unpublishing: 'Unpublishing',
    publishing: 'Publishing',
    unpublish_from_marketplace: 'Unpublish from Marketplace',
    unpublished: 'Unpublished',
    unpublish: 'unpublish',
    publish: 'publish',
    quiz_complete: 'Quiz Complete',
    lesson_complete: 'Lesson Complete',
    get_certificate: 'Get Certificate',
    select_participants: 'Select participants',
    competition_updated_successfully: 'Competition updated successfully!',
    competition_created_successfully: 'Competition created successfully!',
    levels_configuration: 'Levels Configuration',
    account_subscribptions: 'Active Subscriptions',
    search_organisation: 'Search Organisation',

    generate_an_engaging_introduction_to_capture:
      "Generate an engaging introduction to capture your audience's attention and set the tone for your lesson.",
    create_a_comprehensive_summary:
      'Create a comprehensive summary that reinforces key points and wraps up your lesson effectively.',
    introductio_added_at_the_beginning:
      'Introduction added at the beginning of the lesson.',
    summary_added: 'Summary added at the end of the lesson.',
    you_cannot_add_other_element_in_a_scenario_page:
      'You cannot add other element in a scenario page. Please try other pages or remove the scenario from the page first.',
    pages_list_whose_content_you_want_to_reference:
      'Please click on the pages from the pages list whose content you want to reference in the',
    choose_your_story: 'Choose Your Story',
    generate_scenario: "Here's your generated scenario!",
    will_help_you_create_scenario:
      "Hello! I'll help you create a scenario. What would you like to focus on?",
    sorry_encountered_an_error:
      'Sorry, I encountered an error. Please try again.',
    chat_based_scenario_generation: 'Chat-based Scenario Generation',
    start_conversation_to_generate:
      'Start a conversation to generate your scenario through interactive dialogue.',
    view_scenario: 'View Scenario',
    use_this_scenario: 'Use This Scenario',
    prompt_helper: 'Prompt Helper',
    hide_prompt_helper: 'Hide Prompt Helper',
    please_upload_reference_image:
      'Please upload at least one reference image for Image Edit mode',
    error_generating_image: 'Error generating image. Please try again!',
    max_reference_images_allowed:
      'Maximum of 9 reference images allowed. Please remove an image first.',
    failed_to_convert_image_url: 'Failed to convert image url!',
    preparing_variations: 'Preparing variations...',
    preparing_image: 'Preparing image...',
    generated_image_alt: 'Generated Image',
    processing_your_request: 'Processing your request...',
    generating_variations_in_progress: 'Generating variations in progress',
    lightning_fast_generation_in_progress:
      'Lightning-fast generation in progress',
    file: 'File',
    is_too_large: 'is too large',
    mb: 'MB',
    limit_is: 'Limit is',
    please_enter_image_idea: 'Please enter your image idea...',
    your_prompt_here: 'Your prompt here...',
    what_type_image_generate:
      "What type of image would you like to generate? Please describe the scene, objects, or any specific details you have in mind, and I'll do my best to create it for you.",
    select_pexels_image_title: 'Select Pexels Image',
    stock_image: 'Stock Image',
    pagination_of: 'of',
    pagination_images: 'images',
    reference_image_alt: 'reference Image',
    user_alt: 'user',
    story_description_tone: 'Overall mood or attitude of the story.',
    story_description_narrative_hook:
      "An engaging opening line or paragraph that captures the reader's attention and sets the stage for the story.",
    story_description_narrative_style:
      'A perspective from which the story is told.',
    story_description_story_plot:
      "A plot is how a story is shown, like in a movie or book. It's the order in which events happen. Sometimes they're shown one after another, and other times they're mixed up. For example, some stories start with the end and then go back to the beginning to explain.",
    story_description_complexity: 'Level of difficulty and depth of the story.',
    story_description_genre: 'Category or type of story.',
    story_description_vocabulary: 'Choice and use of words.',
    story_description_narrative_structure: 'Organization of story events.',
    story_description_time_period: 'Era in which the story is set.',
    story_description_story_length: 'Length of the narrative.',
    story_description_character_names: 'Names of characters in the story.',
    story_description_output_type: 'The format of the story.',
    story_chat_initial_message:
      "Hello! I'll help you create a story. What would you like to focus on?",
    story_add_to_pages_title: 'Do you want to add story to the pages?',
    story_add_to_pages_content:
      'The original content will be replaced with the story text.',
    story_chat_error_message:
      'Sorry, I encountered an error. Please try again.',
    story_generated_story_label: 'Generated Story',
    story_generating: 'Generating...',
    story_use_story_title: 'Do you want to use this generated story?',
    story_use_story_content:
      'This will open the story editor where you can make further edits before adding it to your lesson.',
    story_use_story_button: 'Use Story',
    story_chat_placeholder: 'Type your message...',
    story_chat_send: 'Send',
    story_form_mode: 'Form Mode',
    story_chat_mode: 'Chat Mode',
    story_page_heading: 'Story',
    bullet_points: 'Bullet Points',
    scenario_generation: 'Scenario Generation',
    please_enter_number_of_questions: 'Please enter number of questions',
    please_enter_number_of_questions:
      'Please enter number of questions between 1 and 10',
    maze_summary: 'Maze Summary',
    course_recommendation: 'Course Recommendation',
    downlad_center_save_summary: 'Save Summary in Download Center',
    loading_maze_summary: 'Loading Maze Summary...',
    generating_course_recommendation: 'Generating Course Recommendation...',
    no_course_recommended: 'No course recommended.',
    click_to_view_course: 'Click to view course',
    recommended_skill_journey: 'Recommended Skill Journey',
    click_to_view_skill_journey: 'Click to view Skill Journey',
    select_simulation_type: 'Select Simulation Type',
    simulation_mode: 'Simulation Mode',
    attempts_count: 'Attempts Count',
    no_of_attempts_user_can_try: 'No.of attempts, a user can try',
    uload_section_file: 'Upload Section file',
    my_library: 'My Library',
    search_documents_by_name: 'Search documents by name...',
    document: 'document',
    org_library: 'Org Library',
    top_center: 'Top Center',
    center: 'center',
    bottom_center: 'Bottom Center',
    big: 'Big',
    small: 'Small',
    medium: 'Medium',
    text_position: '📝 Text Position',
    please_select_text: 'Please select a text position',
    note_that_ai_generated_content_may_not_always_be_accurate:
      '* Please note that AI-generated content may not always be accurate. Text  placement and formatting, such as the addition of text, may sometimes be imprecise.',
    number_of_images: '📝 Number of images',
    please_select_of_image: 'Please select number of images',
    creating_calc_spreadsheet: 'Creating Calc spreadsheet...',
    creating_calc_spreadsheet_successfully:
      'Calc spreadsheet created and uploaded successfully!',
    opening_sharelook: 'Opening ShareLook...',
    shareLook_opened_successfully: 'ShareLook opened successfully!',
    upload_function_not_provided:
      'Impress presentation created and uploaded successfully!',
    creating_impress_presentation: 'Creating Impress presentation...',

    talk_with_course_assistants: 'Talk with course assistants',
    select_your_coacher: 'Select Your Coach',
    simon_witts_aviation_generation_ccoacher:
      'Simon Witts - Aviation Generation - Coacher',
    simon_witts: 'Simon Witts',
    aviation_generation_coacher: 'Aviation Generation - Coacher',
    coacher_mode_active: 'Coach Mode Active',
    your_personal_coaching_experience: 'Your personal coaching experience',
    powered_by: 'Powered by',
    uk_civil_viation_authority_data: 'UK Civil Aviation Authority Data',
    start_coaching_session: 'Start Coaching Session',
    what_image_do_you_need: 'What image do you need?',
    write_something: 'Write something.',
    speak: 'Speak',
    grid: 'Grid',
    ar: 'AR',
    premium_voices: 'Premium Voices',
    default_tts: 'Default TTS',
    generate_audio: 'Generate Audio',
    username_or_email_address: 'Username or Email Address',
    meta_maze_avatars: 'MetaMaze Avatars',
    training_skill_journey: 'TRAINING SKILL JOURNEY',
    marketplace: 'Marketplace',
    are_you_sure_you_want_to_update_your_course_template:
      'Are you sure you want to update your course template?',
    this_will_automatically_update_the_template:
      'This will automatically update the template for all the generated lessons and pages in your course.',
    note_this_process_will_change_the_course_lesson_layouts:
      'Note: This process will change the course lesson layouts, which may affect the positions of audio, video, images, and other elements. If you have added new elements to an existing template on any page, their positions will remain unchanged.',
    open_sharelook_application: 'Open ShareLook Application?',
    this_will_launch_sharelook_for_screen_capture:
      'This will launch ShareLook for screen capture.',
    open: 'Open',
    are_you_sure_you_want_to_save_this_certificate_for_later:
      'Are you sure you want to save this certificate for later? It will not be attached to this course but will be available in your certificates history.',
    are_you_sure_you_want_to_remove_this_media:
      'Are you sure you want to remove this media?',
    the_media_will_be_removed_from_the_scenario:
      'The media will be removed from the scenario.',
    proceed_to_template_selection: 'Proceed to Template Selection',
    template_selection: 'Template Selection',

    create_lesson: 'Create lesson',
    competition_title_is_required: 'Competition Title is required!',
    competition_description_is_required: 'Competition Description is required!',
    skill_selection_is_required: 'Skill selection is required!',
    start_date_is_required: 'Start Date is required!',
    end_date_is_required: 'End Date is required!',
    start_date_must_be_before_end_date: 'Start Date must be before End Date!',
    points_cannot_be_negative: 'Points cannot be negative!',
    points_connot_exceed: 'Points cannot exceed 1000!',
    error_occured_while_creating_the_competition:
      'An error occurred while creating the competition.',
    select_question_type: 'Select Question Type',
    please_select_question_type: 'Please select question type!',
    search_by_title_or_description: 'Search by title or description...',
    no_videos_found_matching: 'No videos found matching',
    what_new_at_shareLook: "What's new at ShareLook",
    did_you_know_that_creating_learning_experience:
      'Did you know that creating a storytelling-style learning experience is easy to do in a short time and inexpensive? You should combine the ShareLook course builder with your respective talents. Ask us how.',
    welcome_to_shareLook_help_center: 'Welcome to ShareLook Help Center',
    select_video_from_the_left_navigation:
      'Select a video from the left navigation to get started, or use the search to find specific content.',
    date_time_error_peer:
      'Event start time must be at least 1 minute from now.',
    no_language_information_available:
      'No language information available for these voices.',
    loading_eventlabs_voices: 'Loading ElevenLabs voices...',
    search_voices: 'Search voices...',
    please_upload_at_last_one_supported_file:
      'Please upload at least one supported file.',
    you_can_upload_a_maximum_of_files: 'You can upload a maximum of 5 files.',
    failed_to_load_documents: 'Failed to load documents. Please try again.',
    file_not_supported: 'is not a supported file type. Accepted types:',
    required_fields_are_missing: 'Required fields are missing.',
    form_validation_failed: 'Form validation failed.',
    select_cloned_voice: 'Select Cloned Voice',
    upload_voice: 'Uploaded Voices',
    max_five: '5 (Max)',
    loading_list: 'Loading list...',
    failed_to_create_podcast: 'Failed to create podcast!',
    failed_to_create_voicce: 'Failed to create voice!',
    make_public_success: 'Items made public successfully',
    make_org_success: 'Items moved to organization successfully',
    make_private_success: 'Items made private successfully',
    make_public_failed: 'Failed to make items public',
    make_org_failed: 'Failed to move items to organization',
    make_private_failed: 'Failed to make items private',
    the_number_of_choices_or_paths_available:
      'The number of choices or paths available to the learner. This section to be disabled if the learner selects open-ended scenario type. <2, 3, 4>',
    select_this_image: 'Select this Image',
    please_select_a_font_size: 'Please select a font size',
    font_style: 'Font Style',
    please_select_a_font_style: 'Please select a font style',
    font_type: 'Font Type',
    please_select_a_font_type: 'Please select a font type',
    text_color: 'Text Color',
    please_select_a_text_color: 'Please select a Text Color',
    regular: 'Regular',
    bold: 'Bold',
    italic: 'Italic',
    thin: 'Thin',
    font_retro: 'Retro',
    font_techy: 'Techy',
    font_neon: 'Neon',
    font_sketch: 'Sketch',
    font_3d: '3D',
    font_comic_style: 'Comic Style',
    font_anime_style: 'Anime Style',
    font_illustration: 'Illustration',
    font_hand_written: 'Hand Written',
    font_quirky: 'Quirky',
    font_chalk_board: 'Chalk Board',
    color_vibrant: 'Vibrant',
    color_black_white: 'Black & White',
    color_gold_script: 'Gold Script',
    color_rainbow_neon: 'Rainbow Neon',
    color_gradient: 'Gradient',
    text_options: 'Text Options',
    icon_text: '📝 Text',
    type_message: 'Type a message',
    please_upload_at_least_one_supported_file:
      'Please upload at least one supported file (.pdf, .doc, .docx, .ppt, .pptx, .txt).',
    select_files_to_upload: 'Select Files to Upload',
    showing: 'Showing',
    are_you_sure_delete_file_confirm: 'Are you sure you want to delete this',
    click_to_open_pdf_reference: 'Click to open PDF reference',
    click_to_open: 'Click to open',
    write_here: 'Write here...',
    content_edited_successfully: 'Content edited successfully!',
    failed_to_edit_content: 'Failed to edit content',
    please_enter_editing_instruction: 'Please enter editing instructions',
    review_course_wide_changes: 'Review Course-wide Changes',
    collapse_all: 'Collapse All',
    expand_all: 'Expand All',
    adding_content_from_internet: 'Adding Content From Internet...',
    no_content_found: 'No content found.',
    please_enroll_to_take_this_skill_journey:
      'Please enroll to take this Skill Journey',
    edited_content: 'Edited Content',

    infographics: 'Infographics',
    generate_infographics: 'Generate Infographics', // to translate,
    select_language_error: 'Please select a language for AI course creation.', // to translate
    a_recommended_course_is_available:
      'A recommended course is available. Please check the application for more details.',
    competition_deleted_successfully: 'Competition deleted successfully!',
    failed_to_delete_the_competition: 'Failed to delete the competition!',
    generate_content_from: 'Generate Content from',
    minimum_score: 'Minimum Score',
    please_select_style: 'Please select style',
    document_type: 'Document Type',
    select_document_type: 'Select a document type',
    please_select_document_type: 'Please select a document type',
    document_name: 'Document Name',
    please_enter_document_name: 'Please enter a document name',
    infographics: 'Infographics',
    generate_infographics: 'Generate Infographics',
    course_builder: 'Course Builder',
    short_videos: 'Short Videos',
    user_management: 'User Management',
    user_agreement: 'USER AGREEMENT',
    terms_and_conditions_upper: 'TERMS AND CONDITIONS',
    connected: 'Connected',
    waiting_for_coach: 'Waiting for coach...',
    disconnected: 'Disconnected',
    coach_intro: "Hi, I'm DGF Logistic Coach.",
    coach_help: 'How may i help you?',
    press_to_speak: 'Press here before you speak',
    leave: 'Leave',
    open_the_sharelook_application_for_building_interactive_lesson: `This will open the ShareLook application for building interactive lesson. If the application doesn't open, it may not be installed on your device.`,
    launch_interactive_lesson: 'Launch Interactive Lesson',
    create_interactive_lesson: 'Create Interactive Lesson',
    edit_interactive_lesson: 'Edit Interactive Lesson',
    set_up_your_interactive_lesson: 'Set up your interactive lesson',
    interactive_lesson_title: 'Interactive Lesson Title',
    enter_interactive_lesson_title: 'Enter interactive lesson title',
    this_feature_available_for_windows_user_only:
      'This feature available for windows user only',
    preparing_interactive_lesson: 'Preparing Interactive Lesson...',
    please_wait_while_we_set_up_your_interactive_lesson:
      'Please wait while we set up your interactive lesson',
    open_sharelook_app: 'Open ShareLook App',
    current_color: 'Current Color',
    new_color: 'New Color',

    infographic_content_required: 'Content Required',
    infographic_content_required_desc:
      'Please add content to the page or provide custom instructions to generate an infographic.',
    infographic_using_custom_prompt: 'Using Custom Instructions',
    infographic_using_custom_prompt_desc:
      'Generating based solely on your custom instructions.',
    infographic_source_context: 'Source Context',
    infographic_no_source_content:
      'No content found on page. Please use Custom Instructions.',
    infographic_custom_instructions: 'Custom Instructions',
    infographic_prompt_placeholder_new:
      'E.g., Focus on the statistics, use a blue color scheme...',
    infographic_generate_btn: 'Generate Infographic',
    infographic_creating_magic: 'Creating magic...',
    infographic_generating_image: 'Generating Infographic...',
    infographic_start_over: 'Start Over',
    infographic_start_over_confirm_title: 'Start Over?',
    infographic_start_over_confirm_content:
      'This will clear your entire chat history and reset the session. Are you sure you want to proceed?',
    infographic_preview_area: 'Preview Area',
    infographic_preview_desc:
      'Your generated infographic will appear here ready for review.',
    infographic_discard: 'Discard',
    video_not_loading: 'Video not loading?',
    watch_on_youtube: 'Watch on Youtube',
    select_documents: 'Select Documents',
    no_documents_available: 'No documents available',
    documents: 'Documents',
    change_selected_documents: 'Change Selected Documents',
    end_goal: 'End Goal',
    end_goal_description: 'Describe the final outcome you want to achieve.',
    problem_statement: 'Problem Statement',
    problem_statement_description:
      'Explain the issue, challenge, or need you are trying to address.',
    learner_role: 'Learner Role',
    learner_role_description:
      'Specify the role or perspective the learner should take.',
    depth: 'Depth',
    depth_description: 'Choose how detailed or advanced the content should be.',
    no_of_options: 'Number of Options',
    no_of_options_description: 'Specify how many option variations you want.',
    maze_details: 'Maze Details',
    maze_details_description: 'Describe the final outcome you want to achieve.',
    generate_infographics: 'Generate Infographics', // to translate,
    select_language_error: 'Please select a language for AI course creation.', // to translate,

    narrativeHook: 'Narrative Hook',
    storyPlot: 'Story Plot',
    complexity: 'Complexity',
    genre: 'Genre',
    vocabulary: 'Vocabulary',
    narrativeStructure: 'Narrative Structure',
    timePeriod: 'Time Period',
    storyLength: 'Story Length',
    characterNames: 'Character Names',
    outputType: 'Output Type',
    tone: 'Tone',
    narrativeStyle: 'Narrative Style',
    storyObjectives: 'Story Objectives', // to translate
    storyObjectivesDescription:
      'Describe the final outcome you want to achieve.', // to translate

    formal: 'Formal',
    informal: 'Informal',
    humorous: 'Humorous',
    assertive: 'Assertive',
    sarcastic: 'Sarcastic',
    optimistic: 'Optimistic',
    firstPerson: 'First Person',
    secondPerson: 'Second Person',
    thirdPerson: 'Third Person',
    thirdPersonLimited: 'Third Person Limited',
    thirdPersonOmniscient: 'Third Person Omniscient',
    epistolary: 'Epistolary',
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    experimental: 'Experimental',
    realistic: 'Realistic',
    historical: 'Historical',
    casual: 'Casual',
    drama: 'Drama',
    fantasy: 'Fantasy',
    adventure: 'Adventure',
    satire: 'Satire',
    scienceFiction: 'Science fiction',
    mystery: 'Mystery',
    linear: 'Linear',
    nonLinear: 'Non-linear',
    circular: 'Circular',
    inMediaRes: 'In media res',
    framedNarrative: 'Framed narrative',
    past: 'Past',
    present: 'Present',
    future: 'Future',
    timelessOrUnspecified: 'Timeless or unspecified',
    short: 'Short (300 - 500 words)',
    medium: 'Medium (500 - 800 words)',
    long: 'Long (800+ words)',
    screenplay: 'Screenplay',
    narrative: 'Narrative',
    simple: 'Simple',
    moderate: 'Moderate',
    advanced: 'Advanced',
    jargonOrTechnical: 'Jargon or technical',
    periodSpecific: 'Period-specific',
    slangOrColloquial: 'Slang or colloquial',

    //to translate
    quiz_aded_on_start_page_successfully:
      'Quiz added on start page successfully',
    quiz_aded_on_end_page_successfully: 'Quiz added on end page successfully',
    generated_real_world_scenario: 'Generated Real World Scenario',
    generating_scenario_wait: 'Generating scenario, please wait...',
    processing_scenario_details: 'Processing scenario details...',
    finalizing_test_components: 'Finalizing test components...',
    view_scenario: 'View Scenario',
    will_help_you_create_scenario:
      'I will help you create a scenario based on the course content.',
    sorry_encountered_an_error:
      'Sorry, I encountered an error. Please try again.',
    email_address: 'Email Address',
    podcastHost: 'Podcast Host:', //to translate
    coach_conversation: 'Coach Conversation', //to translate
    workshop_access_denied_title: "You don't have access to My Workshop.",
    workshop_access_denied_subtitle:
      'This section is available to administrators only. Please contact your admin if you need access.'

  },
  v4: {
    drop_files: 'Drop file and select where to upload.', // to translate
    duplicate_lessoon: 'Lesson already present the course',
    upload_another_file: 'Upload Another File',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'Drop file and select where to upload.',
    duplicate_lesoon: 'Lesson already present the course',
    skill_rule_title: 'Please Input Skill Journey Title',
    imageCreatorTitle: 'Image Creator',
    isTranslated: 'Translated',
    translationCourseDesc:
      'This course translation may take a few minutes. Thank you for your patience!',
    translateCourseTip:
      'Create a translated course that you can modify independently of the original, including all lessons and pages.',
    translateModalBtn: 'Translate',
    translationSuccess: 'Course "<0/>" has been translated successfully!',
    translatingCourse: 'Translating Course...',
    translateModalTitle: 'Translate Course',
    translateSelectLang: 'Select Language',
    fileDeleteconfirm:
      'Are you sure you want to delete this file? This cannot be undone.',
    fileDeleteMessage: 'File deleted successfully.',
    fileDeleteFailedMessage: 'File delete failed!.',
    fileDelete: 'Delete this file.',
    certificate_save_btn: 'Add Certificate to ',
    maze_path_info: 'There are no paths availabe for the graph!',
    file_size_mb: 'File size must be lower then 25 MB!',
    reports: {
      products: 'Products',
      users: 'Users',
      ph_username: 'Search user by username',
      ph_id: 'Search user by User’s ID Number',
      ph_email: 'Search user by user’s email'
    },
    select_upload_section_id: 'Section file is required',
    tags_all: 'All',
    delete_file_confirm: 'Are you sure you want to delete this file?',
    delete_file_title: 'Delete File',
    tooltip_publish: 'Publish the course on selected option',
    tooltip_save: 'Save course with current updates',
    tooltip_next: 'Go to next course setting',
    tooltip_finish: 'Complete and save current updates',
    stories_modal: {
      title_upload: 'Upload Stories',
      title_update: 'Update Stories',
      title_audio: 'Audio Story File',
      btn_upload: 'Upload',
      btn_update: 'Update',
      btn_close: 'Close',
      btn_cancel: 'Cancel',
      lbl_cover: 'Story Cover Picture',
      rule_cover: 'Please upload story audio cover!',
      lbl_title: 'Story Audio Title',
      rule_title: 'Please enter the story audio title!',
      lbl_description: 'Story Audio Description',
      rule_description: 'Please enter story audio description!',
      lbl_file: 'Upload Story Audio file',
      rule_file: 'Please upload story audio file!',
      rule_file_type: 'Please upload valid story audio file!',
      lbl_select_file: 'Select story Audio File',
      msg_valid_file: 'Please select a valid story audio file!',
      msg_success: 'Story audio file uploaded successfully',
      msg_failed: 'Failed to assign media data!',
      msg_error: 'Error uploading file!'
    },
    tags_all: 'All',
    delete_file_confirm: 'Are you sure you want to delete this file?',
    delete_file_title: 'Delete File',
    tooltip_publish: 'Publish the course on selected option',
    tooltip_save: 'Save course with current updates',
    tooltip_next: 'Go to next course setting',
    tooltip_finish: 'Complete and save current updates',
    audio_modal: {
      title_upload: 'Upload',
      title_update: 'Update',
      title_audio: 'Audio File',
      btn_upload: 'Upload',
      btn_update: 'Update',
      btn_close: 'Close',
      btn_cancel: 'Cancel',
      lbl_cover: 'Episode Cover',
      rule_cover: 'Please upload episode cover!',
      lbl_title: 'Episode Title',
      rule_title: 'Please enter the episode title!',
      lbl_description: 'Episode Description',
      rule_description: 'Please enter episode description!',
      lbl_file: 'Upload Audio file',
      rule_file: 'Please upload an audio file!',
      rule_file_type: 'Please upload valid audio file!',
      lbl_select_file: 'Select Audio File',
      msg_valid_file: 'Please select a valid audio file!',
      msg_success: 'Audio file uploaded successfully',
      msg_failed: 'Failed to assign media data!',
      msg_error: 'Error uploading file!'
    },
    info_episode: 'A cover picture for the episode.',
    btn_delete_episode: 'Delete this podcast episode.',
    btn_edit_marketplace: 'Edit Marketplace Details.',
    btn_save_marketplace: 'Save the current changes.',
    btn_ai_podcast: 'Create an AI-powered podcast episode.',
    btn_upload_podcast: 'Upload your own podcast audio episode.',
    attach_file: 'Upload files to share more content with your audience',
    fileDownload: 'Download this file.',
    singleEpishode: 'Episode',
    podcast_music: 'podcast, music & stories',
    publishHeader: 'Publish Podcasts, Music & Stories',
    editHeader: 'Edit Podcasts, Music & Stories',
    createHeader: 'Create Podcasts, Music & Stories',
    marketplaceHeader: 'Podcasts, Music & Stories Marketplace Detail',
    message_marketplace: 'Please complete marketplace form!',
    create_podcast_live: 'Live Podcast and Music',
    create_podcast_custom: 'Custom Podcast and Music',
    create_podcast_stories: 'Story',
    ai_Assisted_podcast_reation: 'AI-Assisted Podcast and Music',
    publishTitle: 'Publish podcast, music & stories for public view.',
    customButton: 'Create Custom',
    customTitle: 'Saves changes made to the podcast.',
    updateButton: 'Update',
    createButton: 'Create',
    createNewButton: 'Create New',
    updateTitle: 'Update current podcast, music & stories details.',
    createTitle: 'Create a new podcast, music & stories',
    createNewTitle:
      'New podcast, music & stories will be created on current podcast, music & stories with new input details.',
    podcastTitle: 'Episodes List',
    podcastStoryTitle: 'Stories Episodes List',
    podcastToolTipTitle: 'List of podcast episode(s)',
    uploadAudio: 'Upload Audio',
    aiAudio: 'AI Audio',
    emptyPodcast: 'No podcast, music & stories audio recorder yet.',
    emptyStoriesPodcast: 'No stories added yet.',
    emptyCreatePodcast: 'Please create podcast to be able to add audio.',
    playPodcast: 'Play the selected podcast, music & stories.',
    pausePodcast: 'Pause the selected podcast, music & stories.',
    selectPodcast: 'Select this podcast, music & stories.',
    downloadPodcast: 'Download this audio.',
    uploadAudioFile: 'Upload new audio and replace current audio.',
    deleteConfirm: 'Are you sure you want to delete this audio?',
    roomName: 'Podcast Name',
    addGuestTitle: 'ADD GUEST SPEAKER',
    showTime: 'Show Time',
    startTime: 'Start Time',
    endTime: 'End Time',
    erorMsgImg: 'Please select a valid image.',
    failedMsgImg: 'Failed to load the image. Please try again!',
    failedMsgUpload: 'Failed to upload cover image!',
    btnCoverUpload: 'Upload Cover',
    is_private: 'Private',
    to_attach: 'Attach File',
    file_attached: 'Attach File (s)',
    main_event: 'Main Event',
    event: 'Events',
    upload_pdf: 'Upload PDF',
    portrait: 'Portrait',
    landscape: 'Landscape',
    import_from_library: 'Import Text from Media Library',

    question_answer_ai: 'Question/Answer AI',
    take_maze: 'TAKE MetaMaze',
    training: 'Training',
    select_transcribe_locale: 'Select Language to Transcribe',
    transcribe_limit: 'Please Input Transcribe Minutes',
    not_complete: 'Marketplace Information Is Not Complete',
    complete: 'Marketplace Information Is Complete',
    not_admin: 'Need Admin Privilege to Publish to Marketplace',
    no_course: 'Please Input Title and Select an Image to Enable Marketplace',
    scorm_not_complete:
      'Please Input Title and Select an Image to Upload SCORM File',
    not_found_maze: 'MetaMaze Not Found',
    email_require: 'Emails Are Required',
    poll_required: 'Poll Data Is Required',
    alert: 'Alert!',
    warning: 'Warning !',
    ok: 'Ok',
    cancel: 'Cancel',
    done: 'Done',
    insert: 'Insert',
    private: 'Private',
    public: 'Public',
    no_connection: 'Internet Connection Lost',
    switch: 'Switch',
    share_screen: 'Share Screen',
    stop_share_screen: 'Stop Screen Sharing',
    share_screen_with_camera: 'Share Screen with Camera',
    stop_share_screen_with_camera: 'Stop Screen Sharing with Camera',
    camera_on: 'Camera On',
    camera_off: 'Camera Off',
    mic_on: 'Unmute',
    mic_off: 'Mute',
    fullscreen: 'Full Screen',
    live_now: 'Live Now',
    schedule_on: 'Schedule for',
    organisations: 'Organizations',
    org_groups: 'Organization Groups',
    specific_user: 'Specific User',
    gif: 'GIF',
    unavailable: 'Unavailable',
    yes: 'Yes',
    no: 'No',
    event_duration_message: 'Maximum 300 minutes (5 hours)',
    send_email: 'Send E-mail Notification',
    admin_only: 'Admin Only',
    join: 'Join',
    leave: 'Leave',
    share: 'Share',
    share_text:
      'Please type the email address of whom you want to share this file with.',
    share_text_title: 'Share PDF',
    share_text_title_txt: 'Share Text',
    select_users: 'Select Users',
    delete: 'Delete',
    attachment_event: 'Attachments for the event:',
    transcribe_limit: 'Transcribe Minutes',
    monthly_transcribe: 'Monthly Transcribe Limit:',
    enable_ai: 'Enable AI:',
    enable_maze: 'Enable MetaMaze:',
    media_service: 'Media Service',
    allow_others: 'Allow Others to Edit',
    join_breakout_room: 'Join Breakout Room',
    bio: 'Bio',
    linkedin: 'LinkedIn',
    select_org_report:
      'Please find and choose an organization to generate report.',
    org_image_not_found: 'Image Not Found',
    insert_text: 'Insert Text',
    insert_question_answer: 'Question/Answer AI',
    modal_title2: 'Text Gallery',
    my_text_library: 'My Text Library',
    ai: 'AI',
    public_text_library: 'Public Text Library',
    organization_text_library: 'Organization Text Library',
    no_transcribed_text: 'No Transcribed Text Found',
    public_text_not_found: 'Public Transcribed Text Not Found',
    org_text_not_found: 'Organization Transcribed Text Not Found',
    org_video_not_found: 'Video Not Found',
    canva: 'Do it from Canva',
    canva_open: 'Click here to open Canva editor.',
    pdf: 'PDF',
    txt: 'TEXT',
    human: 'Premium',
    shared_file: 'Your file has successfully been shared.',
    error_shared_file: 'There is problem with sharing file. Please try again.',
    publish: 'Publish',
    maze_scenes: 'MetaMaze Scenes',
    pexel_images: 'Pexel Images',
    group: 'Group',
    group_name: 'Group Name',
    select_group: 'Select Group',
    search_maze: 'Search MetaMaze',
    hosts: 'Hosts',
    avg_score: 'Percentage Score',
    maze_report: 'Maze Report',
    maze_view: 'Maze View',
    title_maze: 'MetaMaze',
    author: 'Author',
    match: 'Path Match',
    preview_mazeTitle: 'Title: ',
    other: 'Other',
    total: 'TOTAL',
    report_course: 'COURSE',
    report_courses: 'COURSES',
    report_event: 'EVENT',
    report_events: 'EVENTS',
    report_maze: 'MAZE',
    report_personalize_learning: 'PERSONALIZE LEARNING',
    report_live_assessment: 'LIVE ASSESSMENT',
    report_live_assessments: 'LIVE ASSESSMENTS',
    report_skill_journey: 'SKILL JOURNEY',
    skill_journey: 'Skill Journey',
    skill_journeys: 'Skill Journeys',
    date: 'DATE: ',
    search_people: 'Search People',
    passed: 'PASSED',
    failed: 'FAILED',
    item: 'ITEM',
    type: 'TYPE',
    minimum_pass_score: 'MINIMUM PASS SCORE',
    resources_count: 'RESOURCES COUNT',
    back: 'BACK',
    resources: 'RESOURCES',
    time_spent: 'TIME SPENT (MINUTES)',
    detail: 'DETAIL',
    watched_time_mins: 'WATCHED TIME (MINUTES)',
    personalize_learning: 'Personalize Learning',
    result: 'Result',
    assessment_title: 'Title',
    marketPlace_graph: 'Marketplace Graph',
    attachments: 'Additional Attachments',

    new_scorm_course: 'Upload a New SCORM Course',
    upload_scorm_course: 'Upload SCORM Course',
    new_maze: 'Create a New MetaMaze',
    new_skill_journey: 'Create a Skill Journey',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Skill Journey',
    new_discussion_room: 'Create a New Podcast',
    title: 'What do you want to do today?',
    build_course: 'Build My Course',
    live_broadcast: 'Live Broadcast',
    invite_users: 'Invite Users to My Organization',
    build_voice_over: 'Build My Voiceover',
    view_reports: 'View Reports',
    upload_media: 'Upload My Media or Work and Share It',
    main_menu: 'Main Menu',
    get_started: 'GET STARTED',
    search_group: 'Search Organization Group',
    ai_course: 'AI Course',
    search_user: 'Search Name of Company',
    no_maze: 'There are currently no MetaMaze.',
    conference_event_title: 'Conference Events',
    conference_event_subTitle: 'Finished Conference Events',
    conference_event: 'There are currently no conference events.',
    no_skill: 'There are currently no skill journeys.',
    no_podcast: 'There are currently no podcast.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Past Live Assessments',
    no_live_assessment: 'There are currently no live assessments.',
    enrolled_courses: 'Courses',
    my_video_channel: 'My Video Channels',
    enrolled_liveEvents: 'Live Events',
    sharebot: 'Sharebot',
    selected_language: 'Selected language',
    shareSphere_game: 'ShareSphere Game',
    maze: 'MetaMaze',
    skill: 'Skill Journey',
    channel: 'Channel',
    order: 'Order',
    is_record: 'Record',
    no_maze_found: 'No MetaMaze found.',
    maze_self_limit_reached: 'MetaMaze self assessment limit reached.',
    metamaze_two_times: 'You have already taken this metamaze 2 times.',
    metamaze_two_times_no_result:
      'You have already taken this metamaze 2 times. Your result will not be tracked for completing this self assessment after the second time.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Minimum Score to Pass',
    organization: 'Please Select an Organization',
    pass_score_mark: 'Please Input Marks Between 1 to 100',
    maze_cloning_success: 'MetaMaze "<0/>" has been cloned successfully!',
    create_certificate: 'Create a Certificate',
    create_badge: 'Create a Badge',
    certificate_added: 'Certificate Added',
    badge_added: 'Badge Added.',
    certificate_warning:
      'You cannot edit the certificate/ badge once it is published!',
    created_course_plan:
      'Edit and publish your created course and plan live events',
    market_place_space: 'Market Place',
    select_course_language: 'Select language',
    select_language: 'Select language',
    file_upload: 'File upload',
    text: 'Write text here…',
    attempts_count: 'Number of Attempts a User Can Retry',
    no_of_people_placeholder: 'Number of People',
    back_to_maze: 'Back to MetaMaze Scenario',
    edit_maze: 'Edit Maze',
    wait: 'Wait...',
    retry: 'Retry',
    publish_scorm_course: 'Publish Your SCORM Course',
    publish_maze: 'Publish Your MetaMaze',
    import: 'Import Elements',

    answer_correct: 'Choose the Correct Answer',
    author_name: `Please Input Author's Name`,
    select_category: 'Please Select a Category',
    course_outline: 'Please Input Course Outline',
    course_obj: 'Please Input Course Objectives',
    course_description: 'Please Input Course Description',
    maze_outline: 'Please Input Maze Outline',
    maze_obj: 'Please Input Maze Objectives',
    maze_description: 'Please Input Maze Description',
    lessons: 'Please Input Number of Lessons',
    user_email_require: `User Email Is Required`,
    team_size: `Team Size Is Required`,
    enter_price: 'Please Enter a Price (5 or More)',
    input_title_maze: 'Please Input Maze Title',
    trainer_bio: 'Please Input Trainer’s Bio',
    trainer_linkedin: 'Please Input the Trainer’s LinkedIn',
    error_video: 'Please Input Number of Videos',
    input_video_link: 'Please Input Video Link',
    number_of_video: 'number of videos',
    number_of_lessions: 'number of lessons',
    no_of_people_in_conference: 'How many people in the conference?',
    transcribe_settings: 'Transcribe Settings',
    transcribe: 'Transcribe',
    cloning_maze: 'Cloning MetaMaze...',
    id_number: 'ID Number',
    timezone: 'Time Zone',
    edit_maze: 'Edit',
    delete_maze: 'Delete',
    view_maze: 'View',
    create_metamaze: 'Create a MetaMaze',
    metamaze_scenario: 'MetaMaze Scenario',
    publish_metamaze: 'Publish setting',
    search_result: 'Search Results:',
    search_for: 'Search for',
    search_no_result: '- No results available !',
    channel_no_available: 'No channel is available !',
    this_card: 'This is a card',
    course_no_available: 'No courses available !',
    exit_fullscreen: 'Exit Full Screen',
    bg_image: 'Background Image',
    introduction: 'Introduction',
    summary: 'Summary',
    generate_introduction: 'Generate Introduction',
    bullet_points: 'Bullet Points',
    title_simulation: 'Please Input Simulation Name',
    view_generated_images: 'View Generated Images',
    image_transparency: 'Image Transparency',
    template_bg_color: 'Template Background Color',
    select_template_layout: 'Select a Template Layout',
    reload_template: '(Reload templates)',
    are_you_sure_want_close: 'Are you sure you want to close?',
    all_your_changes_will_be_lost: 'All your changes will be lost.',
    please_checked_before_generated_video:
      'Please confirm all the conditions are checked before generating a video.',
    voice_must_be_selected: 'A voice must be selected',
    avatar_must_be_selected: 'An avatar image must be selected.',
    maximum_five_slides_try_again:
      'Error during extracting images from your file. Make sure there are maximum 5 slides in your file and there are notes in each slide. Please Try Again !',
    back_to_upload: 'Back to Upload',
    uploading_file_to_server: 'Uploading your file to the server',
    extracting_images_from_your_file: 'Extracting images from your file',
    upload_your_ppt_or_drag:
      'Upload your presentation file (.PPTX) or drag it here.',
    maximum_five_slides_error:
      'Please make sure your PowerPoint file contains maximum 5 slides and there are notes in each slide.  Otherwise, it will result in an error.',
    number_of_questions_generated: 'Number of Questions to be generated',
    quiz_page_this_cannot_be_done:
      'Are you sure you want to add the quiz to this page? This cannot be undone.',
    confirm_selection: 'Confirm Selection',
    select_quiz_page: 'Select Quiz Page',
    lesson_do_you_want_add_this_quiz:
      'Which part of the lesson do you want to add this quiz?',
    beginning_of_lesson: 'At the Beginning of Lesson',
    end_of_lesson: 'End of Lesson',
    currently_active_page: 'Currently Active Page',
    finish: 'Finish',
    upload_selection_file: 'Upload Section file',
    general_quiz: 'General Quiz',
    manage_sequence: 'Manage sequence',
    save_sequence: 'Save sequence',
    new: 'New',
    in_progress: 'In Progress',
    recommended_course: 'Recommended Course',
    up_coming: 'Upcoming',
    past_live: 'Past Live',
    input_your_channel_name: 'Please input the name of your Channel!',
    organization_place: 'Organization Marketplace',
    marketplace_report: 'Marketplace Report',
    story_writing: 'Story Writing',
    Ai_quiz: 'AI Quiz',
    generate_quiz: 'Generate Quiz',
    create_story: 'Create Story',
    change_layout_page: 'You are about to change the layout of this page.',
    change_layout_message:
      'Please note that only the text, images, background and logo will be retained. All other elements will be removed from the page.',
    reviews: 'Reviews',
    tab_attachments: 'Attachments',
    zoom_in: 'Zoom In',
    zoom_out: 'Zoom Out',
    zoom_reset: 'Reset Zoom',
    no_attachment: 'No attachments.',
    select_upload_simulation: 'Please select/upload simulation.',
    quiz_updated_successfully: 'Quiz updated successfully !',
    quizes: 'Quizes',
    trivia: 'Trivia',
    closing: 'Closing...',
    products: 'Products',

    ask_questions: 'Ask a question here...',
    course_information: 'Course Information',
    course_assistance: 'Course Creator Assistance',
    go_back: 'Go Back',
    ai_generate_content_progress: 'Generating Content Progress',
    view_generate_content: 'View Generated Content',
    generate_error: 'Generation Error !',
    confirm_creating_course:
      'Do you want to confirm creating course using this content?',
    generate_content_automatically:
      'This will add all the generated content as lessons and pages to your course automatically.',
    quiz_created_successfully: 'Quiz created successfully !',
    create_quiz: 'Create Quiz',
    quiz_setting: 'Quiz Setting',
    please_fill_quiz_setting: '* Please fill all the fields in Quiz Setting',
    question_list: 'Questions List',
    add_quiz_to_page: 'Add Quiz to Page',
    form_create_question: 'Form Create a Question',
    user_information_updated: 'User Information Updated !',
    your_stripe_activete_to_continue:
      'Your Stripe account is inactive. Please connect or activate it to continue.',
    connect_tripe: 'Connect Stripe',
    certificate_sent_sucessfully:
      'Certificate sent to your email successfully.',
    error_try_again: 'Error. Try Again !',
    error_delete_channel: 'Error deleting channel.',
    error_update_sub: 'Error updating subscription.',
    end_time_cannot_start: 'End time cannot be before start time.',
    start_date_time_interval: 'Start Date and Time interval are required!',
    podcast_updated_successful: 'Podcast successfully updated.',
    podcast_created_successful: 'Podcast successfully created.',
    podcast_published_successful: 'Podcast successfully published',
    podcast_cover_updated: 'Podcast cover updated',
    new_podcast_details:
      'New podcast will be created on current podcast with new input details.',
    current_update_podcast: 'Update current podcast, music & storiesdetails.',
    create_new_podcast: 'Create a new podcast',
    publish_podcast_public_view: 'Publish podcast for public view.',
    only_allowed_twenty_five_email: 'Only 25 emails is allowed',
    only_allowed_five_email: 'Only 5 emails is allowed.',
    cover_is_required: 'Cover is Required.',
    topic_is_required: 'Topic is Required.',
    delete_schedule: 'Delete Schedule',
    make_as_coaching: 'Mark as Coaching Availability',
    manage_category: 'Manage Category',
    threshold: 'Threshold',
    threshold_popup:
      'Threshold value in percentage(%), the value after which the recommendation is activated for the given category.',
    list_of_catagory: 'List of category',
    category_name: 'Category Name',
    category_threshold: 'Category Threshold',
    play_game: 'Play Game',
    switching_organization: 'Switching Organization...',
    coaching_session: 'Coaching Session',
    video_link: 'Please input video link', // to translate
    required_channel_id: 'Channel Id is required!',
    error_occured_try_again: 'Error occured. Try Again !',
    please_complete_marketplace_form: 'Please complete marketplace form!',
    upload_file_corrupt: 'Uploaded file is corrupt.',
    course_not_published: 'Course is not published yet !',
    error_request: 'Error in request. Please try again!',
    skill_request: 'Please complete missing fields!',
    error_occured: 'Error occured. Try Again !',
    show_time: 'Show Time',
    start_time: 'Start Time',
    end_time: 'End Time',
    room_name: 'Podcast Name',
    add_guest_speaker: 'Add Guest Speaker',
    cover_picture: 'Cover Picture',
    guest_speaker: 'Guests Speaker',
    see_more: 'See More',
    see_less: 'See Less',
    background: 'Background',
    icon: 'Icon',
    icon_size: 'Icon Size',
    icon_color: 'Icon Color',
    only_text: 'Text',
    change_bg: 'Change background color',
    bg_color: 'Background Color',
    font_size: 'Font size',
    normal: 'Normal',
    change_color: 'Change text color',
    slant_text: 'Slant text',
    text_radius: 'Text Radius',
    vertical_align: 'Vertical Align',
    horizontal_align: 'Horizontal Align',
    change_icon_color: 'Change icon colour',
    upload_icon: 'Upload Icon',
    upload_signature: 'Upload Signature',
    add_another_sign: 'Add another signature',
    name_badges: 'Name of Badges',
    should_less_150: 'should be 150 characters or less',
    your_badge: 'Your Badge',
    do_you_want_delete_badge: 'Are you sure you want to delete this badge ??',
    do_you_want_delete_cert:
      'Are you sure you want to delete this certificate ??',
    upload_logo: 'Upload Logo',
    name_of_cert: 'Name of Certificate',
    upload_cert: 'Update Certificate',
    your_cert: 'Your Certificate',
    translate_to: 'Translate to',
    select_file_attach: 'Select File To Attach',
    certificate: 'Certficate',
    badge: 'Badge',
    publish_options: 'Publish options',
    publish_skills_journey: 'Publish Skill Journey',
    videos: 'Video List',
    generate_ai_video:
      'Video generation process may take some time. You will be notified with an email once its completed.',
    trainer_information: 'Trainer Information',
    promotional_video_link: 'Promotional Video Link',
    please_select: 'Please select',
    image_name: 'Image name:',
    image_size: 'Image size:',
    charecters_fifteen_less: '15 characters or less',
    leadership: 'Leadership',
    text_arc: 'Text arc',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    badge_history: 'Badge History',
    templates: 'Templates',
    sign: 'Signature',
    logo: 'Logo',
    certificate_history: 'Certificate History',
    please_wait: 'Please Wait...',
    information: 'Information',
    support_five_thousand_live_event:
      'Supports up to 5000 participants for the event',
    support_ten_live_event: 'Support up to 10 live video participants',
    we_will_back_participant:
      "We'll be back with the event having access to huge participants.",
    course_objectives: 'Course Objectives',
    course_outlines: 'Course Outline',
    you_have: 'You have',
    more_attempt: 'more attempt(s) remaining',
    price_dollor: 'price (usd)',

    // not translated added by prabin
    not_completed: 'Not Completed',
    enable_marketplace: 'Enable MarketPlace',
    enable_course_ai: 'Enable Course Creation with AI',
    enable_report_to_admin: 'Enable Showing Reports to Admin',
    enable_white_label: 'Enable White Label',
    enable_eleven_labs_for_maze_play: 'Enable Elevenlabs for Maze Play',
    enable_eleven_labs_for_maze_play_cloned: 'Enable Elevenlabs Cloned Voices',
    enable_shorts_for_org: 'Enable Shorts',
    enable_custom_sop: 'Enable Custom SOP',
    generate_video_text: 'Generate AI Video',
    enable_cloned_voice_maze: 'Enable Clone voice Maze',
    roles_and_permissions: 'Roles and Permissions',
    limit_fifty_words: 'should be 50 characters or less',
    bg_image: 'Background Image',
    roles_and_permissions: 'Roles and Permissions',
    introduction: 'Introduction',
    summary: 'Summary',
    generate_introduction: 'Generate Introduction',
    generate_summary: 'Generate Summary',
    title_simulation: 'Please Input Simulation Name',
    view_generated_images: 'View Generated Images',
    template_bg_color: 'Template Background Color',
    select_template_layout: 'Select a Template Layout',
    reload_template: '(Reload templates)',
    are_you_sure_want_close: 'Are you sure you want to close?',
    all_your_changes_will_be_lost: 'All your changes will be lost.',
    please_checked_before_generated_video:
      'Please confirm all the conditions are checked before generating a video.',
    voice_must_be_selected: 'A voice must be selected',
    avatar_must_be_selected: 'An avatar image must be selected.',
    maximum_five_slides_try_again:
      'Error during extracting images from your file. Make sure there are maximum 5 slides in your file and there are notes in each slide. Please Try Again !',
    back_to_upload: 'Back to Upload',
    uploading_file_to_server: 'Uploading your file to the server',
    extracting_images_from_your_file: 'Extracting images from your file',
    upload_your_ppt_or_drag:
      'Upload your presentation file (.PPTX) or drag it here.',
    maximum_five_slides_error:
      'Please make sure your PowerPoint file contains maximum 5 slides and there are notes in each slide.  Otherwise, it will result in an error.',
    number_of_questions_generated: 'Number of Questions to be generated',
    quiz_page_this_cannot_be_done:
      'Are you sure you want to add the quiz to this page? This cannot be undone.',
    confirm_selection: 'Confirm Selection',
    select_quiz_page: 'Select Quiz Page',
    lesson_do_you_want_add_this_quiz:
      'Which part of the lesson do you want to add this quiz?',
    beginning_of_lesson: 'At the Beginning of Lesson',
    end_of_lesson: 'End of Lesson',
    currently_active_page: 'Currently Active Page',
    finish: 'Finish',
    upload_selection_file: 'Upload Section file',
    general_quiz: 'General Quiz',
    simulation_quiz: 'Simulation Quiz',
    bg_color_setting: 'Background Color Settings',
    color_preview: 'Color Preview',
    choose_new_color: 'Choose New Color',
    remove_color: 'Remove Color',
    apply_color: 'Apply Color',
    elemeent_in_a_sceenario_page:
      'You cannot add other element in a scenario page. Please try other pages or remove the scenario from the page first.',
    no_data_found: 'No Data Found.',
    references: 'References',
    open_file: 'Open File',
    showing_result: 'Showing Results:',
    fiften_day_free_trail: '15-Day Free Trial',
    your_browser_does_not_support:
      'Your browser does not support the audio element.',
    podcast_desc: 'Podcast Topic Description',
    input_podcast_desc: 'Please Input Podcast Description',
    podcast_obj: 'Podcast Objectives',
    input_podcast_obj: 'Please Input Podcast Objectives',
    podcast_outline: 'Podcast Outline',
    input_podcast_outline: 'Please Input Podcast Outline',
    add_file: 'Add File',
    generate_podcast_audio: 'Generate Podcast Audio',
    generate_uploaded_file_input_parameter:
      'Generates the content relative to the user uploaded files with the given input parameters.',
    go_backe_generation_state: 'Go back to content generation state.',
    create_ai_powered_podcast:
      'Create an AI-powered podcast episode(s) with generated audio.',
    generate_voice_for_all_podcast:
      'Please generate voice for all podcast epishode(s)',
    create_podcast_episode: 'Create Podcast Episode',
    voice_name: 'Voice Name',
    input_custom_name: 'Please input a custom name!',
    enter_custom_name: 'Enter custom voice name',
    upload_complete: 'upload complete',
    uploading_in_progress: 'uploading in progress...',
    podcast_stream_content: 'Podcast Content Stream',
    upload_podcast_cover: 'please upload podcast cover!',
    enter_podcast_name: 'Please enter the podcast name!',
    podcast_topic: 'Podcast Topic',
    enter_podcast_topic: 'Please enter the podcast topic!',
    enter_podcast_desc: 'Please enter the podcast description!',
    number_of_speaker: 'Number of Speakers',
    select_the_number_of_speaker: 'Please select the number of speakers!',
    number_of_episode: 'Number of Episodes',
    input_number_of_episode: 'Please input number of episode!',
    podcast_length: 'Podcast Length',
    select_the_podcast_length: 'Please select the length of the podcast!',
    short_podcast: 'Short (5-10 min)',
    medium_podcast: 'Medium (15-18 min)',
    long_podcast: 'Long (18+ min)',
    name_of_host: 'Name of the Host',
    enter_host_name: 'Please enter the host name!',
    guest_name: 'Name of guests',
    enter_guest_name: 'Please enter the guest name!',
    choose_speaker_tone: 'Choose tone of Speaker',
    enter_speaker_tone: 'Please select the tone of the podcast!',
    informal: 'Informal',
    formal: 'Formal',
    serious: 'Serious',
    light_humor: 'Light Humor',
    casual: 'Casual',
    select_content_source: 'Select Content Source',
    from_internet: 'From the Internet',
    upload_pdf_internet: 'Upload a PDF or Internal Document',
    note: 'Note:',
    podcast_content_will_be_automatically_generated:
      'The podcast content will be automatically generated using trusted internet sources.',
    upload_or_select_file: 'Please upload or select file(s)!',
    podcast_eposode_title: 'Podcast Episode Title',
    enter_podcast_title: 'Please enter the episode title!',
    podcast_episode_des: 'Podcast Episode Description',
    enter_podcast_episode_des: 'Please enter the podcast episode description!', // to translate
    voice: 'Voice',
    music: 'Music',
    select_music: 'Select music',
    play_the_music: 'Play the music',
    stop_the_music: 'Stop the music',
    context: 'Context',
    generate_audio_content_selected_voice:
      'This will generate the audio of the content according to selected voices.',
    required_field_before_submitting:
      'Please fill in all the required fields before submitting.',
    regenerate_voice: 'Regenerate to Voice',
    generate_voice: 'Generate to Voice',
    your_browser_does_not_suppot:
      'Your browser does not support the audio element.',
    are_sure_leave_podcast: 'Are you sure to leave podcast?',
    broadcast_ongoing:
      'The broadcast is ongoing. Do you really want to navigate away from this page?',
    brodcaster_unavailable: 'Currently broadcaster is unavailable.',
    setting_calender_for_booking: 'Setting Calendar For Booking',
    add_calender: 'Add Calendar',
    waiting_join_host: 'Waiting for host to join...',
    no_reviews_found: 'No Reviews Found.',
    rated_already: 'You have already rated this live event.',
    downlink_png: 'downlink_png',
    downlink_jpg: 'downlink_jpg',
    donwload_file_format: 'Please select the file format you want to download.',
    crashed_event:
      'This event is crashed. You need to create new event. Sorry for the inconvenience.',
    prompt: 'Prompt:',
    generated_image: '🚀 Generating your image... Please wait.',
    download_add: 'Download all',
    setting_generator: 'Setting Generator',
    enter_image_prompt: 'Please enter a image prompt',
    image_prompt: 'Enter your image prompt',
    negative_prompt: 'Negative Prompt',
    negative_image_prompt: 'Enter your negative image prompt',
    number_output: 'Number of Outputs',
    enter_number_output: 'Please enter number of outputs',
    image_style: 'Please select style for image',
    output_format: 'Output Format',
    seeds: 'Seeds',
    enter_seeds: 'Please enter number of seeds',
    performance_mode: 'Performance Mode',
    quality: 'Quality',
    speed: 'Speed',
    balanced: 'Balanced',
    guidance_scale: 'Guidance Scale',
    enter_guidance: 'Please enter guidance scale',
    select_image: 'Please select image.',
    image_prmt: 'Image Prompt',
    generate_image_list_empty: 'Generated image list is empty.',
    knowledge_center_tooltrip_des:
      'Get concise and contextually accurate responses to a wide range of queries including general knowledge questions. The responses are obtained from the general information on the internet from an AI model trained from a diverse range of internet text.',
    contexts: 'Contexts',
    ai_processing_video_sharebot:
      'AI processing of the video will take about 24 hours to complete and reflect on Sharebot.',

    remove_sharebot_video: `If you wish to remove the video's reference to Sharbot, please delete the corresponding transcript along with the video.`,
    remove_sharebot_video_audio:
      'Deleting the transcript will remove the associated video/audio reference to Sharebot, but the video will still appear in the media library/channel.',
    monthly_live_stream:
      'To change your monthly live-streaming limit please contact',
    monthly_transcribe_limit:
      'To change your monthly transcribe limit please contact',
    must_be_one_to_three_hundred: 'Must be between 1 to 300 minutes.',
    all_field_required: 'All fields are required.',
    duration_minute: 'Duration (maximum 300 minutes)',
    gender: 'Gender',
    select_gender: 'Select Gender',
    accent: 'Accent',
    select_accent: 'Select Accent',
    create_voice: 'Create Voice',
    enter_voice_name: 'Enter Voice Name',
    select_voice_gender: 'Please select voice gender',
    upload_voice: 'Upload Your Voice',
    upload_voice_mp_three: 'Upload your voice (.mp3)',
    cloned_voice: 'Cloned Voices',
    voice_type: 'Voice Type',
    select_voice_type: 'Select Voice Type',
    sharelook_stand: 'Standard',
    sharelook_premium: 'Premium',
    sharelook_custum_voice: 'Custom (Voice Cloning)',
    create_auto_flow: 'Create auto flow',
    how_many_layers: 'How many layers',
    verify_selection: 'Verify Selection',
    uploaded_successful: 'Uploaded successfully',
    upload_failed: 'Upload failed',
    upload_only_five_mb: 'Upload Content (max 5)',
    docs_from_org_library: 'Use Document from Organization Library',
    docs_from_org_library_sop: '(SOP)',
    failed_maze_generate: 'Failed to generate maze. Please try again.',
    generate_metamaze: 'Generating MetaMaze...',
    metamaze_being_generated:
      'Your metamaze is currently being generated. You will be notified via email once the process is complete.',
    metamaze_generate_successfully: 'MetaMaze Generated Successfully!',
    metamaze_with_proceed: 'You can now proceed with the metamaze.',
    ai_metamaze_generate: 'AI Metamaze Generation',
    what_kind_maze_create: 'What kind of maze would you like to create?',
    manual_metamaze_creation: 'Manual Metamaze Creation',
    manually_maze_customizing_scnario:
      'Manually create a maze by customizing the scenario and option tree',
    maze_ai_generated: 'Automatically generate a maze with AI',
    unmark_deadend: 'Unmark as deadend',
    mark_deadend: 'Mark as deadend',
    select_multiple_image_for_scenario:
      'You can select multiple images for the scenario.',
    select_your_image: 'Your selected images',
    click_to_preview: 'Click to preview',
    are_you_sure_delete_image: 'Are you sure to delete this image?',
    select_image_from_library: 'Select Image from the Media Library',
    uploading_video: 'Uploading video...',
    tree_node_type: 'Tree Node Type',
    correct_option_scenario: 'Correct Option or Scenario',
    incorrect_option: 'Incorrect Option',
    option_scenario_without_text: 'Option or Scenario without any text in it',
    dead_end: 'Dead End (Red Border)',
    correct_path: 'Correct Path',
    incorrect_path_not_selected_correct_option_path:
      'Incorrect Path / Path where correct option is not selected.',
    double_click_on_tree_node:
      'When you double-click on a tree node, the text editor will automatically scroll to display the content of that specific node in the view.',
    add_scenario: 'Add Scenario',
    add_option: 'Add Option',
    an_error_occured: 'An error occurred:',
    download_summary: 'Download Summary',
    step_wise_analysis: 'Step-Wise Analysis',
    step: 'Step',
    upload_csv_file: 'Upload CSV File',
    download_template_to_import: 'Download sample template to import',
    please_input_email: 'Please input email.',
    email_at_least_three_characters: 'Email must be at least 3 characters.',
    email_cannot_be_empty: 'Email cannot be empty.',
    input_email_in_new_line:
      'Please input emails (each email is on a new line)',
    role: 'Role',
    select_role: 'Please select a Role',
    select_group: 'Please select a Group',
    identification_number: 'Identification number (Optional)',
    add_identification_number: 'Please add a Identification number',
    pie_chart_of_all_categories:
      'Pie chart of all categories based on their use on sharelook.',
    total_sharesphere_question_answered_by_users:
      'Total ShareSphere questions answered by the users in the current organization, with these categories and their respective results of success and failures.',
    voice_style_over_the_text: `Where you can use many voice stlye over the text that you type bla Bla bla Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,`,
    input_your_question: 'Please input your question!',
    make_me_sales_manager: 'eg: What can make me a sales manager',
    enter_the_number_relevant_document:
      'Enter the number of relevant documents',
    please_wait_loading_result: 'Please wait loading results...',
    no_result_found: 'No results found, Try asking more questions',
    browser_doesnot_support_iframes: 'Your browser doesnot support iframes',
    total_duration: 'Total Duration',
    number_of_messages: 'Number of Messages',
    search_result: 'Search results',
    count_result: '(1244 results)',
    your_other_interests: 'Your other interests',
    your_total_score: 'Your Total Score',
    add_a_question: '+ Add a question',
    travia_question_empty: 'Travia question list is empty.',
    video_generation_is_on_queue: 'Your video generation is on queue !',
    checking_video_status: 'Checking video status...',
    total_quizzes: 'Total Quizzes',
    number_of_votes: 'Number of Votes',
    total_events: 'Total Events',
    number_of_rates: 'Number of Rates',
    number_of_likes: 'Number of Likes',
    all_courses: 'All Courses',
    total_questions: 'Total Questions',
    no_skill_journey: 'No skill journey is available!',
    search_no_results: '- no results available!',
    no_image_generated: 'No Images Generated !',
    all_topic_in_this_lesson:
      'All topics in this lesson will be deleted. This cannot be undone.',
    content_has_been_generated: 'Content has been generated for this topic.',
    update_course_template: 'Update Course Template',
    add_course_template: 'Add Course Template',
    create_course_now: 'Create Course Now',
    preview_course: 'Preview Course',
    layout: 'Layout',
    import_from_youtube: 'Import from Youtube',
    my_media_library: 'My Media Library',
    bg_added: 'Background added',
    add_bg: 'Add Background',
    booked_schedule: 'Booked Schedule',
    add_schedule: 'Add schedule',
    are_you_delete_schedule: 'Are you sure delete this schedule?',
    add_task: 'Add Task',
    update_calender: 'Update Calendar',

    // new translate
    manage_cookies: 'Manage Cookies',
    cookie_banner_text:
      'We use cookies to enhance your browsing experience, analyze website traffic, and personalize content. Your privacy is important to us.',
    accept_all_cookies: 'Accept All Cookies',
    reject_all: 'Reject All',
    customize: 'Customize',
    cookie_preferences_title: 'Cookie Preferences & Privacy Settings',
    privacy_subtitle:
      "Your privacy matters to us. Choose which cookies you're comfortable with. You can change these settings at any time.",
    save_choices: 'Save My Choices',
    strictly_necessary: 'Strictly Necessary',
    strictly_necessary_desc:
      'These cookies are essential for the website to function properly. They enable basic functionality like page navigation, form submissions, and access to secure areas. The website cannot function properly without them.',
    analytics_performance: 'Analytics & Performance',
    analytics_performance_desc:
      "These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve our website's performance and user experience.",
    advertising_marketing: 'Advertising & Marketing',
    advertising_marketing_desc:
      'These cookies are used to make advertising messages more relevant to you. They prevent the same ad from continuously reappearing and ensure ads are properly displayed for advertisers.',
    tracking_social: 'Tracking & Social Media',
    tracking_social_desc:
      'These cookies enable enhanced functionality and personalization, such as social media features and personalized content. They may be set by us or by third-party providers.',
    functional: 'Functional',
    functional_desc:
      'These cookies enable enhanced functionality like chat support, live help, and other interactive features that improve your experience on our website.',
    your_rights: 'Your Rights:',
    rights_description:
      'You can withdraw your consent at any time, access your data, or request its deletion at any time.',
    withdraw_consent: 'Withdraw All Consent',

    how_many_options: 'How many options',
    add_content: 'Add Content',
    downloads_center: 'Downloads Center',
    sharelook_help_center: 'Sharelook Help Center',
    channel_outline: 'Channel Outline',
    channel_objectives: 'Channel Objectives',
    no_sop_available: 'No sop list available.',
    no_sop_available: 'No sop list available.',
    generate_world_summary: 'Generate Scenario',
    generate_world_summary: 'Generate Scenario',
    world_scenario: 'Real World Scenario',
    drag_icon_hint: 'Tip: Drag the icon on the canvas to position it',
    drag_text_hint: 'Tip: Drag the text on the canvas to position it',
    edit_badge: 'Edit Badge',
    create_new_badge: 'New Badge',
    select_video_preview: 'Select a video to preview',
    certificate_title_required: 'Certificate Title is required',
    discard_changes: 'Discard Changes',
    edit_certificate: 'Edit Certificate',
    add_another_logo: 'Add Another Logo',
    optional: 'Optional',
    doc: 'DOC',
    ppt: 'PPT',
    sharelook_assistance: 'Sharelook Coaching',
    upload_scorm_zip: 'Upload Scorm Zip',
    only_letters_numbers_space_dot_allowed:
      'Only letters, numbers, spaces, and dots are allowed!',
    video_playing: 'Playing',
    course_price_message: `*The course will only be published to users within the organization and cannot be resold on the marketplace.`,
    lesson_must_be_positive: 'Number of Lessons must be greater then 1',
    btn_proceed: 'Proceed',
    rule_select_music: 'Pleae select music',
    course_info: 'Course Info',
    content_selection: 'Content Selection',
    course_content_source: 'Course Content Source',
    choose_how_to_source: 'Choose how to source content for this course:',
    automatic_selection: 'Automatic Selection',
    system_will_automatically_select_relavant_documents:
      'System will automatically select relevant documents from your library',
    manual_selection: 'Manual Selection',
    choose_specific_documents_from_your_library:
      'Choose specific documents from your library',
    upload_files: 'Upload Files',
    upload_new_documents:
      'Upload new documents (PDF, DOC, DOCX, PPT, PPTX, TXT) - Maximum 5 files',
    file: 'file',
    ready_to_upload: 'ready to upload',
    clear_all: 'Clear All',
    confirm_course_wide_premiew: 'Confirm Course-wide Preview',
    generate_course_preview: 'Generate Course Preview',
    instructions_across_the_course_to_generate:
      "We'll apply your instructions across the course to generate a preview. Review everything first, then choose to keep or discard changes.",
    instruction_to_preview_course_wide: 'Instructions to preview course-wide:',
    edit_content: 'Edit Content',
    manage_course_template: 'Manage Course Template',
    undo: 'Undo',
    apply_changes: 'Apply Changes',
    characters: 'characters',
    apply_all: 'Apply All',
    apply_to_all: 'Apply to All',
    use_this_content: 'Use This Content',
    original: 'Original',
    edited: 'Edited',
    edited_content_preview: 'Edited Content Preview',
    apply_edits_to_all_topices: 'Apply edits to all topics?',
    current_editing_instructions_across_the_whole_course:
      'This will apply your current editing instructions across the whole course. You can review the combined preview before saving.',
    edit_content_instructions: 'Edit Content Instructions',
    generate_content_for_this_topic_instruction:
      'Generate content for this topic using your instructions',
    descrip_edit_content:
      'Describe how to edit this content (e.g., shorten, simplify, rephrase)',
    try_short_clear_direcctives: `Try short, clear directives. Examples: “reduce to 100 words, keep key points”, “simplify language”, “make more concise and remove filler”.`,
    we_preserve_the_core_meaning:
      'We preserve the core meaning while applying your instructions.',
    feedback_optional: 'Feedback (Optional)',
    write_your_feedback_here: 'Write your feedback here',
    from_web: 'From Web',
    from_desktop: 'Create in ELearning App',
    from_org_library: 'Add from Organization library',
    pleae_wait_processing: 'Please wait processing...',
    create_simulation_from_screen_capture:
      'Create Simulation from Screen Capture',
    sharelook_not_found: 'ShareLook Not Found',
    sharelook_screen_capture_application_not_be_opened:
      'ShareLook Screen Capture application could not be opened. It may not be installed on your computer.',
    download_sharelook: 'Download ShareLook',
    launch_sharelook_application: 'Launch ShareLook Application',
    this_will_open_the_sharelook_application_for_screen_capture:
      'This will open the Sharelook Screen Capture Application for screen capture.',
    sharelook_dosenot_open:
      "If ShareLook doesn't open, it may not be installed on your computer.",
    open_sharelook: 'Open ShareLook',
    download_app: 'Download App',
    background_image_setting: 'Background Image Settings',
    current_image: 'Current Image',
    change_image: 'Change Image',
    remove_image: 'Remove Image',
    no_background_image_selected: 'No background image selected',
    add_image: 'Add Image',
    this_will_open_for_screen_recording:
      'This will open the ShareLook application for screen recording.',
    ai_image_generation: 'AI Image Generation',
    image_edit: 'Image Edit',
    text_to_image: 'Text to Image',
    output_gallary: 'Output Gallery',
    instant_generation: 'Ready for instant generation',
    prompt_and_unleash_the_power: 'Enter your prompt and unleash the power',
    use_this_image: 'Use This Image',
    error_generating: 'Error generating.',
    generation_tips: 'Generation Tips',
    detailed_descriptions_for_more_accurate_results:
      'Use detailed descriptions for more accurate results',
    reference_image: 'Reference Image',
    select_pexels_image: 'Select Pexels Image',
    max_mb: 'Max 50MB',
    please_enter_text_to_appear_image:
      'Please enter text to appear in the image',
    enter_text_to_apear_in_the_image: 'Enter the text to appear in the image',
    generate_image: 'Generate Image',
    prompt_assistant: 'Prompt Assistant',
    generate_image_using_suggested_prompt:
      'Generate Image Using Suggested Prompt',
    talk_to_ai_about_the_image_generate:
      'Talk to AI about the image you want to generate',
    ask_for_prompt_suggestions: 'Ask for prompt suggestions...',
    enter_a_search_term_to_find_stock_images:
      'Enter a search term to find stock images',
    choose_your_content_source: 'Choose your content source:',
    upload_new_document_from_your_device:
      'Upload new documents from your device',
    automatic_library_selection: 'Automatic Library Selection',
    system_automatically_selects_relevant_document:
      'System automatically selects relevant documents',
    manual_library_selection: 'Manual Library Selection',
    generate_content: 'Generate Content',
    add_to_current_page: 'Add To Current Page',
    generate_bullet_points: 'Generate Bullet Points',
    generating: 'Generating',
    this_may_take_a_few_moments: 'This may take a few moments',
    apply_to_page: 'Apply to Page',
    scenario_escription: 'Scenario Description:',

    feedback: 'Feedback',
    form_mode: 'Form Mode',
    chat_mode: 'Chat Mode',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'This will generate a continuation of the selected story using AI.',
    continue_this_story_question: 'Continue This Story?',
    continue_this_story: 'Continue This Story',
    what_will_happen: 'What will happen:',
    the_ai_will_analyze_the_existing_story_content:
      'The AI will analyze the existing story content',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Generate a natural continuation that follows the same tone and style',
    create_new_content_that_build_upon_the_current_narrative:
      'Create new content that builds upon the current narrative',
    this_process_may_take_a_few_moments_to_complete:
      'This process may take a few moments to complete.',
    no_existing_stories_found_for_this_course:
      'No existing stories found for this course.',
    create_your_first_story: 'Create Your First Story',
    existing_stories: 'Existing Stories',
    create_new_story: 'Create New Story',
    tone: 'Tone',
    style: 'Style',
    genre: 'Genre',
    loading_your_stories: 'Loading your stories...',
    edit_story: 'Edit Story',
    story_preferences: 'Story Preferences',
    please_input_your: 'Please input your',
    add_character_names_and_press_enter: 'Add character names and press enter',
    select_or_type_your: 'Select or type your',
    enter_your: 'Enter your',
    position_of_the_story_in_the_lesson:
      'The position of the story in the lesson. The story will be added as a block at the specified position.',
    save_previous_content_on_the_pages: 'Save previous content on the pages',
    the_existing_content_in_the_selected_pages:
      'The existing content in the selected pages will be replaced by the generated story.',
    real_world_scenario: 'Real World Scenario',
    add_optional_instructions:
      'Add optional instructions (tone, length, audience, etc.)',
    ready_to_enerate_your_real_world_scenario:
      'Ready to Generate Your Real World Scenario',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Click "Generate Real World Scenario" to create a realistic scenario based on your lesson content.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'The AI will analyze your lesson topic and content',
    generate_a_practical_real_world_scenario:
      'Generate a practical real-world scenario',
    you_can_then_edit_and_customize_the_result:
      'You can then edit and customize the result',

    add_it_as_a_new_page_to_your_lesson: 'Add it as a new page to your lesson',
    regenerate_with_instructions: 'Regenerate with Instructions',
    add_real_world_scenario: 'Add Real World Scenario',
    generate_real_world_scenario: 'Generate Real World Scenario',
    simulation_has_been_stopped: 'Simulation has been stopped !',
    loading_simulation: 'Loading Simulation...',
    you_have_exhausted_all_the_attempts: 'You have exhausted all the attempts',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Study the scenario on this page and select the correct answer from the options below.',
    attempts_limit_reached:
      'Attempts limit reached. You can play again but your score will not be saved.',
    play_again: 'Play Again',
    import_music_from_computer: 'Import music from computer.',
    more: 'more',
    no_badge_yet: 'No badges yet',
    competition_filter: 'Competition Filter',
    global_leaderboard: 'Global Leaderboard',
    placeholder_for_the_global_leaderboard:
      'This is a placeholder for the Global Leaderboard.',
    badge_editor: 'Badge Editor',
    adjust_the_appearance_of_this_badge_icon:
      'Adjust the appearance of this badge icon. The changes apply to this badge only.',
    badge_style: 'Badge Style',
    the_image_must_be_pixels: 'The image must be 200x200 pixels.',
    badge_name: 'Badge Name',
    badge_descrription: 'Badge Description',
    enter_badge_criteria: 'Enter badge criteria',
    discard: 'Discard',
    badge_enable: 'Badges Enabled',
    award_users_with_badges_to_highlight_the_milestones:
      'Award users with badges to highlight the milestones in their learning journey.',
    badge_types: 'Badge Types',
    enable_or_disable_specific_badge_types_for_your_users:
      'Enable or disable specific badge types for your users.',
    levels_enabled: 'Levels Enabled',
    level_rules: 'Level Rules',
    points: 'Points',
    add_new_level: 'Add New Level',
    add_level: 'Add Level',
    points_enabled: 'Points Enabled',
    learning_activities_and_encourage_healthy_competition:
      'Award users with points for different learning activities and encourage healthy competition.',
    award_points: 'Award Points',
    the_following_equates_the_value_of_one_item_completion:
      'The following equates the value of one item completion',
    general: 'general',
    others: 'Others',
    certificate: 'Certificate',
    quiz_passed: 'Quiz passed',
    tip_approved: 'Tip Approved',
    tip_liked: 'Tip Liked',
    rewards: 'Rewards',
    offer_discounts_when_learners_achieve:
      'Offer discounts when learners achieve a set of points, badges or levels.',
    give_rewards: 'Give rewards',
    discount_course_purchases_by: 'Discount course purchases by',
    with_points_more_than: 'with points more than',
    with_badges_more_than: 'with badges more than',
    with_level_upwards_more_than: 'with level upwards more than',
    leaderboard: 'Leaderboard',
    leaderboard_enabled: 'Leaderboard Enabled',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      "Leaderboards offer users an overview of their learning progress in points compared to everyone else's.",
    show_levels: 'Show Levels',
    show_points: 'Show Points',
    show_badges: 'Show Badges',
    show_courses: 'Show Courses',
    show_certificates: 'Show Certificates',
    leaderboard_settings: 'Leaderboard Settings',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Set up engaging leaderboard experiences to boost learner motivation.',
    award_users_with_points_for_different_learning_activities:
      'Award users with points for different learning activities.',
    badge_set: 'Badge set',
    choose_the_type_of_badges_your_users:
      'Choose the type of badges your users will earn as they learn.',
    levels: 'Levels',
    Levels_represent_the_stages:
      "Levels represent the stages in a user's learning journey.",
    enabled: 'Enabled',
    disabled: 'Disabled',
    quick_select: 'Quick Select',
    yesterday: 'Yesterday',
    last_week: 'Last week',
    Last_month: 'Last month',
    last_quarter: 'Last quarter',
    historical_leaderboard: 'Historical Leaderboard',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Track your performance and see how you rank among your peers',
    time_period: 'Time Period',
    page_of: 'Page 1 of 1',
    edit_competition: 'Edit Competition',
    create_competition: 'Create Competition',
    arrow_right: 'arrow-right',
    update_competition: 'Update Competition',
    competition_title: 'Competition Title',
    enter_competition_title: 'Enter competition title',
    enter_competition_description: 'Enter competition description',
    leaderboard_skill: 'Skill',
    select_a_skill: 'Select a skill',
    no_skills_found: 'No skills found',
    competition_period: 'Competition Period',
    add_badge_rule: 'Add Badge Rule',
    create_badge: 'Create Badge',
    add_level_rule: 'Add Level Rule',
    selected_participants: 'Selected participants',
    no_participants: 'No participants',
    start_end_date: 'Start–End Date',
    created_date: 'Created by',
    new_competition: 'New Competition',
    competitions_list: 'Competitions List',
    search_competitions: 'Search competitions...',
    are_you_sure_you_want_to_delete_the_competition:
      'Are you sure you want to delete the competition',
    history: 'History',
    export: 'Export',
    search_by_name: 'Search by name...',
    no_historical_data_available_for_the_selected_period:
      'No historical data available for the selected period.',
    no_leaderboard_data_available: 'No leaderboard data available.',
    competitions: 'Competitions',
    leaderboards: 'Leaderboards',
    welcome_back: 'Welcome Back',
    track_your_performance_and_see:
      'Track your performance and see how you rank among your peers',
    team_leaderboard: 'Team Leaderboard',
    try_again: 'Try Again',
    no_competitions_for_search: 'No Competitions Available for',
    no_competitions_available: 'No Competitions Available',
    no_competitions_matching_search:
      'No competitions found matching your search. Try adjusting your search terms or check back later for new competitions.',
    no_competitions_general:
      'There are currently no competitions set up. Check back later or contact your administrator to create new competitions.',
    media_management: 'Media Management',
    badgess_set: 'Badges Set',
    choose_the_default_visual_style_for_badge:
      'Choose the default visual style for badge icons used across the platform.',
    enable_badges: 'Enable Badges',
    add_badge: 'Add Badge',
    min: 'Min',
    max: 'Max',
    your_rank: 'Your rank',
    your_points: 'Your points',
    your_level: 'Your level',
    rank: 'Rank #',
    level: 'Level',
    progress: 'Progress',
    new_folder: 'New Folder',
    file_upload: 'File Upload',
    writer: 'Writer',
    text_documents: 'Text Documents',
    spreadsheets: 'Spreadsheets',
    impress: 'Impress',
    presentations: 'Presentations',
    capture_desktop_screen: 'Capture Desktop Screen',
    capture_desktop_screens: 'Capture desktop screens',
    your_documents: 'Your Documents',
    manage_your_videos_images_audio_files:
      'Manage your videos, images, audio files, and other assets used in your content creation.',
    your_organization_documents: 'Organization SOP Documents',
    keep_your_organization_creative_assets_organized:
      "Keep your organization's creative assets organized and accessible—streamline teamwork and content production.",
    your_public_documents: 'Your Public Documents',
    curated_collection_of_media_assets_available:
      'A curated collection of media assets available for everyone—explore, reuse, and create.',
    your_download_center_documents: 'Your Download Center Documents',
    repository_of_approved_media_assets_for_download:
      'A repository of approved media assets for download and use in your projects.',
    search_files_and_folders: 'Search files and folders..',
    home: 'Home',
    folders: 'Folders',
    folder_name: 'Folder Name',
    owner: 'Owner',
    last_updated: 'Last Updated',
    action: 'Action',
    no_folders_found: 'No folders found',
    files: 'Files',
    enabling_ai: 'Enabling AI...',
    rename: 'Rename',
    copy: 'Copy',
    move: 'Move',
    verson_history: 'Version History',
    manage_permission: 'Manage Permission',
    generate_audit_report: 'Generate Audit Report',
    last_edited: 'Last edited',
    no_files_found: 'No files found',
    are_you_sure_you_want_to_make_this_item_public:
      'Are you sure you want to make this item public? It will be copied to your public library.',
    move_to_organization: 'Move to Organization',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'Are you sure you want to copy this item to your organization library?',
    are_you_sure_you_want_to_make_this_item_private:
      'Are you sure you want to make this item private? It will be copied to your own library.',
    date_modified: 'Date Modified',
    workflow_management: 'Workflow Management',
    configure_editors_approvers_and_viewers_for_this_document:
      'Configure editors, approvers, and viewers for this document.',
    error_Loading_editor: 'Error Loading Editor',
    debug_info: 'Debug Info',
    loading_editor: 'Loading Editor...',
    submitted_for_review: 'Submitted for Review',
    editors: 'Editors',
    no_editors_added_yet:
      'No editors added yet. Click "Add editor" to add one.',
    add_editor: 'Add editor',
    approvers: 'Approvers',
    no_approvers_added_yet:
      'No approvers added yet. Click "Add approver" to add one.',
    add_approvers: 'Add approvers',
    viewer: 'Viewer',
    no_viewers_added_yet:
      'No viewers added yet. Click "Add viewer" to add one.',
    add_viewer: 'Add viewer',
    are_you_sure_you_want_to_delete_the_selected_items:
      'Are you sure you want to delete the selected items?'
  },

  v3: {
    reportShareSphere: 'SHARESPHERE',
    overview: 'Category Overview',
    triviaReport: 'ShareSphere Category',
    overviewGraph: 'Category Overview Graph',
    category: 'Category',
    phCategory: 'Select Category',
    podcast: 'Podcasts, Music And Stories ',
    pastPodcast: 'Past Podcast',
    upcomingPodcast: 'Upcoming Podcast',
    podcastLanguageTitle: 'Language of podcast, music & stories',
    podcastLanguageCheckbox: 'AI generate language to my podcast',
    howRate: 'how world you rate this podcast?',
    podcastSubmit: 'Submit',
    podcastGuest: 'Guest Speaker:',
    podcastReview: 'Reviews',
    podcastEpishode: 'Episodes',
    podcastEnd: 'Podcast has ended',
    date_podcast: 'Podcast Date',
    skill_not_found: 'Sorry ! No skill journey found.',
    coaching: 'Coaching',
    webinar: 'Webinar',
    public_conference: 'Pubilc Conference',
    skill_journey_subtitle:
      'Add settings to your skill journey and select who can view and interact with your skill journey.',
    enable_white_label: 'Enable white label',
    create_new_event_org: 'Create a new event for your organization.',
    create_new_event_marketplace: 'Create a new event for the marketplace.',
    create_new_event_both:
      'Create new event for both your organization and the marketplace.',
    event_outline: 'Please Input Event Outline',
    event_obj: 'Please Input Event Objectives',
    event_description: 'Please Input Event Description',
    create_new_metamaze_org: 'Create a new MetaMaze for your organization.',
    create_new_metamaze_marketplace:
      'Create a new MetaMaze for the marketplace.',
    create_new_metamaze_both:
      'Create new MetaMaze for both your organization and the marketplace.',
    add_key_words: 'Add key words',
    press_enter_make_keyword: 'Press Enter To Make A Keyword',
    disable_skip_quiz: 'Disable Skip Quiz',
    warning_complete_quiz: 'Please complete the quiz to proceed.',
    signup_email_verification:
      'We have emailed a verification link to the address you provided. Please visit that link to confirm your registration.',
    verifying_registration: 'Verifying account registration...',
    reset_password_linK:
      'We have emailed a link to the address you provided. Please visit that link to set a new password.',
    reset_email_error:
      'User not found with this email, please try again using username instead!',
    first_name: 'First Name',
    last_name: 'Last Name',
    error_firstName: 'Please input your first name',
    error_sharebot_organization: 'Please input your Organization',
    error_lastName: 'Please input your last name',
    private_conference: 'Private Conference',
    public_conference: 'Public Conference',
    discussion_room: 'Discussion Room',
    training_no_courses: 'You are currently not enrolled in any courses.',
    training_no_events: 'You are currently not enrolled in any events',
    allow_sharing_trainer_info: 'Allow sharing email address in marketplace',
    error_username_space: `Username can't have any spaces.`,
    error_sharebot_organization_space: `Organization can't have any spaces.`,
    edit_permission: 'Edit permission',
    valid_price: 'Price must be greater than 0',
    valid_edit_price: 'Price to edit must be lesser than price to buy.',
    my_calendar: 'My Calendar',
    error_valid_firstName: 'Please enter a valid first name.',
    error_valid_organization: 'Please enter a valid Organization name.',
    error_valid_lastName: 'Please enter a valid last name.',
    error_name_spaces: `Name can't have any spaces`,
    items: 'Items',
    publish_to_channel: 'Publish to My Channel Collection',
    create_a_channel: 'Create My Channel',
    create_a_trivia: 'Trivia Game',
    create_a_new_channel: 'Create A New Channel',
    add_videos: 'Add Videos',
    save_and_continue: 'Save & Continue',
    channel: 'Channel',
    channels: 'Channels',
    view_channel: 'View Channel',
    edit_channel: 'Edit Channel',
    delete_channel: 'Delete Channel',
    my_video_channels: 'My Video Channels',
    training_no_channel: 'You are currently not enrolled in any channel.',
    monthly_price_required: 'Monthly price is required',
    yearly_price_required: 'Yearly price is required',
    one_time_price_required: 'One time price is required',
    marketplace_quantity: 'USD',
    report_webinar: 'WEBINAR',
    report_coaching: 'COACHING',
    report_channel: 'CHANNEL',
    report_public_conference: 'PUBLIC CONFERENCE',
    report_maze: 'MAZE',
    channel: 'Channel',
    edit_price: 'Edit Price ($)',
    quantity: 'Quantity',
    payment_type: 'Payment Type',
    total_amount: 'Total Amount ($)',
    net_amount: 'Net Amount ($)',
    edit_option: 'Edit Option',
    marketplace_price: 'Price ($)',
    market_name: 'Name',
    duration_min: 'Duration (Min)',
    users_total: 'Users (Total)',
    sales_total: 'Sales Total(USD)',
    search_coaching: 'Search Coaching',
    search_channel: 'Search Channel',
    search_webinar: 'Search Webinar',
    search_maze: 'search Maze',
    search_public_conference: 'Search Public Conference',
    buyer_type: 'Buyer Type',
    quanity: 'Quanity',
    channel_unit_amount: 'Net Amount ($)',
    channel_updated_at: 'Upadates Date',
    month_price: 'Price (Month)',
    year_price: 'Price (Year)',
    one_time_price: 'Price (One Time)',
    sharebot_organization: 'Add new organization name',
    share_sphere: 'ShareSphere',
    ai_course_title: 'Course Title',
    ai_input_course_title: 'Please input the course title!',
    learning_objective_label: 'Learning Objective',
    learning_objective_message: 'Please input the learning objective!',
    standard_question: 'Do You Have Any Standard The Learner Need To Follow?',
    standard_details_label: 'Standard Details',
    standard_details_message: 'Please input the standard details!',
    estimated_duration_label: 'Estimated Duration Of Course (In Minutes)',
    estimated_duration_message: 'Please input the estimated duration!',
    min_duration_message: 'Minimum duration is 5 minutes.',
    ai_mins: '25 mins',
    industry_specific_question: 'Is It Industry Specific?',
    industry_label: 'Specify Industry',
    industry_message: 'Please input the industry!',
    ai_course_creation: 'AI Course Creation',
    course_generated: 'Course Generated By Sharelook',
    ai: 'AI',
    ai_you: 'You',
    ai_prompt_ready:
      'Your prompt is ready. You are now ready to generate table of content.',
    ai_unable_respond:
      'Apologies ! AI is unable to respond to your prompt. Please try again.',
    ai_hide_toc: 'Hide Table of Content',
    ai_preview_toc: 'Preview Table of Content',
    ai_generate_toc_now: 'Generate Table of Content Now',
    ai_creation_course_title: 'Course Title:',
    ai_creation_industry_specific: 'Is It Industry Specific:',
    ai_creation_industry: 'Industry:',
    ai_creation_standard_needed:
      'Do You Have Any Standard The Learner Need To Follow?:',
    ai_creation_standard_details: 'Standard Details:',
    ai_creation_estimated_duration:
      'Estimated Duration Of Course (In Minutes):',
    minutes: 'minutes',
    ai_creation_learning_objective: 'Learning Objective:',
    setup_again: 'Setup Again',
    ai_creation_confirm_title: 'Are you sure you want to setup the form again?',
    ai_creation_confirm_content:
      'The chat & all the content you have generated will be reset.',
    ai_toc: 'Table Of Content',
    ai_note_topic:
      'Note: You can drag and drop to reorder topics inside the lesson.',
    ai_add_topic: '+ Add Topic',
    add_topic: 'Add Topic',
    add_lesson: 'Add Lesson',
    add_new_lesson: 'Add New Lesson',
    ai_add_lesson: '+ Add Lesson',
    attention: 'Attention',
    before_varifying: 'Before Verifying',
    ai_save_later: 'Save For Later',
    ai_download_word_doc: 'Download as Word Document',
    ai_download_course_word_doc: 'Download Course as a Word Document',
    ai_create_course_button: 'Create Course',
    ai_generate_course_content: 'Generate Course Content',
    ai_out_of: 'out of',
    ai_subtopic_failed_content:
      'subtopics failed to generate content. Click on "Generate Course Content" again to generate content for only those subtopics.',
    ai_edit_topic: 'Edit Topic',
    ai_edit_lesson_title: 'Edit Lesson Title',
    ai_save_topic: 'Save Topic',
    ai_save: 'Save',
    ai_save_lesson_title: 'Save Lesson Title',
    ai_add_new_topic: 'Add New Topic',
    ai_download_ref: 'Download with References',
    ai_download_ref_content:
      'It will download the course as a word document with references.',
    ai_download_without_ref: 'Download without References',
    ai_download_two_word: 'Two Word documents will be downloaded:',
    ai_download_two_word_content_one:
      '• One with main content without references',
    ai_download_two_word_content_two: '• One with only references (no content)',
    ai_manage_content: 'Manage Content',
    ai_add_content_from_internet: '+Add Content From Internet',
    ai_confirm_start: 'Confirm Start',
    ai_Verify: 'Verify',
    ai_undo_warning:
      'This process may take some time. Please do not close this window until the generation is complete as it cannot be undone.',
    ai_verified_content:
      'You have verified the content. Note that after confirmation, you will not be able to return to chat with the AI assistant with the current content.',
    ai_want_proceed: 'Are you sure you want to proceed?',
    upload_simulation: 'Upload Simulation',
    name_simulation: 'Simulation Name',
    selected_simulation_files: 'Selected Simulation Files',
    score_between_one_hundred: 'Your score should be between 1 and 100.',
    are_sure_simulation: 'Are you sure delete this simulation file?',
    required_simulation: 'Score is required',
    required_section_file: 'Section file is required',
    simulation: 'Simulation',
    simulation_quiz_games: 'Need to add quiz in games',
    simulation_alert_des:
      'You can add games only if all the questions have answer type of either single or multiple.',
    alert_info: 'info',
    ai_number_quiz: 'Number of Quiz',
    ai_point: 'Point',
    ai_points: 'Points',
    val_required: 'Required',
    games: 'Games',
    add_simulation: 'Add Simulation',
    text_tiewer: 'Text Viewer',
    back_to_account: 'Back to Account',
    delete_account: 'Delete Account',
    delete_account_title: 'Delete Account ???',
    delete_account_subtitle: 'You can delete your account from here.',
    delete_account_cannot_undo:
      'You are about to delete your account. This action cannot beundone.',
    account_org_profile:
      'You will also lose all the courses you have created, your organization profile and all your settings.',
    deleting_account_database:
      'Deleting your account will remove all your data from our database.',
    account_confirm_delete: 'Are you sure you want to delete your account?',
    action_cannot_be_undone: 'This action cannot be undone.',
    account_delete_message_success:
      'Your account has been deleted successfully.',
    message_edit: 'Edit',
    message_delete: 'Delete',
    message_reply: 'Reply',
    attached_file: 'Attached File',
    attach_file: 'Attach File',
    attach_des: '25 MB, maximum file size',
    view: 'View',
    go_to_marketplace: 'Go To Marketplace',
    learning_center: 'Learning Center',
    knowledge_center: 'Knowledge Center',
    sharebot: 'ShareBot',
    sharebot_help_message: 'How can I help you today?',
    my_organization: 'My Organization',
    world_knowledge: 'World Knowledge',
    welcome_to_sharelook: 'Welcome To Sharelook !',
    sharelook_you_want_go: 'Where do you want to go today?',
    shareLook_learning_management_system:
      'Access the ShareLook learning management system to create or access learning resources such as live events and courses in your organization on ShareLook.',
    shareLook_powerful_ai_system:
      'Access ShareLook’s powerful AI-powered system where you can upload pdf documents and get useful insights at your fingertips within seconds. Retrieve quick answers based on the resources uploaded in your organization or get answers from our generic AI system in the world knowledge section.',
    edit_now: 'Edit Now',
    sharelook_log_out:
      'You have been logged out from Sharelook. Please Login !',
    sorry_error: 'Sorry ! We experienced some error.',
    login: 'Login',
    refresh_page: 'Refresh Page',
    just_a_moment: 'Just A Moment',
    enter_lname_fname: 'Please enter your first name and last name to proceed.',
    procced_to_sharelook: 'Proceed to Sharelook',
    option_one: 'Option 1',
    option_two: 'Option 2',
    selected_image: 'Selected Image:',
    add_text: 'Add Text',
    linkdin_is_required: 'Linkedin is required.',
    bio_is_required: 'Bio is required.',
    save_user_information: 'Save User Information',
    select_all: 'Select All',
    enable_ai: 'Enable AI',
    load_more: 'Load More',
    channel_id: 'Channel ID.',
    send: 'Send',
    v4: 'Information',
    subscription: 'Subscription',
    reset_user_flag: 'RESET USER FLAG',
    delete_my_accont: 'Delete my account',
    sharebot_sub_error: 'Error fetching subscriptions. Try Again !',
    sharebot_no_sub: 'You currently have no active subscriptions.',
    sharebot_dont_sub: "You don't have any previous subscriptions.",
    sharebot_prev_sub: 'Previously Subscribed',
    sharebot_sub: 'ShareBot Subscription',
    sharebot_un_sub: 'ShareBot UnSubscription',
    sharebot_no_available: 'No Description Available',
    sharebot_start_date: 'Start Date:',
    sharebot_end_date: 'End Date:',
    sharebot_sure: 'Are you sure?',
    sharebot_do_you_want: 'Do you want to',
    unsubscribe: 'unsubscribe',
    unsubscribe_what: 'unsubscribe ?',
    subscribe: 'subscribe',
    subscribe_what: 'subscribe ?',
    subscribe_now: 'subscribe Now',
    confirm: 'Confirm',
    sharebot_intel_knowledge_center: "ShareBot's Intelligent Knowledge Center",
    sharebot_welcome_paragraph:
      "Welcome to ShareBot's Knowledge Center, the advanced AI chatbot designed to transform how professionals access information and collaborate.",
    expired: 'Expired',
    active: 'Active',
    Inactive: 'Inactive',
    yearly_subscription: 'Yearly Subscription',

    monthly_subscription: 'Monthly Subscription',
    no_sharebot_org: 'You have no sharebot organization',
    sharebot_start_free_trial: 'Start Free Trial',
    sub_month: 'Subscription Monthly',
    sub_year: 'Subscription Yearly',
    question_per_month: 'Data Storage (1TB) and 1000 Questions per Month',
    sharebot_para:
      'By proceeding, you are confirming the immediate deletion of the organization. This action will result in the loss of all the valuable insights provided by ShareBot, and it cannot be undone.',
    cancelled_date: 'Cancelled Date:',
    live_straming_para:
      'If you wish to change your monthly live-streaming limit please contact',
    sharelook_agree: "I agree to Sharelook's",
    terms_condition: 'terms & conditions',
    and: 'and',
    privacy_policy: 'privacy policy',
    save_for_later: 'Save For Later',
    ai: 'AI',
    no_video_yet: 'No Videos Selected Yet !',
    are_you_sure_delete_video: 'Are you sure you want to delete this video?',
    video_des: 'Description',
    video_now: 'Now',
    video_playing: 'Playing:',
    video_no: 'Video No.',
    ai_generated_course: 'AI Generated Course',
    create_course_on_our_own: 'Create a Course on Your Own',
    ai_Assisted_ourse_reation: 'AI-Assisted Course Creation',
    pending: 'Pending',
    published: 'Published',
    intro_course: 'into your course?',
    clone_course: 'Would you like to clone',
    browser_audio_not_support: 'Your browser does not support the audio tag.',
    audio_popup_content:
      "Where you can use many voice stlye over the text that you type bla Bla bla Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    close: 'Close',
    podcast_rec: 'REC',
    create_podcast: 'Create Podcast',
    add_admin: 'ADD ADMIN',
    delete_all: 'Delete all',
    ai_podcast_audio: 'Ai Podcast Audio',
    language: 'Language',
    podcast_download_content:
      '*Download the Audio file Ai for editing to become your audio file.',
    upload_audio: 'Upload Audio',
    browser_do_not_support_audio:
      'Your browser does not support the audio element.',
    upload_cover: 'Upload Cover',
    upload_ai_creator: 'AI Creator',
    required_cover_image: 'Cover Image is required!',
    room_required_name: 'Podcast Name is required!',
    add_guest_list: 'Please add guest lists!',
    podcast_add_participants: 'ADD PARTICIPANT',
    topic_required: 'At least one topic is required',
    podcast_description: 'Description',
    podcast_date: 'DATE',
    date: 'Date',
    podcast_time: 'time',
    podcast_to: 'to',
    podcast_all_day: 'All day',
    podcast_start_date_time: 'Start Date and Time Interval Are Required!',
    podcast_id: 'ID',
    selected_user: 'Invite Selected Users',
    see_more: 'See More',
    see_less: 'See Less',
    no_review_yet: 'No review yet, be the first one to review.',
    request_to_speak: 'Accept user request to speak?',
    kick_user: 'Do you want to kick this user?',
    accept_request: 'Accept Request',
    kick: 'KICK',
    started: 'STARTED',
    end: 'END',
    join_now: 'Join Now',
    podcast_end: 'Podcast has ended',
    connecting: 'connecting...',
    knowledge_center_know_today: 'What would you like to know today?',
    knowledge_center_question: 'Please enter a question first',
    knowledge_center_error: 'Sorry ! We experienced some error.',
    knowledge_center_tooltrip:
      'Get quick answers from the learning resources in your organization’s repository on ShareLook, with proper references and possibility to preview and download the referenced pdf documents.',
    my_organization: 'My Organization',
    world_knowledge: 'World Knowledge',
    open_file: 'Open File',
    reference: 'Reference',
    are_you_cancel: 'Are you sure you want to cancel?',
    are_you_remove_media: 'Are you sure you want to remove the media?',
    terms_agree: 'I agree to these',
    ready: 'Ready',
    send_email: 'SEND EMAIL',
    active_users: 'Active users',
    sign_up_user: 'Sign up users',
    non_sign_up_user: 'Non Sign up users',
    organisation: 'Organization',
    usage_report: 'Usage Report',
    check_email: 'check your email',
    delete_schedule: 'Delete Schedule',
    are_you_sure_delete_schedule: 'Are you sure delete this schedule?',
    add_task: 'Please input a task !',
    coaching_available: 'Mark as Coaching Availability',
    message_booking_coaching: 'This timeslot is booked by a user for coaching.',
    task_day: 'Task Day',
    created_task_day: 'You have created a task for this day.',
    event_day: 'Event Day',
    has_booked_coaching: 'A coaching has been booked for this day.',
    active_day: 'Active Day',
    selectable_time_slots:
      'The selectable time slots at the right is active for this day.',
    compare_last_month: 'Compared to last Month',
    uploading_file: 'Uploading your file',
    attach_file_course: 'attached to this course.',
    fetch_request: 'Fetching your request',
    finilize_upload: 'Finalizing upload',
    scorm_scanned: 'Please wait... Your uploaded SCORM zip is getting scanned.',
    scan_status: 'Scan Status:',
    scan_completed: 'Scan Completed. Your file is',
    scan_progress: 'Scan in progress...',
    check_scorm: "Checking your SCORM's file format... Please wait...",
    file_check_success: 'File check succeeded',
    file_check_progress: 'File checking in progress...',
    scorm_not_upload:
      'Your uploaded file is Not SCORM 1.2 standard, Please upload file again.',
    select_question: 'Answer Options (select one correct answer)',
    select_answer: 'Please select answer option!',
    check_option_one: 'Please input option one!',
    check_option_two: 'Please input option two!',
    check_option_three: 'Please input option three!',
    check_option_four: 'Please input option four!',
    question_image: 'Question Image',
    select_question_image: 'Please select question image!',
    ans_image: 'Answer Image',
    upload_image_question: 'Upload Answer Image',
    select_image_answer: 'Please select answer image!',
    save_question: 'Save Question',
    do_you_leave: 'Are you sure you want to leave?',
    loose_all_progress: 'You will lose all your progress.',
    welcome: 'Welcome',
    team_knowledge_quest: 'Team Knowledge Quest',
    your_score: 'Your Score',
    start_playing: 'Start Playing',
    share_sphere_complete: 'ShareSphere Complete',
    final_score: 'Final Score',
    play_next: 'Play Next',
    you_donot_access_event: 'You donot have access to this event.',
    ai_content_generated: 'Content has been generated for this topic.',
    ai_popup_confirm_content: 'Confirm Content Generation',

    limit_transcribe_text:
      'Transcribe Minutes Remaining: <0>{{ transcribe_limit }}</0> minutes <1/><2/> <3>. To change your transcribe limit, please contact </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'You donot have access to this event.',
    ai_course_title_training: 'Leadership training courses',
    ai_course_object: 'Navigating Leadership in Digital',
    create_ai_video: 'Create AI Video',
    generate: 'Generate',
    video_generate_process:
      'Video generation process may take some time. You will be with an email once its completed.',
    stripe_account_connect:
      'Your Stripe account is inactive. Please connect or activate it to continue.',
    ai_creator: 'AI Creator',
    check_video_status: 'Checking video generation status...',
    video_on_queue: 'The video generation is on queue.',
    video_fail_generation:
      'Sorry, the video generation failed. Please try another one.',
    video_currently_generated: 'This video is currently being generated.',
    checking_status: 'Checking Status',
    check_status: 'Check Status',
    browser_does_not_support_audio:
      'Your browser does not support the audio tag',
    existing_edit_scenario:
      'Do you want to edit the existing scenario or to create a new scenario? If you want to create a new scenario, you will lose the old scenario.',
    generate_scenario: 'Generate Scenario',
    layout: 'Layout',
    confirm_change: 'Confirm Change',
    generated_ai_creation_message:
      'Please note that only the text elements that are generated from AI creation will be retained. All other elements will be removed from the page.',
    generate_story: 'Generate Story',
    save_original_content: 'Save original content:',
    story_added_specified_position:
      'The position of the story in the lesson. The story will be added as a block at the specified position.',
    position_of_story: 'Position of Story',
    start_the_lesson: 'Start of the Lesson',
    end_the_lesson: 'End of the Lesson',
    add_story_pages: 'Add Story to Pages',
    browser_does_not_support:
      'Your browser does not support the audio element.',
    no_video_available: 'No videos are available.',
    no_podcast_available: 'No podcasts are available.',
    no_item_baskets: 'No items in the basket.',
    ai_course_object: 'Navigating Leadership in Digital'
  },

  v2: {
    n_data: 'No Data',
    change: 'Change',
    remove: 'Remove',
    auto_background: 'Auto Background',
    create_new_course_org: 'Create a new course for your organization.',
    create_new_course_marketplace: 'Create a new course for the marketplace.',
    create_new_course_both:
      'Create new course for both your organization and the marketplace.',
    ok: 'Ok',
    page_bg: 'Page Background',
    lesson_cover: 'Lessons Cover Picture',
    create_skill_journey: 'Create a Skill Journey',
    Metamaze: 'Metamaze',
    events: 'Events',
    scroms: 'SCORMs',
    min_score_pass: 'Minimum Score to Pass',
    no_scorms_available: 'No SCORMs are available.',
    no_events_available: 'No events are available.',
    no_courses_available: 'No courses are available.',
    no_courses_baskets: 'No courses in the basket.',
    no_mazes_baskets: 'No mazes in the basket.',
    no_scroms_baskets: 'No SCORMs in the basket.',
    no_events_baskets: 'No events in the basket.',
    sorry: 'Sorry!',
    option_1: 'Option 1',
    option_2: 'Option 2',
    enter_number_words: 'Enter the maximum number of words.',
    summarize: 'Summarize',
    answer: 'Answer',
    hold_tight_one_minute:
      'Hold tight! We are still preparing. This may take up to one minute.',
    enter_question: 'Enter your question.',
    enter_relevant_documents: 'Enter the number of relevant documents.',

    please_input_relevant_documents:
      'Please input relevant number of documents!',
    please_wait_loading_results: 'Please wait for the loading results...',
    proceed_to_add_voice: 'Proceed to Add Voice',
    results: 'Results',
    no_result_found_try_asking_questions:
      'No results found. Try asking more questions.',
    eg: 'e.g.,',
    what_make_sales_manager: 'What can make me a sales manager?',
    please_select_lang: 'Please select any language!',
    search: 'Search',
    please_copy_desired_content:
      'Please copy the desired content from the left-hand box to the right-hand box.',
    rating_req: 'Rating is a required field.',
    review_req: 'Review is a required field.',
    rating_review_req: 'Must provide both a rating and a review.',
    how_rate_this: 'How Would You Rate This?',
    amazing_above_expectations: 'Amazing! Above expectations!',
    certificates: 'Certificates',
    you_no_certificates: 'You have no certificates available at this moment.',
    please_add_review:
      'Please provide a review along with the rating, Thank you!',
    post: 'Post',
    rate: 'Rate',
    avg_rating: 'Average Rating',
    no_review_found: 'No Review Found',
    are_sure_to_disale_zoom_integration:
      'Are you sure you want to disable Zoom integration?',
    badges: 'Badges',
    you_no_badge_available: 'You have no badges available at this moment.',
    download_certificate: 'Download Certificate',
    loading: 'Loading...',
    no_file_attached: 'No Files Attached',
    you_do_not_have_any_notes: "You don't have any notes.",
    question: 'Question',
    score: 'Score',
    alert_score_message: 'Person(s) have submitted their scores.',
    alert_question_message: 'No questions added until now.',
    button_submit: 'Submit',
    button_allScores: 'All scores have been submitted.',
    record_wait: 'Recording is starting. Please wait...',
    buttonSubmit_warning: 'Please input all scores before submitting.',

    upload_ar_assets: 'Upload AR Assets',
    edit_ar_assets: 'Edit AR Assets',
    edit_maze_assets: 'Edit MetaMaze Assets',
    upload_assets: 'Upload Assets',
    upload_maze_assets: 'Upload MetaMaze Assets',
    trigger_title: 'Trigger Title',
    model_title: 'Model Title',
    trigger_description: 'Trigger Description',
    model_description: 'Model Description',
    please_type_target_description: 'Please type target description.',
    please_type_model_description: 'Please type model description.',
    trigger_image: 'Trigger Image*',
    model_image: 'Model Image*',
    upload_trigger_image: 'Upload Trigger Image',
    upload_model_image: 'Upload Model Image',
    drag_n_drop: 'Drag and Drop',
    file_size_should_not_exceed:
      '(Image File (JPEG) size should not exceed 512 KB)',
    zip_size_should_not_exceed: '(Zip File size should not exceed 60 MB)',
    ar_content: 'AR Content*',
    model_content: '3D Model*',
    upload_3d_zip: 'Upload ZIP / Video',
    upload_3d_maze_zip: 'Upload ZIP',
    audio_content: 'Audio Content',
    _mp3: '(.mp3)',
    content_attached: 'Zip Attached.',
    video_attached: 'Video Attached.',
    audio_attached: 'Audio Attached.',
    enter_trigger_image_title: 'Enter trigger image title.',
    enter_model_title: 'Enter MetaMaze model title.',
    ar_preview_image: 'AR Preview Image',
    upload_preview_image: 'Upload Preview Image',
    upload_audio: 'Upload Audio',
    creating___: 'Creating...',
    updating___: 'Updating...',
    create: 'Create',
    update: 'Update',
    ar_assets: '3D Image',
    _3d_files_mp4: '(Zipped .obj, .fbx or .mp4 Video)',
    _3d_files_mp4_ar: '(Zipped .obj, .fbx)',
    maze_3d_files_mp4: '(Zipped .obj, .fbx)',
    _jpg_files: 'Supports only .jpg',
    persons_have_submitted_their_scores:
      'Person(s) have submitted their scores.',
    no_questions_added_till_now: 'No questions added until now.',
    submit: 'Submit',
    all_scores_submitted: 'All scores have been submitted.',
    recording_is_starting: 'Recording is starting. Please wait...',
    please_input_scores_before_submitting:
      'Please input all scores before submitting.',
    end_for_all: 'End for All',
    full_screen: 'Full Screen',
    breakout_room: 'Breakout Room',
    send_invitations: 'Send Invitation(s)',
    add_participants: 'Add Participant(s)',
    create_breakout_room: 'Create Breakout Room',
    connecting: 'Connecting...',
    currently_broadcaster_unavailable: 'Currently, broadcaster is unavailable.',
    how_many_breakout_room_to_create:
      'How many breakout rooms do you want to create?',
    create_upto_three_breakout_rooms: '*Create Up to 3 Breakout Rooms',
    allow: 'Allow',
    additional: 'Additional',
    attachment: 'Attachments',
    no_description_available: 'No description available.',
    people: 'PEOPLE',
    waiting: 'Waiting',
    hand_raising_users: 'Hand Raising Users',
    invite: 'Invite',
    create_room: 'Create Room',
    create_live_event: 'Create Live Event',
    support_upto_fivethousand_participants:
      'Supports up to 5,000 participants for the event',
    support_upto_ten_participants: 'Supports up to 10 live video participants',
    support_upto_twohundred_participants:
      'Supports up to 200 participants for the event',
    supprt_upto_five_participants: 'Supports up to 5 live video participants',
    support_upto_twentyfive_participants:
      'Supports up to 25 live video participants for the event',
    two_live_video_participants:
      'There are 2 live video participants for the event (host and attendee)',
    you_can_have_upto_five_examinees: 'You can only have up to 5 examinees.',
    you_can_have_upto_twentyfive_participants:
      'You can only have up to 25 participants.',
    you_can_have_upto_five_participants:
      'You can only have up to 5 participants.',
    you_can_have_upto_ten_participants:
      'You can only have up to 10 participants.',
    select_hosts_email: 'Select Host’s Email',
    send_invite_email: 'Send Invite Email',
    do_not_send_invite_email: "Don't Send Invite Email",
    error: 'Error',
    max_twentyfive_users_allowed: 'Max. 25 users are allowed to select',
    max_five_users_allowed: 'Max. 5 users are allowed to select',
    max_ten_users_allowed: 'Max. 10 users are allowed to select',
    no_user_found: 'No User Found',
    transcribe_to: 'Transcribe To',
    integrate_zoom_to_start_meeting:
      'Integrate Zoom on your account to start a Zoom meeting.',
    zoom_is_not_integrated: 'Zoom is not integrated.',
    delete_poll: 'Delete Poll',
    add_poll: 'Add Poll',
    live_now: 'LIVE NOW!',
    average_rating: 'Average Rating',
    review: 'Review',
    time_spent: 'Time Spent',
    total: 'Total',
    mins: 'Minutes',

    no_data: 'There is no data for this quiz.',
    total_score: 'Total Score',
    pass_score: 'Pass Score',
    point: 'Point',
    wrong: 'Wrong',
    response: 'Response',
    submitted: 'Submitted',
    average: 'Average',
    total_play: 'Total Play',
    view_graph: 'View Graph',
    time_spent_mins: 'Time Spent (Minutes)',
    play: 'Play',
    ideal_path: 'Ideal Path',
    user_incorrect_path: 'User Incorrect Path',
    ideal_path_taken: 'Ideal Path Taken by User',
    scenario: 'Scenario',
    option: 'Option',
    spend: 'Spend',
    average_spending_time: 'Average Spending Time',
    activity_overview: 'Activity Overview',
    live_event: 'Live Event',
    live_assessment: 'Live Assessment',
    report_download: 'Report Download',
    all_workshops: 'All Workshops',
    overview_average_activity: 'Overview Average Activity',
    overview_workshop_graph: 'Overview Workshop Graph',
    mazes: 'Mazes',
    correct_feedback: 'Correct Feedback',
    incorrect_feedback: 'Incorrect Feedback',
    checkin_checkout: 'Check-In - Checkout',
    minutes: 'Minutes',
    incorrect_path: 'Incorrect Path',
    answer_not_available: 'Answer Not Available',
    views: 'Views',
    item: 'Item',
    questions: 'Questions',
    total_points: 'Total Points',
    total_attempts: 'Total Attempts',
    created_date: 'Created Date',
    host_name: 'Host Name',
    host_section: 'Host Section',
    choose_products: 'Choose Products',
    add_to_basket: 'Add to Basket',
    basket: 'Basket',
    times: 'Times',
    scorms: 'SCORMs',
    skill_journey_overview: 'Skill Journey Overview',
    how_to_use: 'How to Use',
    live_broadcast_description:
      'WE’VE INTEGRATED LIVE VIDEO INTO AN EASY-TO-USE COURSE BUILDER',
    live_broadcast_subdescription:
      'With ShareLook’s patented live broadcast system, you can create engagement, automate learning, and maximize knowledge sharing.',
    disclaimer: `I warrant that my skill journey will not: 
      - infringe the rights of any third party
      - contain any illegality, including defamatory, obscene, indecent, lewd, pornographic, violent, abusive, insulting, threatening, or discriminatory content, even disguised with asterisks
      - contain any personal attacks on other persons
      - contain any impersonation of other participants, public figures or celebrities
      - contain any recording or personal information on any individual without the consent of such individual and is not in breach of any data protection regulation in any part of the world
      - contain any commercial solicitation or any form of “spam”'`,
    price: 'Price',
    video_link: 'Video Link',
    category: 'Category',
    objectives: 'Objectives',
    marketplace_description: 'Marketplace Description',

    live_discussion: 'LIVE DISCUSSION',
    poll: 'POLL',
    hide_grid: 'Hide Grid',
    show_grid: 'Show Grid',
    stop_screen_share: 'Stop Screen Share',
    screen_share: 'Screen Share',
    mute: 'Mute',
    unmute: 'Unmute',
    raise_hand: 'Raise Hand',
    waiting__: 'Waiting...',
    audio_active: 'Audio Active'
  },
  general: {
    save: 'Save',
    autosaved: 'Autosaved',
    back_to: 'Back To',
    by: 'By',
    chat: 'Chat',
    completed: 'Completed',
    canceled: 'Canceled',
    component: 'Component',
    confirm: 'Confirm',
    course: 'Course',
    skill: 'Skill Journey',
    maze: 'MetaMaze',
    channel: 'Channel',
    podcast: 'Podcast',

    date: 'Date',
    details: 'Details',
    empty: 'No Data',
    enrolled: 'Enrolled',
    free: 'Free',
    graph: 'Graph',
    loading: 'Loading...',
    lesson: 'Lesson',
    lessons: 'Lessons',
    live_assessment: 'Live Assessment',
    live_event: 'Live Event',

    no: 'No',
    of: 'Of',
    or: 'Or',

    organization: 'Organization',
    page: 'Page',
    pages: 'Pages',
    personal: 'Personal',
    poll: 'Poll',
    rating: 'Rating',
    reset: 'Reset',
    signin: 'Sign In',
    signup: 'Sign Up',
    soon: 'Soon',
    type: 'Type',
    uploading: 'Uploading...',
    yes: 'Yes',
    something_went_wrong: 'Something went wrong!',
    view_all: 'View All',
    upload_successful: 'Upload Successful',
    upload_successful_message:
      'Your Excel documents has been successfully uploaded and is currently processing. This may take some time.',
    check_email_upload_successful:
      'Please <0>check your email</0> for the <1>report</1> of the uploaded user list.'
  },

  account: {
    title: 'Account',
    subtitle: 'Manage your settings and account information.',
    saved: 'Account Successfully Changed'
  },

  assessments: {
    title: 'Assessments',
    subtitle: 'Create an Assessment',
    finished: 'The Assessment Is Finished',
    countdown: 'Live Assessment Will Be Broadcasting In',
    create: 'Create Assessment',
    list_title: 'Your Assessments',
    delete_warning: 'Are you sure you want to delete this item?',
    details_title: 'Add Assessment Details',
    details_subtitle:
      'Name your assessment and tell your audience what they should expect to learn from it.',
    disclaimer: `I warrant that my recorded assessment will not:
    - Infringe on the rights of any third party
    - Contain any illegality, including defamatory, obscene, indecent, lewd, pornographic, violent, abusive, insulting, threatening, or discriminatory content, even disguised with asterisks
    - Contain any personal attacks on other persons
    - Contain any impersonation of other participants, public figures, or celebrities
    - Contain any recording or personal information on any individual without the consent of such individual and is not in breach of any data protection regulation in any part of the world
    - Contain any commercial solicitation or any form of spam'`,

    // added_first
    assessment_details: 'Assessment Details',
    assessment_settings: 'Assessment Settings' // to translate
  },

  buildersettings: {
    title: 'Publish Settings',
    subtitle:
      'Add settings to your event and who can view and interact with your event.'
  },

  buttons: {
    market_place: 'Marketplace',
    back_to_normal: 'Back to Normal',
    add: 'Add',
    add_page: 'Add Page',
    add_lesson: 'Add Lesson',
    add_answer: 'Add New Answer',
    add_group: 'Add Group',
    add_organization: 'Add Organization',
    add_question: 'Add Question',
    add_quiz: 'Add Quiz',
    add_users: 'Add Users',
    back: 'Back',

    back_to_course: 'Back to Course Overview',
    back_to_lesson: 'Back to Lesson overview',
    back_to_media: 'Back to Media Library',
    back_to_details: 'Back to Details',
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    clear: 'Clear',
    close: 'Close',
    clone: 'Clone',
    close_lesson: 'Close Lesson',
    clone_course: 'Clone Course',
    confirm: 'Confirm',
    create: 'Create',
    download: 'Download',
    download_mass_user_tamplate: 'Download Template',
    add_mass_users: 'Add Mass Users',
    upload_excel_list: 'Upload Excel List',
    delete: 'Delete Media',
    edit: 'Edit',
    edit_course: 'Edit Course',

    enroll: 'Enroll',
    finish: 'Finish',

    upload_image: 'Upload Image',
    upload_image_video: 'Upload Image or Video',
    select_media_library: 'Select Media Library',
    make_public: 'Make Public',
    make_private: 'Make Private',
    make_org: 'Make Organization',
    media: 'Media Library',
    my_theme: 'My Theme',
    next: 'Next',
    next_lesson: 'Next Lesson',
    next_step: 'Next Step',
    previous_step: 'Previous Step',
    publish: 'Publish',
    publish_assessment: 'Publish Your Assessment',
    publish_course: 'Publish Your Course',

    publish_event: 'Publish Your Event',

    reset: 'Reset',
    reset_elements: 'Reset Elements',
    save: 'Save',
    creating: 'Creating...',
    updating: 'Updating...',
    saved: 'Saved',
    save_for_later: 'Save for Later',
    save_settings: 'Save Settings',
    select_files: 'Select Files',
    select_theme: 'Select Theme',
    start_lesson: 'Start Lesson',
    update: 'Update',

    upload: 'Upload',
    upload_audio: 'Upload Audio',
    upload_photo: 'Upload a Profile Photo',
    refresh: 'Refresh',
    retry: 'Retry',
    upload_video: 'Upload Video',
    enrolled: 'Enrolled',
    unenroll: 'Unenroll',
    from_library: 'Media Library',
    remove: 'Remove',
    removed: 'Removed',
    start_broadcast: 'Start Broadcast',
    end_broadcast: 'End Broadcast',
    camera: 'Camera',
    screen: 'Screen',
    screen_with_camera: 'Screen with Camera',
    insert: 'Insert',
    inserting: 'Inserting'
  },

  card: {
    quick_add: 'Quick Add',
    add: 'Add',
    clone: 'Clone',
    completed: 'Lessons Completed'
  },

  course: {
    upcoming_course: 'Upcoming Course',
    unPublishEvent: 'Unpublish Event',
    unPublishAssessment: 'Unpublish Assessment',
    pastCourse: 'Training Course',
    upcoming: 'Upcoming Live event',
    unPublishMaze: 'Unpublish Maze', // to translate
    upcomingMaze: 'Upcoming Maze', // to translate
    pastMaze: 'Past MetaMaze', // to translate
    pastEvent: 'Past Live Event',
    pastAssessment: 'Past Live Assessment',
    upcomingAssessment: 'Upcoming Live Assessment',
    created: 'Date Created:',
    assignees: 'Assignees',
    organisations:
      '{{ organizations }} Organizations, <2> {{ users }} Users</2>',
    event_date: 'Live Event Date <1> {{ date }} </1>',
    delete_warning: 'Are you sure you want to delete ',
    clonning_no_lesson:
      'Please add at least one lesson in order to clone this course.',
    Clone_warning: 'Are you sure you want to clone this?',
    clone_success: 'Currently in the cloning process.',
    disclaimer: `I warrant that my course does not:
    - Infringe on the rights of any third party
    - Contain any illegality, including defamatory, obscene, indecent, lewd, pornographic, violent, abusive, insulting, threatening, or discriminatory content, even disguised with asterisks
    - Contain any personal attacks on other persons
    - Contain any impersonation of other participants, public figures, or celebrities
    - Contain any personal information on any individual without the consent of such individual and is not in breach of any data protection regulation in any part of the world
    - Contain any commercial solicitation or any form of spam`
  },

  coursecreate: {
    take_a_tour: 'Take a Tour',
    dropzone_text: 'Insert Media',
    sidebar_text: 'Select a Theme <1/> for Your <3/> Lessons',
    delete_warning: 'Are you sure you want to delete this lesson?'
  },

  coursepage: {
    quizview_loading: 'Checking answers. Please wait...',
    quizview_answer: 'Your Answer'
  },

  coursequiz: {
    title: 'Quizzes in All Lessons'
  },

  dashboard: {
    tooltip_title: 'Do not show this video again.',
    page_title: 'Your Courses’ Statistics',
    page_subtitle: 'Status of the Courses You Created',
    profile_add_info:
      'Add your <1>{{uncompleted text}}</1> to complete your profile.',
    profile_build:
      'Build your profile <1>here</1>. Let us know your interests and skills.',
    profile_title: 'Profile Strength',
    more_details: 'More Details'
  },

  errors: {
    answer: 'Please Input Answer',
    topics_max: 'Please Add No More Than 5 topics', // (just the digit 5)
    code: 'Please Input Your Code',
    criterion: 'Please Input Criterion',
    duration: 'Duration Is Required',
    element: 'Please Input Element',
    email: 'Please Input Your Email',
    email_invalid: 'The Input Is Not a Valid Email',
    feedback_correct: 'Please Input Correct Feedback',
    feedback_incorrect: 'Please Input Correct Feedback',
    host: 'Please Input Event Host',
    host_assessment: 'Please Input Assessment Host',
    image: 'Please Upload an Image',

    location: 'Please Input Your Location',
    live_location: 'Please Choose a Broadcast Location',
    limit: 'Please Input Livestreaming Minutes',
    min_3char: '3 Characters Minimum',
    number: 'Please Input Positive Number',
    host_email_require: `Host's Email Is Required`,
    attendee_email_require: `Attendee's Email Is Required`,

    name: 'Please Input Your Name',
    not_found_course: 'Course Not Found',
    not_found_event: 'Event Not Found',
    not_found_assessment: 'Assessment Not Found',

    password: 'Please Input Your Password',
    password_digit: 'At Least One Digit',
    password_short:
      'Password is too short. Must be a minimum of 10 characters.',
    password_special: 'At least one special character.',
    password_uppercase: 'At least one uppercase character.',
    password_lowercase: 'At least one lowercase character.',
    phone: 'Please Input Your Phone',
    phone_invalid: 'Invalid Phone Number',
    position: 'Please Input Your Position',

    question: 'Please Input Question',
    start_date: 'Start Date and Time Are Required',
    tag: 'Please Select a Tag',
    topics: 'Please Select at Least One Topic',
    live_topics: 'Please Add Topics',
    title: 'Please Input Title',
    title_assessment: 'Please Input Assessment Title',
    title_course: 'Please Input Course Title',

    title_empty: 'Title Cannot Be Empty',
    title_event: 'Please Input Event Title',
    title_lesson: 'Please Input Lesson Title',
    title_quiz: 'Please Input Quiz Name',

    username: 'Please Input Your Username',
    invalid_verification_code: 'This verification link has expired or is no longer valid. This usually happens if a newer verification email was requested. Please check for the most recent email from Sharelook to verify your email.',
    sharebot_organization: 'Please Input Your Organization',
    upload_error: 'Error - File Not Compatible!',
    upload_more_than_10: 'You can only upload a maximum of 10 files at once.',

    upload_excel: 'Please make sure you have uploaded the correct file.',
    title_excel: 'Error uploading template:',
    file_size_exceed: 'File size exceeds limit.',
    subtitle_excel:
      'Please make sure you use the template provided and the columns are filled out correctly.',
    select_broadcast_option: 'Please select an option to broadcast this event',
    multi_hosts_number_error:
      'Number of presenter cannot exceed that specified for the event.',
    conference_people_number_error: `Number of attendees cannot exceed that specified for the event.`,
    select_max_host: 'Select at least 1 presenter for the event.',
    select_max_conference: 'Select at least 1 attendee for the event.',
    stream_stop_error: 'Trying to reconnect...',
    no_stream_error: 'Waiting for host to start event…',
    unsecure_context:
      'Fatal Error: Browser cannot access camera and mic because of unsecure connection. Please install SSL and access via https.',
    ws_not_supported: 'Fatal Error: WebSocket not supported in this browser.',
    no_org: 'Select at least 1 organization to proceed.',
    no_org_group: 'Select at least 1 organization group to proceed.',
    waiting_to_join: 'Waiting for someone to join!'
  },

  events: {
    title: 'Add Live Event Details',
    change_host: 'Change Host',
    finished: 'The Event Is Finished',
    countdown: 'Live Event Will Be Broadcasting In',
    subtitle:
      'Name your live event and tell your audience what they should expect to learn from it.',
    poll_disabled: 'Poll Is Not Available in This Event',
    disclaimer: `I warrant that my recorded event will not:
    - Infringe on the rights of any third party
    - Contain any illegality, including defamatory, obscene, indecent, lewd, pornographic, violent, abusive, insulting, threatening, or discriminatory content, even disguised with asterisks
    - Contain any personal attacks on other persons
    - Contain any impersonation of other participants, public figures, or celebrities
    - Contain any recording or personal information on any individual without the consent of such individual and is not in breach of any data protection regulation in any part of the world
    - Contain any commercial solicitation or any form of spam'`,
    prompt_message:
      'Leaving this page will end your event. Are you sure you want to leave this page?',
    duration_exceed_message:
      'Your broadcast time has exceeded its limit. The app is going to stop broadcasting.',
    before_schedule_message:
      'You are about to start the broadcast before the scheduled event time. Please note that stopping the broadcast will end the event.',
    browser_unsupportive_message:
      "Your browser doesn't support screen sharing. You can see supported browsers in this link:",
    cancel_switch_host_message:
      'The host is not available. The event will continue from your end.',
    coaching_prompt_message:
      'You cannot leave this page until the event is finished.',
    event_modal_warn: 'Do you want to leave this event?',
    event_end_warn: 'Do you want to end this event?',
    event_breakout_leave: 'Do you want to leave this breakout room?',
    event_breakout_end: 'Do you want to end this breakout room?',
    confirm_message: 'Your event will end if you click OK.',
    screen_share_denied: 'You denied sharing your screen.',
    media_not_found:
      'Camera or mic is not found or not allowed in your device.',
    media_not_access:
      'Camera or mic is being used by some other program that does not allow the devices to be read.',
    constraint_error:
      'There is no device found that fits your video and audio constraints. You may change the video and audio constraints',
    media_access_denied: 'You are not allowed to access camera and mic.'
  },

  filters: {
    days7: 'Last 7 Days',
    days15: 'Last 15 Days',
    days30: 'Last 30 Days',
    days365: 'Last 365 Days',
    date: 'Date Created',
    relevance: 'Relevance',
    popularity: 'Popularity',
    name: 'Name',
    group: 'Group',
    Newest_to_Oldest: 'Newest to Oldest',
    Oldest_to_Newest: 'Oldest to Newest',
    A_Z: 'A to Z',
    Z_A: 'Z to A'
  },

  helpers: {
    password:
      'To ensure the security of your account, we require at least one lowercase and one number in your password. You also need to have a minimum length of 10 characters.',
    phone: 'Please include your phone country code; for example: +65',
    username:
      'Your username is treated as public information and shared with other users as needed. As such, we recommend that you do not use personal information in your username.',
    public_description_normal:
      'Your <0><0/></0> has been saved and is considered private by default. This means that only you can see this content. To publish this content, you can select one of the options below. Publishing your <0><0/></0> to “Public” means that it will be available to all users on the platform. The Specific Users option will enable you to share your <0><0/></0> with specific users using the email address associated with their ShareLook account.',
    public_description_admin:
      'This <0><0/></0> has been saved and is considered private by default. This means that only you (and the content creator) can see this content. To publish this content, you can select one of the options below. Publishing your <0><0/></0> to “Public” means that it will be available to all users on the platform, including those outside of your organization. Publishing it to the organization means that all users within the organization will be able to see it. You can also publish it to 1 or more groups, meaning only the users within those groups will be able to see it. Lastly, you have the option to publish it to specific users within and outside of your organization using their ShareLook account email address.'
  },

  labels: {
    add: 'Add',
    delete_certificate: 'Delete Certificate',
    delete_badge: 'Delete Badge',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',

    answer_type: 'Answer Type',
    answers: 'Answers',
    back_to_quiz: 'Back to Quiz List',
    back_to_question: 'Back to Questions List',
    chat: 'Chat',
    chat_available: 'Chat is not available in this event.',
    chat_report: 'Chat Report',
    choice_single: 'Single Choice',
    choice_multiple: 'Multiple Choice',
    choice_free: '"Free" Choice',
    choice_sorting: '"Sorting" Choice',
    choice_matrix: '"Matrix Sorting" Choice',
    clone_lesson_permission: 'Clone Permission',
    code: 'Code',
    correct: 'Correct',
    created: 'Date Created',
    clone_modal: 'Clone Course',
    cloning_course: 'Cloning Course...',

    cloning: 'Cloning...',
    cloning_course_desc: 'This process will take some time. Please be patient.',
    cloning_success: 'Course "<0/>" has been cloned successfully!',

    description: 'Description',
    disclaimer: 'Disclaimer',
    drop_file: 'Drop file here...',
    duration: 'Duration',
    edit: 'Edit',
    email: 'Email',
    event: 'Event',
    event_all: 'All Events',
    event_date: 'Live Event Local Date/Time',
    event_this: 'This Event',
    expire: 'Expires On',
    expiry_date: 'Expiry Date',
    forgot: 'Forgot password?',
    group: 'Group',
    groups_list: 'List of Groups',
    host: 'Host',
    id_annotation: 'Annotation ID',

    id_quiz: 'Quiz ID',
    incorrect: 'Incorrect',
    interests: 'Interests',
    invited: 'Invited',
    live_chat: 'Live Discussion',
    live_stream_limit: 'Livestreaming Minutes',
    contact_text: 'To change your monthly livestreaming limit, please contact:',
    contact_admin:
      '<0>If you wish to change your monthly livestreaming limit, please contact</0> <1>admin@sharelook.com</1>.',
    limit_stream_text:
      'Livestreaming Minutes Remaining: <0>{{ limit }}</0> minutes <1/><2/> <3>. To change your monthly livestreaming limit, please contact </3> <4>admin@sharelook.com</4>.',
    location: 'Location',
    lessons: 'Lessons',
    location_broadcast: 'Host Server Location',
    location_broadcast_subtitle:
      'Add a location that is closest to the broadcast host’s location to reduce audiovisual delay.',
    media_manager: 'Media Manager',
    minutes: 'Minutes',
    name: 'Name',
    online_quiz: 'Online Quiz',
    organiser: 'Author',
    organization: 'Organization',
    overall_emotion: 'Overall Experience',
    organizations_list: 'List of Organizations',
    password: 'Password',
    participants: 'Participants',

    picture: 'Picture',

    phone: 'Phone',
    photo: 'Photo',
    poll: 'Poll',
    position: 'Position',
    processing: 'Processing',
    privacy_settings: 'Privacy Settings',
    question: 'Question',
    quiz_create: 'Create New Quiz',
    quiz_name: 'Quiz Name',
    quiz_update: 'Update Quiz',
    select_organization: 'Select an Organization',
    settings: 'Settings',
    show: 'Show',
    show_graph: 'Show Graph Result',
    signin: 'Sign In',
    signup: 'Sign Up',
    sort_by: 'Sort By',
    start_date: 'Start Date',
    tags: 'Tags',
    terms: 'I agree to these <1>terms and conditions</1>.',

    title: 'Title',
    topics: 'Topics',
    topic: 'Topic',
    total_comments: 'Total Comments',
    username: 'Username',
    users_list: 'List of Users',
    users_emails: `Choose specific user's email.`,
    description_specifiction_email:
      'Please enter 1 email address per line to share this with multiple specific users.',
    message_specific_email: 'Please enter an email of the specific user.',
    viewers: 'Viewers',
    edit_course: 'Edit',
    edit_assessment: 'Edit',
    edit_event: 'Edit',

    delete_course: 'Delete',
    delete_event: 'Delete',

    delete_assessment: 'Delete',
    view_course: 'View',
    view_event: 'View',
    view_assessment: 'View',

    date_event: 'Live Event Date',
    date_assessment: 'Live Assessment Date',
    clone_of: 'Clone',
    clone_course:
      'Create a clone of this course that you can modify independently of the original, including all lessons and pages.',
    make: 'Make',
    available_to: 'Available to Any ShareLook User',
    uploaded_by: 'Uploaded By: ',
    course: 'Course',
    assessment: 'Assessment',
    user_not_exist: 'User does not exist. Would you like to send an invite?',
    check_user: 'Notice',
    user_not_exist_in_org:
      'User does not exist in this organization. Would you like to send an invite?',
    title_modal_stream: 'Change Organization Livestream Limit',
    des_warning_stream: 'You are about to change.',
    monthly_stream: 'Monthly Livestreaming Limit:',
    min_per_month: 'Minutes/Month',
    broadcast_label: 'I want to do:',
    hosts_emails: `Insert Specific Hosts’ Emails`,
    attendee_emails: `Insert Specific Attendees’ Emails`,
    trainer_assessor_attendee_emails: `Insert Specific Trainer/Assessor Emails`,
    examinee_emails: `Insert Specific Attendees’ Emails`, // to translate s
    description_host_specifiction_email:
      'Please enter 1 email address per line.',
    presenter_label: 'Presenter',
    presenter_label_conference: 'Number of People',
    event_privacy: 'Conference Mode'
  },

  broadcastOptions: {
    stream_from_phone: 'Live Broadcast with My Phone',
    other_webrtc: 'Webinar From My PC',
    multihost: 'Multicast Webinar From My PC',
    peer2peer: 'Coaching Session',
    conference: 'Live Conference'
  },

  //to translate
  conferenceTeamOptions: {
    uptoTen: '1 to 10', // to translate
    uptoTwenty: '11 to 20', // to translate
    uptoTwentyFive: '21 to 25' // to translate
    // uptoForty: '31 to 40'
  },

  //to translate
  conferenceAttendeeOptions: {
    uptoTwoHundredFifty: '1 to 250' // to translate
    // uptoHundred: '51 to 100',
    // uptoTwoHundred: '101 to 200'
    // uptoForty: '31 to 40'
  },

  mediaServices: {
    ANTMEDIA: 'ANTMEDIA', // to translate
    CHIME: 'CHIME' // to translate
  },

  lessoncreate: {
    take_a_tour: 'Take a Tour',
    title: 'Add Lesson Details',
    subtitle:
      'Name your lesson and tell your audience what they should expect to learn from it.',
    input_label_title: 'Lesson Title',
    input_label_topics: 'Lesson Topics',
    input_label_description: 'Lesson Description',
    delete_warning: 'Are you sure you want to delete this page?'
  },

  lessonoverview: {
    title: 'Add Lesson',
    subtitle: 'Add Existing Lesson or Create a New One',
    new_lesson: 'Create a New Lesson',
    new_lesson_sub: 'Create a Brand-New Lesson From Scratch!',
    existing_lesson: 'Select Existing Lesson',
    existing_lesson_sub:
      'Link to an existing lesson. Changes made to this lesson will also affect this lesson in other courses.',
    clone_lesson: 'Duplicate Existing Lesson',
    clone_lesson_sub:
      'Make a unique copy of the lesson in this course. Changes made to this lesson will not affect the original lesson.',
    clone_lesson_modal_sub:
      'Please click the clone button below the lesson that you would like to add to your course.'
  },

  management: {
    groups_title: 'Manage Groups',
    delete_warning: 'Are you sure?',
    organizations_title: 'My Organizations',
    organizations_subtitle: 'Add Organizations to Your List',
    users_title: 'Manage Users',
    users_position: 'Senior Account Manager',
    user_not_found: 'User Not Found',
    select_org: 'Please find and choose an organization to manage users.'
  },

  audio: {
    modal_title: 'Insert Audio',
    list_view: 'List View',
    create_audio_modal_title: 'Create Audio',
    edit_audio_modal_title: 'Edit Audio',
    public_audio_not_found: 'Audio Not Found',
    private_audio_not_found: 'You have not uploaded any audio yet.',
    org_audio_not_found: 'Audio Not Found', // to translate
    are_you_sure_to_delete: 'Are you sure want to delete this?',
    type_something: 'Type something.',
    select_voice: 'Select',
    file_name: 'File Name',
    description: 'Description',
    topic: 'Topic',
    key_words_tag: 'Keywords Tag',
    mp3_audio: 'MP3 Audio',
    created: 'Created',
    duration: 'Duration',
    close: 'Close'
  },

  image: {
    modal_title: 'Insert Image',
    image: 'Image',
    pixel: 'Pixel',
    dimension: 'Dimension',
    public_image_not_found: 'Image Not Found',
    private_image_not_found: 'You have not uploaded any image yet.'
  },

  annotation: {
    modal_title: 'Annotation'
  },

  text: {
    modal_title: 'Text Editor'
  },

  video: {
    modal_title: 'Insert Video',
    image: 'Video',
    mp4_video: 'MP4 Video',
    public_video_not_found: 'Video Not Found',
    private_video_not_found: 'You have not uploaded any video yet.'
  },

  media: {
    title: 'Media Library',
    subtitle: 'Library of Your Files',
    modal_title: 'Upload Media',
    delete_warning: 'Confirm Deletion',
    delete_message:
      'Deleted media will still appear in the pages where they were used.',
    dropzone_text: 'or Drag and Drop',
    delete_success: 'Media has been deleted successfully.',
    upload_file: 'Upload File',
    drag_drop: 'or Drag and Drop',
    import_file: 'Import file(s) from your computer.',
    no_media: 'You have not uploaded any media yet.',
    media_type: 'Media Type',
    video: 'Video',
    image: 'Image',
    audio: 'Audio',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',

    media_not_found: 'Media Not Found',
    of: 'Of',
    disclaimer: `I warrant that my media does not:
    - Infringe on the rights of any third party
    - Contain any illegality, including defamatory, obscene, indecent, lewd, pornographic, violent, abusive, insulting, threatening, or discriminatory content, even disguised with asterisks
    - Contain any personal attacks on other persons
    - Contain any impersonation of other participants, public figures, or celebrities
    - Contain any personal information on any individual without the consent of such individual and is not in breach of any data protection regulation in any part of the world
    - Contain any commercial solicitation or any form of spam`,

    // added_first
    my_media: 'My Media', // to translate

    public_library: 'Public Library', // to translate
    organization_library: 'SOP Documents', // to translate
    upload_from_computer: 'Upload From Computer', // to translate

    create: 'Create', // to translate
    all: 'All', // to translate
    male: 'Male', // to translate
    female: 'Female', // to translate
    processing_audio: 'Processing Audio', // to translate
    create_annotation: 'Create Annotation', // to translate
    popup_over_lesson_text:
      'The annotation will pop up over the lesson page once clicked.', // to translate
    edit_detail: 'Edit Detail', // to translate
    delete: 'Delete', // to translate
    go_create_audio: 'Go Create Audio', // to translate
    show_more_details: 'Show More Details', // to translate
    show_less_details: 'Show Less Details', // to translate
    drop_files: 'Drop files and select where to upload.', // to translate
    or: 'Or', // to translate
    import_files: 'Import files from computer.' // to translate
  },

  navigation: {
    account: 'Account',
    assessments: 'Assessments',
    dashboard: 'Dashboard',
    groups: 'Group Management',
    logout: 'Log out',
    organisations: 'Organizations',
    organizations_users: 'Organizations & Users',
    reports: 'Reports',
    schedule: 'Schedule',
    training: 'Training',
    users: 'Users',

    // added_first
    nowLive: 'Live',

    workshop: 'My Workshop'
  },

  onboarding: {
    step1_title: 'Step 1: Tell Us a Little About Yourself',
    step1_subtitle:
      'What is your name? Where are you from? What is your job title?',
    step2_title: 'Step 2: Select Some Skill You Could Improve In',
    step2_subtitle:
      'Next, tell us what you would like to understand better. Perhaps something you have yet to pick up? A new field of study? What your loved one does?'
  },

  pagebuilder: {
    title: 'Create Lesson',
    subtitle:
      'Time to create content for your audience to learn from you. You can include pictures, videos, and infographics.',
    select_layout: 'Select a Page Layout',
    template1: 'Blank',
    template2: 'Title & Subtitle',
    template3: 'Title & Text',
    template4: 'Title, Media, & Text',
    template5: 'Title & Media',
    template6: 'Title & Quiz'
  },

  pageconstructor: {
    title: 'Create and Clone Lesson',
    subtitle:
      'Time to create content for your audience to learn from you. You can add pictures, videos, and infographics.'
  },

  passwordreset: {
    success_coded:
      'We have emailed a confirmation code to the address you provided. Please copy the code into the field below to set a new password.',
    success_changed:
      'You have successfully set a new password. You can sign in now.'
  },

  placeholders: {
    search: 'Search',
    answer: 'Answer',
    chat: 'Say something...',
    code: 'Code',
    criterion: 'Criterion',
    date_event: 'Select Date and Time',
    date_start: 'Start Date',
    date_expire: 'Expiry Date',
    description: 'Description',
    elements: 'Sort Elements',
    email: 'Email',
    feedback_correct: 'Feedback Correct',
    feedback_incorrect: 'Feedback Incorrect',
    host: 'Host',
    keywords: 'Search Keyword(s)',
    lesson_description: 'Lesson Description',
    location: 'Location',
    minutes: 'Minutes',
    name: 'Name',
    organiser: 'Author',
    organization: 'Organization',
    password: 'Password',
    phone: 'Phone',
    photo: 'Photo',
    picture: 'Picture',
    point: 'Points',
    position: 'Position',
    question: 'Question',
    quiz: 'Quiz Name',
    search_course: 'Search by Course',
    search_media: 'Search Media',
    search_name: 'Search by Name',
    search_title: 'Search by Title',
    search_training: 'Search Training',
    settings: 'Settings',
    tags: 'Tags',
    title: 'Title',
    topics: 'Topics',
    username: 'Username',
    keyword: 'Keywords',
    max_500_characters: 'Maximum 500 Characters',
    no_description: 'This file does not have a description.',
    no_keyword: 'This file does not have any keywords.',
    no_topics: 'This file does not have a topic set.',
    feedback: 'Message',
    contact: 'How can we help?'
  },

  publishsettings: {
    title: 'Publish Settings',
    event_subtitle:
      'Add settings to your event and select who can view and interact with your event.',
    assessment_subtitile:
      'Name your assessment and tell your audience what they should expect to learn from it.',
    course_subtitle:
      'Add settings to your course and select who can view and interact with your course.',
    disclaimer:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis',
    dates_validation_error: 'Both dates should be filled out.',
    course_dates_validation_error: 'Please enter start and expiry date for this course.',
    emails_validation_error: 'Email list is invalid.',
    specific_email_validation_error: 'Only one email is allowed.',
    i_agree_to_these: 'I agree to these',
    terms_and_conditions: 'terms and conditions.',
    PublicDescription:
      'Free independent users: (private and public options) Your [Course|Event|Assessment] has been saved and is considered private by default. This means that only you can see this content. To publish this content, you can select to make it public below. This means that the course will be available to all users on the platform.',
    OrganisationsDescription:
      'Organization users: (Instead of "Finish" use "Publish" and bring them to the publish page just as other users but without any of the publish options.) Your [Course|Event|Assessment] has been saved and is private. This means that only you and the administrators in your organization can see it. As a user, you are not able to publish your content within your organization yourself, as this requires administrator rights. Please contact one of your administrators and ask them to publish your content publicly to the entire organization, to specific groups within your organization, or to specific users.',
    OrganisationGroupsDescription:
      'Organization Admins: (For content made within the organization: Private, public, organization, groups, specific users): This [Course|Event|Assessment] has been saved and is considered private by default. This means that only you (and the content creator) can see this content. To publish this content, you can select one of the options below. Publishing your course to “Public” means that it will be available to all users on the platform, including those outside of your organization. Publishing it to the organization means that all users within the organization will be able to see it. You can also publish it to 1 or more groups, meaning that only the users within those groups will be able to see it. Lastly, you have the option to publish it to specific users within and outside of your organization using their ShareLook account email address.',
    SpecificUsersDescription:
      'Paid Independent users: (private, public, and specific users) Your [Course|Event|Assessment] has been saved and is considered private by default. This means that only you can see this content. To publish this content, you can select one of the options below. Publishing your course to “Public” means that it will be available to all users on the platform. The Specific Users option will enable you to share your course with specific users using the email address associated with their ShareLook account.'
  },

  quiz: {
    quiz_empty: 'You have not yet created a quiz.',
    questions_empty: 'You have not yet created a question.'
  },

  regions: {
    asia_pacific_australia: 'Australia',
    asia_pacific_india: 'India',
    asia_pacific_japan: 'Japan',
    asia_pacific_s_korea: 'South Korea',
    asia_pacific_singapore: 'Singapore',
    asia_pacific_taiwan: 'Taiwan',
    eu_belgium: 'Belgium',
    eu_germany: 'Germany',
    eu_ireland: 'Ireland',
    south_america_brazil: 'Brazil',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'South Carolina',
    us_east_virginia: 'Virginia',
    us_west_california: 'California',
    us_west_oregon: 'Oregon'
  },

  // still left translate

  publishmaze: {
    title: 'Publish Settings', // to translate
    maze_subtitle:
      'Add settings to your maze and select who can view and interact with your maze.', // to translate
    disclaimer: `I warrant that my maze will not:
     - Infringe on the rights of any third party
     - Contain any illegality, including defamatory, obscene, indecent, lewd, pornographic, violent, abusive, insulting, threatening, or discriminatory content, even disguised with asterisks
     - Contain any personal attacks on other persons
     - Contain any impersonation of other participants, public figures, or celebrities
     - Contain any recording or personal information on any individual without the consent of such individual and is not in breach of any data protection regulation in any part of the world
     - Contain any commercial solicitation or any form of spam'` // to translate
  },

  reports: {
    title: 'Reports',
    // added_first
    workshop_report: 'Workshop Report',
    user_report: 'User Report',
    organization_workshop: 'Organization Workshop',
    course: 'Course',
    live_event: 'Live Event',
    workShop_graph: 'Workshop Graph',
    organization_account: 'Organization Account',
    all: 'All',
    name: 'Name',
    id_number: 'ID Number',
    email: 'Email',
    search_user_report: 'Search User Report',
    participant: 'Participant',
    participants: 'Participants',
    buyers: 'Buyers',
    coaching: 'Coaching',
    assessors_trainers: 'Assessors/Trainers',
    assesse_trainee: 'Assesse/Trainee',
    host: 'Host',

    username: 'Username',
    event: 'Event',
    quiz: 'Quiz',
    assessment: 'Assessment',
    time: 'Time',
    no_recent_activity: 'No Recent Activity',
    workshops: 'Workshops',
    courses: 'Courses',
    live_events: 'Live Events',
    live_assessments: 'Live Assessments',
    quizzes: 'Quizzes',
    overview: 'Overview',
    product: 'Product',
    by: 'By',
    views: 'Views',
    status: 'Status',

    poll: 'Poll',
    comment: 'Comment',
    comments: 'Comments',
    no_comments: 'No Comments',
    no_polls: 'No Polls',
    live_date: 'Live Date',
    score: 'Score',
    question: 'Question',
    submit: 'Submit',
    recent_activity: 'Recent activity',
    ago: 'Ago',
    no_data_found: 'No Data Found',
    start_end_live: 'Start/End live',
    join_leave_date: 'Join/Leave',
    watched_time: 'Watched Time',
    complete: 'Complete',
    in_complete: 'Incomplete',
    today: 'Today',
    seven_days: '7 Days',
    last_month: 'Last Month',
    one_year: '1 Year',
    all_time: 'All Time',
    report: 'Report',
    from_date: 'From Date',
    to_date: 'To Date',
    all_workshop: 'All Workshops',
    all_marketplace: 'All marketplace',
    all_participants: 'All Participants',
    live_assessment: 'Live Assessment',
    users: 'Users',
    user: 'User',
    download: 'Download',
    recent: 'Recent',
    WorkShop: 'Workshop',
    Activity: 'Activity',
    created_date: 'Created Date',
    purchased_date: 'Purchased Date',
    ai_credit_usage_report: 'AI Credit Usage Report',
    total_credits: 'Total Credits',
    used_credits: 'Used Credits',
    remaining_credits: 'Remaining Credits',
    used: 'Used',
    remaining: 'Remaining',
    total: 'Total',
    credits: 'Credits',
    usage_by_feature: 'Usage by Feature',
    usage_timeline: 'Usage Timeline',
    daily_usage: 'Daily Usage',
    credit_usage_progress: 'Credit Usage Progress',
    credit_usage: 'Credit Usage',
    chat: 'Chat',
    generation: 'Generation',
    analysis: 'Analysis',
    other: 'Other',
    no_credit_usage_data: 'No credit usage data available',
    error_loading_data: 'Error Loading Data',
    something_went_wrong: 'Something went wrong. Please try again.',
    no_data_available: 'No data available',
    lessons: 'Lessons',
    lesson: 'Lesson',
    completed: 'Completed',
    report_download: 'DOWNLOAD',
    this_month: 'This Month',
    search_course: 'Search Course',
    // search_skill_journey: "Search Skill journey", // to translate

    participants_graph: 'Participants Graph',
    viewed: 'Viewed',
    enrolled: 'Enrolled',
    description: 'Description',
    topic: 'Topic',
    analytic: 'Analytic',
    quiz_list: 'Quiz List',
    select_one: 'Select One',
    group_status: 'Group Status',
    duration_min: 'Duration (minutes)',
    submit_poll: 'Submit Poll',
    download_events: 'Download Events',
    search_event: 'Search Event',
    duration: 'Duration',
    total_participants: 'Total Participants',
    message: 'Message',
    avg_message: 'Average Message',
    per_message: 'A PERCENTAGE OF MESSAGES/EVENTS'
  },

  signup: {
    success_step1:
      'We have emailed a verification code to the address you provided. Please copy the code into the field below to confirm your registration.',
    success_step2: 'Thanks. You are successfully registered!',
    privacy: `I agree to ShareLook's <1> terms & conditions</1> and <3> privacy policy</3>.`
  },

  stream: {
    emotion_impressive: 'Impressive',
    emotion_unimpressive: 'Unimpressive',
    message_not_started: 'Coming Soon',
    message_running: 'Live',
    message_processing:
      'We are currently processing the live recording for playback. Please check back later to view the video and to continue adding ratings and feedback.'
  },

  tabs: {
    audience: 'Audience',
    course: 'Course Overview',
    details: 'Live Event Details',
    description: 'Description',
    host: 'Host',
    lesson: 'Lesson Overview',
    lessons: 'Lessons',
    overview: 'Overview',
    page: 'Page Builder',
    publish: 'Publish',
    settings: 'Publish Setting',
    total_views: 'Total Views',
    live_participates: 'Live Participants',
    live_chats: 'Live Chats',
    live_quiz: 'Live Polls',
    trainer_rating: 'Trainer Rating',
    trainer_times: 'Trainer Times',
    courses_quizzes: 'Courses Quizzes',
    user_list: 'User List',
    discussion: 'Discussion',
    notes: 'My Notes'
  },

  topics: {
    SALES_TRAINING: 'Sales Training',
    NEGOTIATION_TRAINING: 'Negotiation Training',
    CROSS_CULTURAL_AWARENESS: 'Cross-Cultural Awareness',
    NETWORKING_SKILLS: 'Networking Skills',
    SOFTWARE_ARCHITECTURE: 'Software Architecture',
    PROJECT_MANAGEMENT: 'Project Management',
    DIGITAL_TRANSFORMATION: 'Digital Transformation',
    IT_CONSULTING: 'IT Consulting',
    MANAGEMENT_CONSULTING: 'Management Consulting',
    HR_CONSULTING: 'HR Consulting',
    INTERNET_OF_THINGS: 'Internet of Things (IoT)',
    CYBERSECURITY: 'Cybersecurity',
    PRIVACY_AND_GDRP: 'Privacy and GDPR'
  },

  training: {
    title: 'Training',
    title_assessment: 'Assessments',
    subtitle: 'Courses and Live Events',
    enrolled_title: 'Enrolled Courses and Live Events',

    enrolled_subtitle: 'Courses and Live Events You Enrolled In',
    enrolled_message:
      'You are currently not enrolled in any courses or events.',

    past_live_event_title: 'Past Live Events',
    past_live_event_subTitle: 'Finished Live Events',
    past_live_event: 'There are currently no past live events.',
    recomended_title: 'Recommended Courses and Live Events',
    now_live_event_title: 'Now Live',
    now_live_event_subTitle: 'Events that Are Live or Will Be Very Soon',
    now_live_event: 'There is currently no live event.',

    webinar_event_title: 'Webinar Channel',
    webinar_event_subTitle: 'Finished Webinars',
    webinar_event: 'There are currently no webinars.',
    p2p_event_title: 'Coaching Sessions',
    p2p_event_subTitle: 'Finished Coaching Session',
    p2p_event: 'There are currently no coaching sessions.',

    now_live_assessment_title: 'Now Live',
    now_live_assessment_subTitle:
      'Assessments That Are Live or Will Be Very Soon',
    now_live_assessment_message: 'There is currently no live assessment.',

    upcoming_assessment_title: 'Upcoming Live Assessments',
    upcoming_assessment_subtitle: 'Upcoming Live Assessments',
    upcoming_assessment_message:
      'There is currently no upcoming live assessment.',

    past_live_assessment_title: 'Past Live Assessments',
    past_live_assessment_subTitle: 'Finished Live Assessments',
    past_live_assessment_message:
      'There are currently no past live assessments.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'We have curated courses and live events based on your <0><0/></0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Search Training',
    search_assessment: 'Search Assessment',
    recomended_message: 'There are currently no recommended courses or events.'
  },

  warnings: {
    delete: 'Are you sure?'
  },

  workshop: {
    title: 'My Workshop',
    subtitle: 'Create a Course or Host a Live Event of Your Own',
    new_course: 'Create a New Course',
    new_event: 'Create a New Live Event',
    new_assessment: 'Create a New Live Assessment',
    courses_title: 'Created Courses and Live Events',
    courses_subtitle:
      'Edit and Publish Your Created Course and Plan Live Events',
    tags_course: 'Course',
    tags_live: 'Live Event',
    tags_assessment: 'Live Assessment'
  },

  help_center: {
    sidebar: {
      title: 'How can we help you?',
      back_to: 'Dashboard'
    },
    menu: {
      help_center: 'Help Center',
      whats_new: "What's new",
      feedback: 'Feedback',
      feedback_title: 'Send Feedback to ShareLook',
      terms_and_conditions: 'Terms & Conditions',
      privacy_policy: 'Privacy Policy',
      contact_us: 'Contact Us'
    },
    get_started: {
      title: 'Get Started with ShareLook',
      new_title: 'User Guide', // to translate
      description: {
        main: 'WE’VE INTEGRATED LIVE VIDEO INTO AN EASY-TO-USE COURSE BUILDER',
        tagline:
          'With ShareLook’s patented live broadcast system, you can create engagement, automate learning, and maximize knowledge-sharing.'
      }
    },
    whats_new: {
      title: 'Get Started with ShareLook',
      description: {
        main:
          'Did you know that creating a storytelling-style learning experience is easy to do in a short time and inexpensive? You should combine the ShareLook course builder with your respective talents. Ask us how.',
        tagline: ''
      }
    },
    create_workshop: 'How to Create a Workshop',
    create_course: 'How to Create a Course',
    create_user: 'How to Create a User',
    create_group: 'How to Create a Group',
    create_webinar: 'How to Create a Webinar',
    create_live_event: 'How to Create a Live Event',
    create_live_assessment: 'How to Create a Live Assessment',
    create_live_on_mobile: 'Create Live on Mobile',
    personalize_profile: 'Personalize a Profile',
    manage_group: 'Manage Group',
    report: 'Report',
    add_annotations: 'How to Add Annotations/Popups',
    add_audio: 'How to Add Audio',
    add_header_and_footer: 'Adding Header and Footer',
    add_image: 'How to Add Image',
    add_quiz_content: 'How to Add Quiz Content',
    add_text_content: 'How to Add Text Content',
    add_user: 'How to Add User',
    add_video: 'How to Add Video',
    clone_course: 'How to Clone Course',
    find_live_broadcast: 'How to Find Live Broadcast',
    transcribe_and_translate_live_broadcast:
      'Translate/Transcribe Live Broadcast', // to translate
    transcribe_and_translate_your_live_broadcast:
      'How to Transcribe and Translate Your Live Broadcast', // to translate
    contact_us: {
      title: 'Contact Us',
      subject_placeholder: 'Enter a Subject*',
      content_placeholder: 'Enter a Message*',
      subject_required: '*Subject Is Required',
      content_required: '*Message Is Required',
      submit: 'Send',
      cancel: 'Cancel',
      sent: 'Sent'
    },
    feedback: {
      title: 'Send Feedback to ShareLook',
      attach_title: 'Attach a File',
      choose: 'Choose File',
      detail: 'File Will Be Shared with the Support Team',
      content_placeholder: 'Enter a Message*',
      content_required: '*Message Is Required',
      submit: 'Send',
      cancel: 'Cancel',
      sent: 'Sent'
    }
  },
  discussion: {
    join_discussion: 'Join Discussion'
  },
  notes: {
    title: 'My Notes',
    add_note: 'Add New Note'
  }
}
